import {
  AfterViewChecked,
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  DebugElement,
  ElementRef,
  EventEmitter,
  HostListener,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as L from "leaflet";
import { CommonService } from "../../services/commen/commen.services";
import { DatePipe } from "@angular/common";
import { Http } from "@angular/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { appService } from "../../../_services/app.service";
import { DecryptPipe } from "../../../auth/_services/encrypt-decrypt.pipe";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { OrdersService } from "../../services/orders/orders.service";
import { Helpers } from "../../../helpers";
import { IDetails } from "../details-card/model/IDetails";
import 'leaflet-routing-machine';
import { environment } from "../../../../environments/environment";
import { DetailsCardComponent } from "../details-card/details-card.component";
declare var google: any;

// delete (L.Icon.Default.prototype as any)._getIconUrl;

// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: 'assets/img/leaflet/images/marker-icon-2x.png',
//   iconUrl: 'assets/img/leaflet/images/marker-icon.png',
//   shadowUrl: 'assets/img/leaflet/images/marker-shadow.png',
// });

@Component({
  selector: "app-map-details-card",
  templateUrl: "./map-details-card.component.html",
  styleUrls: ["./map-details-card.component.scss"],
})
export class MapDetailsCardComponent implements AfterViewInit, OnChanges, AfterViewChecked {
  // private map: L.Map;
  // private map: L.Map;
  map: any;
  @ViewChild('mapContainer') mapContainerRef: ElementRef;
  private mapLeaflet: L.Map | null = null;
  @ViewChild('WayPointMap') mapContainerRefWayPoint: ElementRef;
  private mapWayPoint: L.Map | null = null;
  @ViewChild('WayPointMapTwo') mapContainerRefWayPointTwo: ElementRef;
  private mapWayPointTwo: L.Map | null = null;
  @ViewChild('LiveTrackingMap') mapContainerLiveTracking: ElementRef;
  private mapLiveTracking: L.Map | null = null;
  beachMarker: any;
  @Input() PickUpLatitude: any;
  @Input() PickUpLongtitude: any;
  @Input() DeliverLatitude: any;
  @Input() DeliverLongtitude: any;
  @Input() Origin: any;
  @Input() Destination: any;
  @Input() data: any;
  @Input() addressData: any;
  svg: any;
  static that: MapDetailsCardComponent;
  Distance: any;
  TraavelTime: any;
  @Output() OnCatchData = new EventEmitter<any>();
  isGPS: boolean = false;
  @Input() BookingId: any;
  @Input() ConsignmentDetailId: any;
  liveTrackData: any = { orderDetailsList: [{ starRating: "" }] };
  VehicleDirectionDegree: any = 0;
  position: any = [40.748774, -73.985763];
  numDeltas: any = 60000;
  delay: any = 600; //milliseconds
  i: any = 0;
  deltaLat: any;
  deltaLng: any;
  GPSUrl: any;
  selectedDriverId: any;
  fullAddress: any
  currentUrl: any;
  isShowMap: boolean = false
  @Output() isShowMapChange = new EventEmitter<boolean>();
  IsMapShow: boolean;
  WayPointsres: any = [];
  LiveTrackingThrowWarehouseLatLongFlage: any = false;
  TripRouteBaseOnDeliveryDateFlag: any = false;
  OrderDestinationLocation: any = [];
  OrderInfoLatLong: any = [{ origin: 'jamnagar', destination: 'jamnagar' }];
  @Input() IsWayPointsMap: boolean = false;
  @Input() WayPoints: any = [];
  @Input() CFSYARDLocationLatitude: any;
  @Input() CFSYARDLocationLongtitude: any;
  @Input() CFSYARDAddress: any;
  @Input() FTLType: any;
  @Input() IsWayPointsMapTwo: boolean = false;
  mapPickup: any;
  originIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/OriginLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  destinationIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/DestinationLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  });
  cfsIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/CfsLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  waypointIcon = L.icon({
    iconUrl: 'assets/img/truck_inactive.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16]
  });
  @Input() TabName: any;
  private cfsMarker: L.Marker;
  cfsCircle: any;
  private mapLayerGroupWayPointTwo: L.LayerGroup = L.layerGroup();
  private mapLayerGroup: L.LayerGroup = L.layerGroup();
  private originMarker: L.Marker;
  private destMarker: L.Marker;
  private routingControl: any;
  originCircle: any;
  destCircle: any;
  private wayPointLayerGroup: L.LayerGroup = L.layerGroup();
  @Input() IsLiveTracking: boolean = false;
  @Input() LiveTrackLatitude: any;
  @Input() LiveTrackLongtitude: any;
  private mapLayerGroupLiveTracking: L.LayerGroup = L.layerGroup();
  svgImg: any = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';
  svgIcon = L.divIcon({
    className: '',  // remove default class styles
    html: this.svgImg,      // this is your full SVG string
    iconSize: [42, 42],         // size of the div container
    iconAnchor: [21, 21],       // center the icon
    popupAnchor: [0, -21]       // adjust popup position if needed
  });
  @Input() PrevLiveTrackLatitude: any;
  @Input() PrevLiveTrackLongtitude: any;
  hostUrl: any = environment.apiUrl;
  @Input() DriverMobileNo: any;
  mockCoordinatesIndex = 0;
  mockCoordinates = [
  ];
  @Input() VehicleNo: any;
  @Input() Driver: any;
  @ViewChild('SelfFullfieldMap') mapContainerSelfFullfilled: ElementRef;
  private mapSelfFullfilled: L.Map | null = null;
  @Input() IsSelfFullfilledMap: boolean = false;
  @Input() TransactionType: any = '';
  @Input() IsViewPageMap: boolean = false;
  @ViewChild('ViewPageMap') mapContainerViewPage: ElementRef;
  private mapViewPage: L.Map | null = null;
  @Input() OrderList: any = [];
  originLocIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/OriginLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  destinationLocIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/DestinationLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  cfsLocIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/CfsLocationPin.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  orderDetails: any = {
    cardName: "",
    id: "FTL",
    listOfRow: [
      [
        { dataField: 'OrderNo', dataField1: 'OrderDate', color: 'var(--colors-primary-blue-blue-200, #3367FB)', Id: 'Id' },
        // { dataField2: '' },
        { dataField: 'OrderStatus', valueType: 'IsStatus', isMenu: true, isShowTimer: true },
      ],
      [{
        label1: 'Customer', dataField: 'Customer', dataField1: 'CustomerPincode',
        valueType: 'isCustomerRedirect',
        CustomerId: 'CustomerId'
      }],
      [
        { deliveryTime: 'deliveryTime', dataField10: 'PCity', dataField11: 'DCity', isLocationFTL: true, },
        // { label1: 'Origin', dataField10: 'PCity', isOriginForCard: true, },
        // { dataField: 'deliveryTime' },
        // { label1: 'Destination', dataField11: 'DCity', isDestinationForCard: true }
      ],
      // [
      //   {
      //     dataField11: 'PCity', isDetailsFTL: true
      //   },
      //   {},
      //   {
      //     dataField11: 'DCity', isDetailsFTL: true
      //   },
      // ],
      // [
      //   { isHrLine: true }
      // ],
      [
        { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg' },
        // { dataField: '', },
        { dataField: 'Package', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/shipnow.svg' }
      ],
    ],
    footer: {
      actionBtn: false,
      actionList: [
        // { label: 'View', },
        {
          label: 'Edit', //icon: 'pi pi-fw pi-plus', 
          command: (event?: any) => console.log(event),
          visible: this.commonService.CheckHasRight('EDIT', 'FTL_DETAILS')
        },
        {
          label: 'Ship Now', //icon: 'pi pi-fw pi-truck',
          visible: this.commonService.CheckHasRight('SHIPNOW', 'FTL_DETAILS')
        },
        {
          label: 'Attachments', //icon: 'pi pi-fw pi-paperclip',
          visible: this.commonService.CheckHasRight('ATTACHMENTS', 'FTL_DETAILS')
        },
        {
          label: 'Delete',
          // icon: 'pi pi-fw pi-trash',
          visible: this.commonService.CheckHasRight('DELETE', 'FTL_DETAILS')
        }
      ],
    },
    isHideFooter: true
  };
  IdleIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/IdleTruck.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  DriverIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/Driver.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  RepairIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/RepairTruck.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  InTransitIcon = L.icon({
    iconUrl: 'assets/img/leaflet/images/IntransitTruck.svg',
    iconSize: [24, 24],
    iconAnchor: [12, 12],       // Center of circle
    popupAnchor: [0, -12]       // Popup shows above center
  });
  @Input() selectedId: any = '';
  VehicleList: any = [];
  CompanyId: any;
  vehicleDetailsIdle: any = {
    cardName: "",
    id: "Idle",
    listOfRow: [
      [
        { dataField: 'VehicleNo', dataField1: 'LastTrackDate', color: 'var(--colors-primary-blue-blue-200, #3367FB)', Id: 'Id' },
        // { dataField2: '' },
        { dataField: 'VehicleStatus', valueType: 'IsStatus', isMenu: false, isShowTimer: false },
      ],
      [
        { label: 'Transporter', dataField: 'Transporter', valueType: 'isCustomerRedirect', CustomerId: 'TransporterId' },
        { label: 'Driver', dataField: 'Driver', valueType: 'isDriverRedirect', DriverId: 'DriverId' }
      ],
      [
        { isHrLine: true }
      ],
    ],
    footer: {
      actionBtn: false,
      actionList: [],
    },
    isHideFooter: true
  };
  OwnerShipType: any = [];
  Locations: any = [];
  @Input() SelectedOrderInfo: any = {};
  @Input() IsViewSingleMap: boolean = false;
  @Input() BookingVehicles: any = [];
  @Input() LocationFilter: boolean = false;
  @Input() IsDriveMapView: boolean = false;
  // driverDetails: any = {
  //   cardName: "",
  //   id: "Driver",
  //   listOfRow: [
  //     [
  //       { dataField: 'FullName', dataField1: 'LastTrackDate', color: 'var(--colors-primary-blue-blue-200, #3367FB)', Id: 'Id' },
  //       { dataField2: '' },
  //       { dataField: 'VehicleStatus', valueType: 'IsStatus', isMenu: false, isShowTimer: false },
  //     ],
  //     [
  //       { label: 'Transporter', dataField: 'Transporter', valueType: 'isCustomerRedirect', CustomerId: 'TransporterId' },
  //       { label: 'Driver', dataField: 'Driver', valueType: 'isDriverRedirect', DriverId: 'DriverId' }
  //     ],
  //     [
  //       { isHrLine: true }
  //     ],
  //   ],
  //   footer: {
  //     actionBtn: false,
  //     actionList: [],
  //   },
  //   isHideFooter: true
  // };
  @Input() SelectedInfo: any = {};
  // Added by priya - 15/01/2026 - CN(PRIYA-JAN26-010)
  @Input() ShowMapFilter: boolean = true;
  @Input() HideVehicleSvg: boolean = false;
  @Input() IsTollMapView: boolean = false;
  TollDetails: any = {
    cardName: "Toll Plaza",
    id: "TollPlazaDetails",
    listOfRow: [
      [{
        dataField: 'PlazaCode', dataField1: 'PlazaName', dataField2: '', color: 'var(--colors-primary-blue-blue-200, #3367FB)', Id: 'Id', IsTollCard: true, isBoldText: true
      }],
      [
        { label: 'State', dataField: 'StateName', dataField2: '' },
        { label: 'City', dataField: 'CityName', dataField1: '' },
      ],
      [
        { label: 'GeoCode', dataField: 'GeoCode', dataField2: '' },
      ],
    ],
    footer: {
      actionBtn: false,
      actionList: [
        { label: 'Edit', icon: 'pi pi-fw pi-plus', },
        { label: 'View', icon: 'pi pi-fw pi-eye' },
        { label: 'Delete', icon: 'pi pi-fw pi-trash' },
      ],
    },
    isHideFooter: true,
  };
  // 🔥 Toll map helpers
  private tollMarkerById = new Map<number, L.Marker>();
  private isTollMapInitialized = false;
  private isTollMarkerFocused = false;

  constructor(
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private anghttp: Http,
    private commonService: CommonService,
    private decryptpipe: DecryptPipe,
    private service: TranslateConfigService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe,
    private _activatedRoute: ActivatedRoute,
    private appRef: ApplicationRef,
    private injector: Injector,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef
  ) {
    MapDetailsCardComponent.that = this;

    // setTimeout(() => {
    //   if (this.BookingId != null && this.BookingId != "") {
    //     setInterval(function () {
    //       if (MapDetailsCardComponent.that.isGPS == false) {
    //         MapDetailsCardComponent.that.getDriverCurrentLatLong();
    //       }
    //     }, 5000);

    //     setInterval(function () {
    //       if (MapDetailsCardComponent.that.isGPS == true) {
    //         MapDetailsCardComponent.that.getDriverCurrentLatLong_GPS();
    //       }
    //     }, 5000);
    //   }
    // }, 2500);
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.svg =
      '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' +
      this.VehicleDirectionDegree +
      ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

    this.selectedDriverId = this.route.snapshot.params['id'] ? this.route.snapshot.params['id'] : this.selectedDriverId;
    this.currentUrl = this.router.url;
    // if (this.currentUrl.includes('so_Orders')) {
    //   this.getSOAddresstoPlot()
    // }
    // if (this.currentUrl.includes('NewDriver/view')) {
    //   this.getFullAddress()
    // }
    // this.LoadLiveTrackingThrowWarehouseLatLong();
    // this.LoadTripRouteBaseOnDeliveryDate();

    // setTimeout(() => {

    //   if (
    //     this.PickUpLatitude == null ||
    //     this.PickUpLatitude == undefined ||
    //     this.PickUpLongtitude == null ||
    //     this.PickUpLongtitude == undefined
    //   )
    //     this.getLatLng(this.Origin, "Origin");

    //   if (
    //     this.DeliverLatitude == null ||
    //     this.DeliverLatitude == undefined ||
    //     this.DeliverLongtitude == null ||
    //     this.DeliverLongtitude == undefined
    //   )
    //     this.getLatLng(this.Destination, "Destination");

    //   setTimeout(() => {
    //     if (this.BookingId != null && this.BookingId != "") {
    //       this.GetLiveTrackListForBooking();
    //     } else {
    //       this.initializeMap();
    //     }
    //   }, 500);

    // }, 2500); // Adjust delay as needed
    const showMap = localStorage.getItem('showMap');
    if (showMap) {
      this.IsMapShow = true;
    } else {
      this.IsMapShow = false
    }
    this.getMapRadius();
    this.GetOwnerShipType();

    this._activatedRoute.params.subscribe((params: Params) => {
      let intervalTime;
      if (MapDetailsCardComponent.that.hostUrl === 'https://sawariya.ifreightbox.net/') {
        this.BookingId = this._activatedRoute.snapshot.queryParams['BookingId'];
        this.DriverMobileNo = this._activatedRoute.snapshot.queryParams['DriverMobile']
        intervalTime = 5000;
        setInterval(() => {
          if (this.BookingId && this.DriverMobileNo) {
            MapDetailsCardComponent.that.GetTrackingDataContinusSawariya(this.BookingId, this.DriverMobileNo);
          }
        }, intervalTime);
      }

    });
    this.Locations.push({ Id: 1, Label: 'Origin' });
    this.Locations.push({ Id: 2, Label: 'Destination' });

    var obj: any = {};
    obj.Id = null;
    obj.Label = 'Both';
    this.selectedLocations.push(obj);
  }

  GetOwnerShipType() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "OwnerShipType")
      .subscribe(
        (response) => {
          this.OwnerShipType = response;

          var obj: any = {};
          obj.Id = null;
          obj.Label = 'All';
          this.selectedOwnerships.push(obj);
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Ownership data !",
            "error"
          );
        }
      );
  }

  //added by vithu 03-07-2025
  UseLeafletMap: boolean = false;
  UseLeafletMapInitialized: boolean = false;
  LoadUseLeafletMap() {
    this._appService.GetById("Common", "GetSystemSettingByName", "UseLeafletMap").subscribe((response) => {
      this.UseLeafletMapInitialized = true;
      if (response == '1') {
        this.UseLeafletMap = true;
      } else {
        this.UseLeafletMap = false;
      }
    },
      (err) => {
        this.UseLeafletMapInitialized = false;
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  LastTrackDate: any;
  @Input() TrackThrough: any;
  GetTrackingDataContinusSawariya(BookingId, DriverMobileNo) {
    this._appService
      .GetByTwoId("OrdersByVehicle", "GetTrackingDataSawariya", BookingId, DriverMobileNo)
      .subscribe(
        (response) => {
          this.PrevLiveTrackLatitude = parseFloat(this.LiveTrackLatitude);
          this.PrevLiveTrackLongtitude = parseFloat(this.LiveTrackLongtitude);
          this.LiveTrackLatitude = parseFloat(response[0].latitude);
          this.LiveTrackLongtitude = parseFloat(response[0].longitude);
          this.LastTrackDate = response[0].CreatedDate;
          this.VehicleNo = response[0].VehicleNo;
          this.Driver = response[0].Driver;

          if (!this.UseLeafletMap) {
            this.showLiveTrackVehicle();
          } else {
            this.showLiveTrackVehicleLeaflet();
          }
        },
        (err) => {

        }
      );
  }


  ngOnDestroy() {
    if (this.mapLeaflet) {
      this.mapLeaflet.remove();
      this.mapLeaflet = null;
    }

    if (this.mapWayPoint) {
      this.mapWayPoint.remove();
      this.mapWayPoint = null;
    }

    if (this.mapWayPointTwo) {
      this.mapWayPointTwo.remove();
      this.mapWayPointTwo = null;
    }
  }

  ngAfterViewInit(): void {
    this.LoadUseLeafletMap();

    // setTimeout(() => {
    //   if (this.UseLeafletMap) {
    //     if (this.mapContainerRefWayPoint && !this.mapWayPoint && this.IsWayPointsMap) {
    //       this.initializeLeafletMapWayPoint();
    //     } else if (this.mapContainerRefWayPointTwo && !this.mapWayPointTwo && this.IsWayPointsMapTwo) {
    //       this.initializeLeafletMapWayPointTwo();
    //     } else if (this.mapContainerLiveTracking && !this.mapLiveTracking && this.IsLiveTracking) {
    //       this.initializeLeafletMapLiveTrack();
    //     } else if (this.mapContainerSelfFullfilled && !this.mapSelfFullfilled && this.IsSelfFullfilledMap) {
    //       this.InitMapSelfFullFilledLeaflet();
    //     } else if (this.mapContainerViewPage && !this.mapViewPage && this.IsViewPageMap) {
    //       // this.InitMapViewPageLeaflet();
    //     } else if (this.mapContainerRef && !this.mapLeaflet && !this.IsWayPointsMap && !this.IsWayPointsMapTwo && !this.IsLiveTracking && !this.IsSelfFullfilledMap && !this.IsViewPageMap) {
    //       this.initializeLeafletMap();
    //     }
    //   }
    // }, 1500);
  }

  ngAfterViewChecked(): void {
    // if (!this.mapPickup && document.getElementById('Newmap')) {
    //   this.initMap();
    // }
  }

  private getSafeValue(change: SimpleChange): any {
    if (!change) return null;

    const current = change.currentValue;
    const previous = change.previousValue;

    // Return current if it's not null, undefined, or empty string
    if (current !== null && current !== undefined && current !== '') {
      return current;
    }

    // Fallback to previous
    return previous;
  }

  private isValidLat(lat: any): boolean {
    const n = parseFloat(lat);
    return !isNaN(n) && n >= -90 && n <= 90;
  }

  //comented by vithu
  // ngOnChanges(changes: SimpleChanges) {
  //   if (this.UseLeafletMap) {
  //     if (!this.UseLeafletMapInitialized) return;
  //   }

  //   if (changes['data']) {
  //     this.getFullAddress();

  //     setTimeout(() => {
  //       this.initializeMap();
  //     }, 500);
  //   }

  //   if (changes['selectedId']) {
  //   }

  //   if (this.UseLeafletMap) {
  //     if (changes['TabName']) {
  //       this.TabName = changes['TabName'].currentValue;
  //       if (this.TabName == 'Details') {
  //         this.IsWayPointsMap = false;

  //         if (this.mapLeaflet) {
  //           setTimeout(() => this.mapLeaflet.invalidateSize(), 200);
  //           setTimeout(() => this.mapLeaflet.invalidateSize(), 1000);
  //         }
  //       } else if (this.TabName == 'Trips') {
  //         this.IsWayPointsMap = true;
  //         if (this.mapWayPoint) {
  //           setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
  //           setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
  //         }
  //       }
  //     }
  //   }

  //   const keysToWatch = [
  //     'BookingId',
  //     'Destination',
  //     'Origin',
  //     'PickUpLatitude',
  //     'PickUpLongtitude',
  //     'DeliverLatitude',
  //     'DeliverLongtitude',
  //     'CFSYARDLocationLatitude',
  //     'CFSYARDLocationLongtitude',
  //     'CFSYARDAddress'
  //   ];

  //   // 1. Update all relevant values if they have changed
  //   for (const key of keysToWatch) {
  //     const change = changes[key];
  //     if (change && change.currentValue !== undefined) {
  //       // Only update Origin/Destination if value actually changed
  //       if ((key === 'Destination' || key === 'Origin')) {
  //         if (change.previousValue !== change.currentValue) {
  //           (this as any)[key] = change.currentValue;
  //         }
  //       } else {
  //         (this as any)[key] = change.currentValue;
  //       }
  //     }
  //   }

  //   // 2. If Destination and Origin are both present, get lat/lng
  //   if (this.Origin && this.Destination) {
  //     if (!this.isValidLat(this.PickUpLatitude) && !this.isValidLat(this.PickUpLongtitude)) {
  //       this.getLatLng(this.Origin, 'Origin');
  //     }
  //     if (!this.isValidLat(this.DeliverLatitude) && !this.isValidLat(this.DeliverLongtitude)) {
  //       this.getLatLng(this.Destination, 'Destination');
  //     }
  //     if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement' && this.CFSYARDAddress) {
  //       if (!this.isValidLat(this.CFSYARDLocationLatitude) && !this.isValidLat(this.CFSYARDLocationLongtitude)) {
  //         this.getLatLng(this.CFSYARDAddress, 'CFSYARDLocation');
  //       }
  //     }
  //   }

  //   // 3. Reset tracking flag if BookingId has changed
  //   const bookingChange = changes['BookingId'];
  //   if (bookingChange && bookingChange.previousValue !== bookingChange.currentValue) {
  //     this.isLiveTrackCalled = false;
  //   }

  //   setTimeout(() => {
  //     if (this.Origin != null && this.Origin != "" && this.Destination != null && this.Destination != "") {
  //       if (this.BookingId != null && this.BookingId != "") {
  //         if (this.IsWayPointsMap) {
  //           this.IsMapShow = true;
  //           this.InitWayPointsMap();
  //         } else if (this.IsLiveTracking) {
  //           this.GetLiveTrackListForBooking();
  //         } else {
  //           this.initializeMap();
  //         }
  //       } else {
  //         if (this.IsWayPointsMapTwo) {
  //           this.IsMapShow = true;
  //           this.InitWayPointsMapTwo();
  //         } else if (this.IsSelfFullfilledMap) {
  //           this.InitMapSelfFullFilled();
  //         } else {
  //           this.initializeMap();
  //         }
  //       }
  //     } else {
  //       if (this.IsViewPageMap) {
  //         alert('trigger 3');
  //         this.BookingVehicleListForMap();
  //         this.InitMapViewPageLeaflet();
  //       }
  //     }
  //   }, 5000);
  // }

  IsViewMapTriggered: boolean = false;
  ngOnChanges(changes: SimpleChanges) {
    console.log('OrderList Map', this.OrderList)
    if (this.UseLeafletMap && !this.UseLeafletMapInitialized) return;

    if (changes['data']) {
      this.getFullAddress();
      setTimeout(() => this.initializeMap(), 500);
    }

    // Added by priya - 16/01/2026 - reset map data if we are seraching or filtering from view page - cn(PRIYA-JAN26-011)
    if (changes['OrderList'] && this.IsTollMapView && this.mapViewPage) {
      const newList = changes['OrderList'].currentValue || [];
      this.resetTollMarkers(newList);
    }

    if (changes['selectedId'] && !changes['selectedId'].firstChange) {
      // Added by priya - 16/01/2026 - works when we click on card - cn(PRIYA-JAN26-011)
      if (this.IsTollMapView) {
        Helpers.setLoading(true);
        this.focusTollMarker(changes['selectedId'].currentValue);
        Helpers.setLoading(false);
        return; // ⛔ STOP HERE
      }
      this.IsViewSingleMap = true;
      this.IsViewPageMap = false;
      this.IsSelfFullfilledMap = true;
      this.IsSelfFullfillMapTriggered = true;

      setTimeout(() => {
        this.InitMapSelfFullFilled();
      }, 200);
    }

    if (changes['TabName'] && this.UseLeafletMap) {
      this.TabName = changes['TabName'].currentValue;

      if (this.TabName === 'Details') {
        this.IsWayPointsMap = true;
        if (this.mapLeaflet) {
          setTimeout(() => this.mapLeaflet.invalidateSize(), 200);
        }
      } else if (this.TabName === 'Trips') {
        this.IsWayPointsMap = true;
        if (this.mapWayPoint) {
          // setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
        }
      }
    }

    // Update individual inputs
    const keysToWatch = [
      'BookingId',
      'Destination',
      'Origin',
      'PickUpLatitude',
      'PickUpLongtitude',
      'DeliverLatitude',
      'DeliverLongtitude',
      'CFSYARDLocationLatitude',
      'CFSYARDLocationLongtitude',
      'CFSYARDAddress'
    ];
    for (const key of keysToWatch) {
      const change = changes[key];
      if (change && change.currentValue !== undefined) {
        if ((key === 'Destination' || key === 'Origin') && change.previousValue !== change.currentValue) {
          (this as any)[key] = change.currentValue;
        } else {
          (this as any)[key] = change.currentValue;
        }
      }
    }

    // Update coordinates if missing
    if (this.Origin && this.Destination) {
      if (!this.isValidLat(this.PickUpLatitude)) {
        this.getLatLng(this.Origin, 'Origin');
      }
      if (!this.isValidLat(this.DeliverLatitude)) {
        this.getLatLng(this.Destination, 'Destination');
      }
      if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement' && this.CFSYARDAddress) {
        if (!this.isValidLat(this.CFSYARDLocationLatitude)) {
          this.getLatLng(this.CFSYARDAddress, 'CFSYARDLocation');
        }
      }
    }

    // Reset tracking
    if (changes['BookingId'] && changes['BookingId'].previousValue !== changes['BookingId'].currentValue) {
      this.isLiveTrackCalled = false;
    }

    // Final map logic in ONE place
    setTimeout(() => {
      if (this.Origin && this.Destination) {
        if (this.BookingId) {
          if (this.IsWayPointsMap) {
            this.IsMapShow = true;
            this.InitWayPointsMap();
          } else if (this.IsWayPointsMapTwo) {
            this.IsMapShow = true;
            this.InitWayPointsMapTwo();
          } else if (this.IsLiveTracking) {
            this.GetLiveTrackListForBooking();
          } else {
            this.initializeMap();
          }
        } else if (this.IsWayPointsMapTwo) {
          this.IsMapShow = true;
          this.InitWayPointsMapTwo();
        } else if (this.IsSelfFullfilledMap) {
          if (!this.IsSelfFullfillMapTriggered) {
            this.InitMapSelfFullFilled();
            this.IsSelfFullfillMapTriggered = true;
          }
        } else {
          this.initializeMap();
        }
      } else if (this.IsViewPageMap) {
        if (!this.IsViewMapTriggered) {
          this.BookingVehicleListForMap();
          this.IsViewMapTriggered = true;
          setTimeout(() => {
            this.InitMapViewPageLeaflet();
          }, 1000);
        }
      }
    }, 1000); // reduce from 5000ms to something more responsive

    // Added by priya - 16/01/2026 -  TOLL MAP – CARD CLICK → FOCUS MARKER - cn(PRIYA-JAN26-011)
    if (
      changes['selectedId'] &&
      !changes['selectedId'].firstChange &&
      this.IsTollMapView &&
      this.mapViewPage &&
      this.tollMarkerById.size > 0
    ) {
      Helpers.setLoading(true);
      // No delay needed – markers already present
      this.focusTollMarker(changes['selectedId'].currentValue);
      Helpers.setLoading(false);
    }

  }

  IsSelfFullfillMapTriggered: boolean = false;
  private isLiveTrackCalled = false; // Flag to prevent multiple calls
  // ngOnChanges(changes: SimpleChanges) {
  //   // if (changes['data']) {
  //   //   this.getFullAddress();

  //   //   setTimeout(() => {
  //   //     this.initializeMap();
  //   //   }, 500);
  //   // }
  //   if (changes['TabName']) {
  //     this.TabName = changes['TabName'].currentValue;
  //     if (this.TabName == 'Details') {
  //       this.IsWayPointsMap = false;

  //       if (this.map) {
  //         setTimeout(() => this.map.invalidateSize(), 200);
  //         setTimeout(() => this.map.invalidateSize(), 1000);
  //       }
  //     } else if (this.TabName == 'Trips') {
  //       this.IsWayPointsMap = true;
  //       if (this.mapWayPoint) {
  //         setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
  //         setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
  //       }
  //     }
  //   }

  //   // if (changes['Destination'] && changes['Origin']) {
  //   // Reset the flag when BookingId changes
  //   if (changes['BookingId']) {
  //     if (changes['BookingId'].previousValue !== changes['BookingId'].currentValue) {
  //       this.isLiveTrackCalled = false;
  //     }
  //   }

  //   const keys = [
  //     'BookingId',
  //     'Destination',
  //     'Origin',
  //     'PickUpLatitude',
  //     'PickUpLongtitude',
  //     'DeliverLatitude',
  //     'DeliverLongtitude',
  //     'CFSYARDLocationLatitude',
  //     'CFSYARDLocationLongtitude',
  //     'CFSYARDAddress'
  //   ];

  //   for (const key of keys) {
  //     const change = changes[key];
  //     if (change) {
  //       // Only update if there is a valid current value
  //       if (change.currentValue !== undefined) {
  //         // Specifically for Origin and Destination, only update if there's a change
  //         if (key === 'Destination' || key === 'Origin') {
  //           if (change.previousValue !== change.currentValue) {
  //             (this as any)[key] = change.currentValue;
  //           }
  //         } else {
  //           // For other keys, just update the value
  //           (this as any)[key] = change.currentValue;
  //         }
  //       }
  //     }
  //   }
  //   setTimeout(() => {
  //     if (this.Origin && this.Origin !== "" && this.Destination && this.Destination !== "") {
  //       setTimeout(() => {
  //         if (this.BookingId && this.BookingId !== "") {
  //           if (this.IsWayPointsMap) {
  //             this.IsMapShow = true;
  //             this.showOriginDestinationWayPoint(this.Origin, this.Destination);
  //           } else if (this.IsWayPointsMapTwo) {
  //             this.IsMapShow = true;
  //             this.showOriginDestinationWayPointTwo();
  //           } else if (this.IsLiveTracking == true) {
  //             this.showLiveTrackVehicle();
  //           } else {
  //             this.showOriginDestination(this.Origin, this.Destination);
  //           }

  //           if (!this.isLiveTrackCalled) {
  //             this.IsMapShow = false;
  //             this.isLiveTrackCalled = true; // Prevent multiple calls unless BookingId changes
  //             //this.GetLiveTrackListForBooking();
  //           }
  //         } else {
  //           if (this.IsWayPointsMapTwo) {
  //             this.IsMapShow = true;
  //             this.showOriginDestinationWayPointTwo();
  //           } else {
  //             this.showOriginDestination(this.Origin, this.Destination);
  //           }
  //         }
  //       }, 500);

  //       // Uncomment if needed
  //       // setInterval(() => {
  //       //   if (!MapDetailsCardComponent.that.isGPS) {
  //       //     MapDetailsCardComponent.that.getDriverCurrentLatLong();
  //       //   }
  //       // }, 5000);

  //       // setInterval(() => {
  //       //   if (MapDetailsCardComponent.that.isGPS) {
  //       //     MapDetailsCardComponent.that.getDriverCurrentLatLong_GPS();
  //       //   }
  //       // }, 5000);
  //     }
  //   }, 5000);
  //   // }


  // }

  getLatLng(address: string, from: string) {
    if (!this.UseLeafletMap) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        console.log('address:', address, 'from:', from, 'results:', results, 'status:', status);
        if (status === "OK") {
          const location = results[0].geometry.location;
          if (from === "Origin") {
            this.PickUpLatitude = location.lat();
            this.PickUpLongtitude = location.lng();
          }
          if (from === "Destination") {
            this.DeliverLatitude = location.lat();
            this.DeliverLongtitude = location.lng();
          }
          if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement') {
            if (from === "CFSYARDLocation") {
              this.CFSYARDLocationLatitude = location.lat();
              this.CFSYARDLocationLongtitude = location.lng();
            }
          }
          if (from == "SOaddress") {
            this.PickUpLatitude = location.lat();
            this.PickUpLongtitude = location.lng();
            this.DeliverLatitude = location.lat();
            this.DeliverLongtitude = location.lng();
          }
          this.isShowMap = true; // Successfully found location
        } else {
          this.isShowMap = false; // Failed to find location
          console.log("Geocode was not successful for the following reason: " + status);
        }
      });
      this.isShowMapChange.emit(this.isShowMap);
    }
  }

  WayPointsMap: any;
  initializeMap() {
    if (!this.UseLeafletMap) {
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer();
      if (this.fullAddress) {
        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: 13,
          center: {
            lat: MapDetailsCardComponent.that.PickUpLatitude ? MapDetailsCardComponent.that.DeliverLatitude : 41.85,
            lng: MapDetailsCardComponent.that.PickUpLongtitude ? MapDetailsCardComponent.that.PickUpLongtitude : -87.65
          },
        });
        const infoWindow = new google.maps.InfoWindow();
        this.beachMarker = new google.maps.Marker({
          position: {
            lat: MapDetailsCardComponent.that.DeliverLatitude,
            lng: MapDetailsCardComponent.that.DeliverLongtitude,
          },
          map: this.map,
          icon: {
            anchor: new google.maps.Point(16, 16),
            url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
            scale: 3,
            fillColor: "red",
            fillOpacity: 0.8,
            strokeWeight: 2,
            rotation: this.VehicleDirectionDegree,
          },
          title: this.fullAddress,
        });
        this.beachMarker.addListener("click", () => {
          this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => {
            this.beachMarker.setAnimation(null);
          }, 2000);
        });

        this.beachMarker.setMap(this.map);
        directionsRenderer.setMap(this.map);
        this.calculateAndDisplayRoute(directionsService, directionsRenderer);
      } else {
        this.map = new google.maps.Map(document.getElementById("map"), {
          zoom: 6,
          center: {
            lat: this.liveTrackData.driverLocationLAT
              ? this.liveTrackData.driverLocationLAT
              : 41.85,
            lng: this.liveTrackData.driverLocationLNG
              ? this.liveTrackData.driverLocationLNG
              : -87.65,
          },
        });
        const image = "../../assets/img/truck_inactive.png";
        const infoWindow = new google.maps.InfoWindow();
        this.beachMarker = new google.maps.Marker({
          position: {
            lat: this.liveTrackData.driverLocationLAT,
            lng: this.liveTrackData.driverLocationLNG,
          },
          map: this.map,
          // icon: image,
          icon: {
            anchor: new google.maps.Point(16, 16),
            url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
            scale: 3,
            fillColor: "red",
            fillOpacity: 0.8,
            strokeWeight: 2,
            rotation: this.VehicleDirectionDegree, //this is how to rotate the pointer
          },
          title: this.liveTrackData.vehicleNo,
        });
        this.beachMarker.addListener("click", () => {
          this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => {
            this.beachMarker.setAnimation(null);
          }, 2000);
          infoWindow.close();
          infoWindow.setContent(
            '<table style="table-layout: fixed;">' +
            "<tr>" +
            '<td style="font-weight: bold">Vehicle No:</td>' +
            "<td>" +
            (this.liveTrackData.vehicleNo
              ? this.liveTrackData.vehicleNo
              : "N/A") +
            "</td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Driver:</td>' +
            "<td>" +
            (this.liveTrackData.driverName
              ? this.liveTrackData.driverName
              : "N/A") +
            "</td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Driver Mobile No:</td>' +
            "<td>" +
            (this.liveTrackData.driverMobileNo
              ? this.liveTrackData.driverMobileNo
              : "N/A") +
            "</td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Last Tracked:</td>' +
            "<td>" +
            this.liveTrackData.LastTracked +
            "</td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Speed:</td>' +
            "<td>" +
            this.liveTrackData.Speed +
            "</td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Status:</td>' +
            "<td><b>" +
            this.liveTrackData.TrackStatus +
            "</b></td>" +
            "</tr>" +
            "<tr>" +
            '<td style="font-weight: bold">Track By:</td>' +
            "<td><b>" +
            this.liveTrackData.TrackThrough +
            "</b></td>" +
            "</tr>" +
            "</table>"
          );
          infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
        });

        this.beachMarker.setMap(this.map);
        directionsRenderer.setMap(this.map);
        this.calculateAndDisplayRouteV2(directionsService, directionsRenderer);
      }
    } else {
      setTimeout(() => this.initializeLeafletMap(), 50);
    }
  }

  calculateAndDisplayRoute(directionsService, directionsRenderer) {
    if (!directionsService || !directionsRenderer) {
      console.error(
        "DirectionsService or DirectionsRenderer is not initialized."
      );
      return;
    }

    if (!this.Origin || !this.Destination) {
      console.error("Origin or Destination is not set.");
      return;
    }

    directionsService
      .route({
        origin: this.Origin,
        destination: this.Destination,
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
        const route = response.routes[0].legs[0];
        const distance = route.distance.text; // e.g., "2,459 km"
        const duration = route.duration.text; // e.g., "24 hours 30 mins"

        var obj: any = {};
        obj.distance = distance;
        obj.duration = duration;
        MapDetailsCardComponent.that.OnCatchData.emit(obj);
      })
      .catch((e) => {
        console.error(e);
        // window.alert("Directions request failed due to " + e.message);
        this.toastr.error("Directions request failed due to " + e.message, "Error");
      });
  }

  getDriverCurrentLatLong() {
    this._appService
      .GetByTwoId(
        "Booking",
        "LT_getDriverCurrentLatLong",
        this.BookingId,
        this.ConsignmentDetailId
      )
      .subscribe(
        (response) => {
          var objOldLatLong: any = [
            this.liveTrackData.driverLocationLAT,
            this.liveTrackData.driverLocationLNG,
          ];
          if (response.length > 0) {
            if (
              this.liveTrackData.driverLocationLAT == null ||
              this.liveTrackData.driverLocationLNG == null
            ) {
              objOldLatLong = [
                response[0].driverLocationLAT,
                response[0].driverLocationLNG,
              ];
            }
            var newOldLatLong: any = [
              response[0].driverLocationLAT,
              response[0].driverLocationLNG,
            ];
            if (
              this.liveTrackData.driverLocationLAT != newOldLatLong[0] &&
              this.liveTrackData.driverLocationLNG != newOldLatLong[1]
            ) {
              this.transition(newOldLatLong, objOldLatLong);
            }
            this.liveTrackData.driverLocationLAT =
              response[0].driverLocationLAT;
            this.liveTrackData.driverLocationLNG =
              response[0].driverLocationLNG;
            this.liveTrackData.LastTracked = response[0].LastTracked;
            this.liveTrackData.TrackStatus = response[0].TrackStatus;
            this.liveTrackData.TrackThrough = response[0].TrackThrough;
            this.liveTrackData.Speed = response[0].Speed;
          }
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  transition(result, position) {
    this.position = position;
    this.i = 0;
    this.deltaLat = (result[0] - this.position[0]) / this.numDeltas;
    this.deltaLng = (result[1] - this.position[1]) / this.numDeltas;
    this.CalculateDegrees(position[0], position[1], result[0], result[1]);
    this.moveMarker();
  }

  moveMarker() {
    this.position[0] = parseFloat(this.position[0] + this.deltaLat);
    this.position[1] = parseFloat(this.position[1] + this.deltaLng);
    var latlng = new google.maps.LatLng(this.position[0], this.position[1]);
    this.beachMarker.setPosition(latlng);
    if (this.i != this.numDeltas) {
      this.i = this.i + 1;
      setTimeout(() => {
        this.moveMarker();
      }, this.delay);
    }
  }

  degreeToRadians(latLong) {
    return (Math.PI * latLong) / 180.0;
  }

  radiansToDegree(latLong) {
    return (latLong * 180.0) / Math.PI;
  }

  CalculateDegrees(
    start_latitude: any,
    start_longitude: any,
    stop_latitude: any,
    stop_longitude: any
  ) {
    console.log(
      "coordinates",
      "[",
      start_latitude,
      "]",
      "[",
      start_longitude,
      "]",
      "[",
      stop_latitude,
      "]",
      "[",
      stop_longitude,
      "]"
    );
    //Source
    var lat1 = parseFloat(start_latitude);
    var lng1 = parseFloat(start_longitude);

    // destination
    var lat2 = parseFloat(stop_latitude);
    var lng2 = parseFloat(stop_longitude);

    var fLat = this.degreeToRadians(lat1);
    var fLong = this.degreeToRadians(lng1);
    var tLat = this.degreeToRadians(lat2);
    var tLong = this.degreeToRadians(lng2);

    var dLon = tLong - fLong;

    var degree = this.radiansToDegree(
      Math.atan2(
        Math.sin(dLon) * Math.cos(tLat),
        Math.cos(fLat) * Math.sin(tLat) -
        Math.sin(fLat) * Math.cos(tLat) * Math.cos(dLon)
      )
    );

    if (degree >= 0) {
      this.VehicleDirectionDegree = degree;
    } else {
      this.VehicleDirectionDegree = 360 + degree;
    }

    this.svg =
      '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' +
      this.VehicleDirectionDegree +
      ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

    var icon = {
      anchor: new google.maps.Point(16, 16),
      url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
      scale: 3,
      fillColor: "red",
      fillOpacity: 0.8,
      strokeWeight: 2,
      rotation: this.VehicleDirectionDegree, //this is how to rotate the pointer
    };
    this.beachMarker.setIcon(icon);
  }

  getDriverCurrentLatLong_GPS() {
    this._appService
      .GetByTwoId(
        "OrdersByVehicle",
        "opa_getTripLiveData_GPSWise_fromTable",
        this.liveTrackData.vehicleNo,
        this.BookingId
      )
      .subscribe(
        (data) => {
          try {
            var response1_obj: any = [];
            response1_obj = data;
            if (response1_obj.length > 0) {
              this.isGPS = true;
              this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
              this.liveTrackData.Speed = response1_obj[0].Speed;

              var objOldLatLong: any = [
                this.liveTrackData.driverLocationLAT,
                this.liveTrackData.driverLocationLNG,
              ];
              var newOldLatLong: any = [
                response1_obj[0].Latitude,
                response1_obj[0].Longitude,
              ];
              if (
                this.liveTrackData.driverLocationLAT != newOldLatLong[0] &&
                this.liveTrackData.driverLocationLNG != newOldLatLong[1]
              ) {
                this.transition(newOldLatLong, objOldLatLong);
              }

              this.liveTrackData.driverLocationLAT = parseFloat(
                response1_obj[0].Latitude
              );
              this.liveTrackData.driverLocationLNG = parseFloat(
                response1_obj[0].Longitude
              );

              this.liveTrackData.LastTracked = response1_obj[0].GPSActualTime;

              var today = new Date();
              var gpsDate = new Date(response1_obj[0].GPSActualTime);
              var diff = today.getTime() - gpsDate.getTime();
              var days = Math.floor(diff / (60 * 60 * 24 * 1000));
              var hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
              var minutes =
                Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);

              var image = "../../assets/img/truck_inactive.png";

              if (minutes > 1) {
                this.liveTrackData.TrackStatus = "InActive";
                image = "../../assets/img/truck_inactive.png";
              } else {
                this.liveTrackData.TrackStatus = "Active";
                image = "../../assets/img/truck_active.png";
              }
              this.liveTrackData.TrackThrough = "GPS";
            }
          } catch (e) { }
          // this.initMap();
        },
        (error) => {
          this.toastr.error(error._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        }
      );
  }

  GetLiveTrackListForBooking() {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId(
        "Booking",
        "GetLiveTrackListForBooking",
        this.BookingId,
        this.ConsignmentDetailId
      )
      .subscribe(
        (response) => {
          Helpers.setLoading(false);
          this.liveTrackData = response.Table[0];
          this.liveTrackData.documentList = [];
          this.liveTrackData.documentList = response.Table1;
          this.liveTrackData.orderDetailsList = [];
          this.liveTrackData.orderDetailsList.push(response.Table2[0]);
          this.liveTrackData.documentList.forEach((element) => {
            if (element.documentFileName !== null) {
              element.documentFileName =
                element.documentFileName.split(/_(.+)/)[1] +
                "." +
                element.documentFileExtension;
            }
          });
          
          this.LiveTrackLatitude = Number(this.liveTrackData && this.liveTrackData.driverLocationLAT) || 0;
          this.LiveTrackLongtitude = Number(this.liveTrackData && this.liveTrackData.driverLocationLNG) || 0;
          this.TrackThrough = this.liveTrackData && this.liveTrackData.TrackThrough ? this.liveTrackData.TrackThrough : '';
          this.LastTrackDate = this.liveTrackData && this.liveTrackData.LastTracked ? this.liveTrackData.LastTracked : '';

          this.LiveTrackLatitude = Number(this.liveTrackData && this.liveTrackData.driverLocationLAT) || 0;
          this.LiveTrackLongtitude = Number(this.liveTrackData && this.liveTrackData.driverLocationLNG) || 0;
          this.TrackThrough = this.liveTrackData && this.liveTrackData.TrackThrough ? this.liveTrackData.TrackThrough : '';
          this.LastTrackDate = this.liveTrackData && this.liveTrackData.LastTracked ? this.liveTrackData.LastTracked : '';

          if (!this.UseLeafletMap) {
            this.initializeMap();
          } else {
            this.initializeLeafletMapLiveTrack();
          }
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        }
      );
  }

  async getFullAddress() {
    // const originLatLng = await this.getCoordinatesFromAddress(this.Origin);
    // const destLatLng = await this.getCoordinatesFromAddress(this.Destination);

    if (!this.UseLeafletMap) {
      this.fullAddress = this.data.fullAddress;
      this.getLatLng(this.fullAddress, 'Origin');
      this.getLatLng(this.fullAddress, 'Destination');
      if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement') {
        this.getLatLng(this.fullAddress, 'CFSYARDLocation');
      }
    }
  }

  getSOAddresstoPlot() {
    this.fullAddress = this.data.fullAddress;
    this.getLatLng(this.fullAddress, 'SOAddress');
  }

  async LoadTripRouteBaseOnDeliveryDate() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "TripRouteBaseOnDeliveryDate")
      .subscribe(
        async (response) => {
          if (response == '1') {
            this.TripRouteBaseOnDeliveryDateFlag = true;
          } else {
            this.TripRouteBaseOnDeliveryDateFlag = false;
          }
        },
        async (err) => {
        }
      );
  }

  async LoadLiveTrackingThrowWarehouseLatLong() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "LiveTrackingThrowWarehouseLatLong")
      .subscribe(
        async (response) => {
          if (response == '1') {
            this.LiveTrackingThrowWarehouseLatLongFlage = true;
          } else {
            this.LiveTrackingThrowWarehouseLatLongFlage = false;
          }
        },
        async (err) => {
        }
      );
  }

  MapRadious: any;
  OrderInfo: any = [];
  async InitWayPointsMap() {

    var WayPointsManualvehicleOrderList = [];
    this._appService
      .GetById(
        "Booking",
        "GetOrderAddressFromLocationCodeMobile",
        this.BookingId
      )
      .subscribe(
        async (response: any) => {
          var DestinationLocation = "";
          DestinationLocation = response.Table[0].DeliveryAddress;
          this.WayPointsres = [];
          let res = [];
          let PickUpPoints = [];
          var CheckForSamePickup: boolean = false;
          WayPointsManualvehicleOrderList = response.Table1;
          response.Table1.map(function (item) {
            var existItem = res.find((x) => x.PickupLocationCode != item.PickupLocationCode);
            var existItemDelivery = MapDetailsCardComponent.that.WayPointsres.find((x) => x.DeliveryAddress == item.DeliveryAddress);
            if (!existItemDelivery || MapDetailsCardComponent.that.TripRouteBaseOnDeliveryDateFlag == true) {
              var objDeliveryLocation: any = {};
              objDeliveryLocation.location = MapDetailsCardComponent.that.LiveTrackingThrowWarehouseLatLongFlage == true ? item.DeliveryAddressLatLong : item.DeliveryAddress1;
              objDeliveryLocation.stopover = true;
              objDeliveryLocation.Order = 0;
              objDeliveryLocation.RouteOrder = "A";
              objDeliveryLocation.OrderNo = item.OrderNo;
              objDeliveryLocation.PickUpContactPersonDetail = item.PickUpContactPersonDetail;
              objDeliveryLocation.DeliveryContactPersonDetail = item.DeliveryContactPersonDetail;
              objDeliveryLocation.OrderAddress = item.DeliveryAddress;
              objDeliveryLocation.OrderLatLong = item.DeliveryAddressLatLong;
              objDeliveryLocation.OrderDate = new Date(item.DeliviryDate);
              objDeliveryLocation.OrderDateFormated = item.DeliviryDateFormated;
              objDeliveryLocation.weight = item.weight;
              objDeliveryLocation.Qty = item.Qty;
              objDeliveryLocation.cbm = item.CBM;
              MapDetailsCardComponent.that.WayPointsres.push(objDeliveryLocation);
            }
            if (existItem) {
              CheckForSamePickup = true;
            } else {
              CheckForSamePickup = false;
              res.push(item);
              var objPickupLocation: any = {};
              if (PickUpPoints.length == 0) {
                objPickupLocation.origin = item.PickupAddress1;
                objPickupLocation.destination = DestinationLocation;
                objPickupLocation.TripNo = "";
                objPickupLocation.DispatchDate = "";
                objPickupLocation.Transporter = "";
                objPickupLocation.TransporterPhone = "";
                objPickupLocation.Driver = "";
                objPickupLocation.DriverPhone = "";
                objPickupLocation.Vehicle = "";
                objPickupLocation.VehicleType = "";
                PickUpPoints.push(objPickupLocation);
              }
            }
            MapDetailsCardComponent.that.MapRadious = item.MapRadious;
          });
          if (CheckForSamePickup == false) {
            this.OrderInfoLatLong = [
              {
                origin: WayPointsManualvehicleOrderList[0].PickupAddress, //.PickupAddressLatLong,
                destination: WayPointsManualvehicleOrderList[0].DeliveryAddressLatLong,
              },
            ];

            this.OrderInfo = PickUpPoints;
            this.OrderDestinationLocation = this.WayPointsres;
            if (this.TripRouteBaseOnDeliveryDateFlag == true) {
              this.OrderDestinationLocation = this.WayPointsres.sort((a, b) => a.OrderDate - b.OrderDate);
            }
          }
          
          setTimeout(() => {
            this.InitWayPointMap();
          }, 100);
        },
        async (err) => {
        }
      );
  }

  InitWayPointMap() {
    if (!this.UseLeafletMap) {
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer();
      const mapv2 = new google.maps.Map(document.getElementById("WayPointMap"), {
        zoom: 6,
        center: { lat: 41.85, lng: -87.65 }
      });

      directionsRenderer.setMap(mapv2);

      const geocoder = new google.maps.Geocoder(); // Geocoder to convert addresses into LatLng

      // This function will handle geocoding for each address
      const geocodeAddresses = async (addresses) => {
        const waypts = [];

        for (let i = 0; i < addresses.length; i++) {
          const loc = addresses[i];
          try {
            const result = await geocodeAddress(loc.location); // Geocode the address
            waypts.push({
              location: result,  // Add geocoded location
              stopover: true
            });

            // Create a marker for the geocoded location
            new google.maps.Marker({
              position: result,
              map: mapv2,
              label: '' //loc.tripNo,  // Label the marker with the order number
            });
          } catch (error) {
            console.error(`Geocode failed for address: ${loc.location}`, error);
          }
        }

        return waypts;  // Return the array of waypoints once all are geocoded
      };

      // Helper function to geocode an address and return a LatLng object
      const geocodeAddress = (address) => {
        return new Promise((resolve, reject) => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results[0].geometry.location);  // Return the LatLng object
            } else {
              reject(new Error('Geocode failed: ' + status));
            }
          });
        });
      };

      // Once geocoding is done, call the directions service
      geocodeAddresses(this.WayPoints).then((waypts) => {
        directionsService.route({
          origin: MapDetailsCardComponent.that.FTLType === 'ContainerMovement' ? this.CFSYARDAddress : this.Origin,
          // origin: this.Origin,  // Ensure Origin is a LatLngLiteral or LatLng object
          destination: this.Destination,  // Ensure Destination is a LatLngLiteral or LatLng object
          // waypoints: waypts,  // Waypoints are set after geocoding
          waypoints: MapDetailsCardComponent.that.FTLType === 'FTL' ? waypts : [{ location: this.Origin, stopover: true }],
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING
        }, (response, status) => {
          if (status === "OK") {
            directionsRenderer.setDirections(response);
            const route = response.routes[0];

            let totalDistance = 0;
            let totalDuration = 0;
            route.legs.forEach((leg) => {
              totalDistance += leg.distance.value;
              totalDuration += leg.duration.value;
            });

            setTimeout(() => {
              // Add polyline to show the route overview
              const polyline = new google.maps.Polyline({
                path: route.overview_path,  // The path is the polyline path
                strokeColor: "#3367FB", // Set polyline color
                strokeOpacity: 1.0,
                strokeWeight: 5,
              });
              polyline.setMap(mapv2);
            }, 1000);
          } else {
            // window.alert("Directions request failed due to " + status);
            this.toastr.error("Directions request failed due to " + status, "Error");
          }
        });
      }).catch((error) => {
        console.error('Error in geocoding waypoints:', error);
      });
    } else {
      this.initializeLeafletMapWayPoint();
    }
  }

  InitWayPointsMapTwo() {
    if (!this.UseLeafletMap) {
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer();
      const mapv2 = new google.maps.Map(document.getElementById("WayPointMapTwo"), {
        zoom: 6,
        center: { lat: 41.85, lng: -87.65 }
      });

      directionsRenderer.setMap(mapv2);

      const geocoder = new google.maps.Geocoder(); // Geocoder to convert addresses into LatLng

      // This function will handle geocoding for each address
      const geocodeAddresses = async (addresses) => {
        const waypts = [];

        for (let i = 0; i < addresses.length; i++) {
          const loc = addresses[i];
          try {
            const result = await geocodeAddress(loc.location); // Geocode the address
            waypts.push({
              location: result,  // Add geocoded location
              stopover: true
            });

            // Create a marker for the geocoded location
            new google.maps.Marker({
              position: result,
              map: mapv2,
              label: '' //loc.tripNo,  // Label the marker with the order number
            });
          } catch (error) {
            console.error(`Geocode failed for address: ${loc.location}`, error);
          }
        }

        return waypts;  // Return the array of waypoints once all are geocoded
      };

      // Helper function to geocode an address and return a LatLng object
      const geocodeAddress = (address) => {
        return new Promise((resolve, reject) => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results[0].geometry.location);  // Return the LatLng object
            } else {
              reject(new Error('Geocode failed: ' + status));
            }
          });
        });
      };

      // Once geocoding is done, call the directions service
      geocodeAddresses(this.WayPoints).then((waypts) => {
        directionsService.route({
          origin: MapDetailsCardComponent.that.FTLType === 'ContainerMovement' ? this.CFSYARDAddress : this.Origin,
          // origin: this.Origin,  // Ensure Origin is a LatLngLiteral or LatLng object
          destination: this.Destination,  // Ensure Destination is a LatLngLiteral or LatLng object
          // waypoints: waypts,  // Waypoints are set after geocoding
          waypoints: MapDetailsCardComponent.that.FTLType === 'FTL' ? waypts : [{ location: this.Origin, stopover: true }],
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING
        }, (response, status) => {
          if (status === "OK") {
            directionsRenderer.setDirections(response);
            const route = response.routes[0];

            let totalDistance = 0;
            let totalDuration = 0;
            route.legs.forEach((leg) => {
              totalDistance += leg.distance.value;
              totalDuration += leg.duration.value;
            });

            setTimeout(() => {
              // Add polyline to show the route overview
              const polyline = new google.maps.Polyline({
                path: route.overview_path,  // The path is the polyline path
                strokeColor: "#3367FB", // Set polyline color
                strokeOpacity: 1.0,
                strokeWeight: 5,
              });
              polyline.setMap(mapv2);
            }, 1000);
          } else {
            // window.alert("Directions request failed due to " + status);
            this.toastr.error("Directions request failed due to " + status, "Error");
          }
        });
      }).catch((error) => {
        console.error('Error in geocoding waypoints:', error);
      });
      this.calculateAndDisplayRouteForContainerMovement(directionsService, directionsRenderer);
    } else {
      this.initializeLeafletMapWayPointTwo();
    }
  }

  calculateAndDisplayRouteForContainerMovement(directionsService, directionsRenderer) {
    if (!directionsService || !directionsRenderer) {
      console.error(
        "DirectionsService or DirectionsRenderer is not initialized."
      );
      return;
    }

    if (!this.Origin || !this.Destination) {
      console.error("Origin or Destination is not set.");
      return;
    }

    directionsService
      .route({
        origin: this.CFSYARDAddress,
        destination: this.Destination,
        waypoints: [{ location: this.Origin, stopover: true }],
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
        let totalDistance = 0;
        let totalDuration = 0;

        response.routes[0].legs.forEach((leg) => {
          totalDistance += leg.distance.value; // in meters
          totalDuration += leg.duration.value; // in seconds
        });

        // Convert distance to kilometers and duration to hours & minutes
        const distanceKm = (totalDistance / 1000).toFixed(2) + " km";
        const durationHrMin = new Date(totalDuration * 1000)
          .toISOString()
          .substr(11, 8); // Converts seconds to HH:MM:SS format


        var obj: any = {};
        obj.distance = distanceKm;
        obj.duration = durationHrMin;
        MapDetailsCardComponent.that.OnCatchData.emit(obj);
      })
      .catch((e) => {
        console.error(e);
        // window.alert("Directions request failed due to " + e.message);
        this.toastr.error("Directions request failed due to " + e.message, "Error");
      });
  }

  //Leaflet Map
  private originMarkerWm: L.Marker;
  private destMarkerWm: L.Marker;
  private routingControlWm: any;
  originCircleWm: any;
  destCircleWm: any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    // this.map.invalidateSize();
    // this.mapWayPoint.invalidateSize();
  }

  // getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
  //   return new Promise((resolve, reject) => {
  //     var obj: any = {};
  //     obj.address = address;
  //     this._appService.Post('OrdersByVehicle', 'GetCoordinatesFromAddressAsync', obj).subscribe(
  //       (response: any) => {
  //         // Assuming response has 'Latitude', 'Longitude', 'Altitude'
  //         if (response) {
  //           const lat: number = response.Latitude;
  //           const lon: number = response.Longitude;
  //           const alt: number = response.Altitude || 0; // Default to 0 if Altitude is not provided

  //           resolve([lat, lon, alt]);
  //         } else {
  //           this.toastr.error('Address not found!');
  //           reject('Address not found');
  //         }
  //       },
  //       error => {
  //         this.toastr.error('Error fetching coordinates!');
  //         reject('Error fetching coordinates');
  //       }
  //     );
  //   });
  // }

  // getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
  //   const cleanedAddress = address
  //     .replace(/-/g, ',')
  //     .replace(/,\s*$/, '');
  //   const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanedAddress)}`;

  //   const userAgent = navigator.userAgent;
  //   console.log(cleanedAddress);
  //   return fetch(url, {
  //     headers: {
  //       'Accept-Language': 'en',
  //       'User-Agent': userAgent // Replace with real app name/email
  //     }
  //   })
  //     .then(response => {
  //       if (!response.ok) {
  //         throw new Error('Failed to fetch coordinates');
  //       }
  //       return response.json();
  //     })
  //     .then(data => {
  //       if (data && data.length > 0) {
  //         const { lat, lon } = data[0];
  //         return [parseFloat(lat), parseFloat(lon), 0] as [number, number, number];
  //       } else {
  //         // If using Toastr in Angular or similar
  //         if (typeof this !== 'undefined' && this.toastr) {
  //           this.toastr.error('Address not found!', 'Error');
  //         }
  //         throw new Error('Address not found');
  //       }
  //     });
  // }

  mapRadius: any = 0;
  getMapRadius() {
    this._appService
      .Get(
        "OrdersByVehicle",
        "getMapRadius"
      )
      .subscribe(
        (response) => {
          this.mapRadius = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  initializeLeafletMap() {
    const containerEl = this.mapContainerRef.nativeElement;
    const initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;

    // if (this.mapLeaflet) {
    //   return;
    // }
    if (this.mapLeaflet) {
      this.mapLeaflet.remove(); // destroy existing map
      this.mapLeaflet = null;
    }

    this.mapLeaflet = L.map(containerEl).setView(initialCoords, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapLeaflet);

    // setTimeout(() => this.mapLeaflet.invalidateSize(), 200);
    // setTimeout(() => this.mapLeaflet.invalidateSize(), 1000);

    this.showOriginDestination(this.Origin, this.Destination);
  }

  async showOriginDestination(origin: string, destination: string): Promise<void> {
    try {
      const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0];

      const isValidCoord = (lat: number, lng: number, lg: number) =>
        typeof lat === 'number' && typeof lng === 'number' &&
        !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

      const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
      const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);

      const originCoords: L.LatLngTuple = hasValidOrigin
        ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
        : defaultCoords;

      const destCoords: L.LatLngTuple = hasValidDestination
        ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
        : defaultCoords;

      const containerEl = this.mapContainerRef.nativeElement;

      // Initialize map if not already
      if (containerEl && !containerEl._leaflet_id) {
        this.mapLeaflet = L.map(containerEl).setView(defaultCoords, 5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.mapLeaflet);
        this.mapLayerGroup = L.layerGroup().addTo(this.mapLeaflet);
      }

      if (!this.mapLeaflet.hasLayer(this.mapLayerGroup)) {
        this.mapLayerGroup.addTo(this.mapLeaflet);
      }

      // Clear all layers and remove routing
      this.mapLayerGroup.clearLayers();
      if (this.routingControl) {
        this.mapLeaflet.removeControl(this.routingControl);
        this.routingControl = null;
      }

      // Early exit if data is invalid
      if (!hasValidOrigin || !hasValidDestination) {
        this.mapLeaflet.setView(defaultCoords, 5);
        setTimeout(() => this.mapLeaflet.invalidateSize(), 200);
        // setTimeout(() => this.mapLeaflet.invalidateSize(), 1000);
        return;
      }

      // Origin marker and circle
      this.originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<div style="padding: 10px;"><b>Origin:</b><br>${origin}</div>`);
      this.originCircle = L.circle(originCoords, {
        radius: this.mapRadius,
        color: '#00bfff',
        fillColor: '#00bfff',
        weight: 1,
        fillOpacity: 0.2
      });
      this.mapLayerGroup.addLayer(this.originMarker).addLayer(this.originCircle);

      // Destination marker and circle
      this.destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<div style="padding: 10px;"><b>Destination:</b><br>${destination}</div>`);
      this.destCircle = L.circle(destCoords, {
        radius: this.mapRadius,
        color: '#ff5733',
        fillColor: '#ff5733',
        weight: 1,
        fillOpacity: 0.2
      });
      this.mapLayerGroup.addLayer(this.destMarker).addLayer(this.destCircle);

      // Add routing
      // @ts-ignore
      this.routingControl = L.Routing.control({
        waypoints: [
          L.latLng(originCoords),
          L.latLng(destCoords)
        ],
        routeWhileDragging: false,
        addWaypoints: false,
        draggableWaypoints: false,
        show: true,
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        // @ts-ignore
        formatter: new L.Routing.Formatter({
          formatInstruction: (instruction) => {
            const text = instruction.text;
            return (
              text.startsWith('Continue onto') ||
              text.startsWith('Exit the traffic circle') ||
              text.startsWith('Enter the traffic circle')
            ) ? '' : text;
          }
        }),
        createMarker: () => null
      }).addTo(this.mapLeaflet);

      // Fit bounds
      this.mapLeaflet.fitBounds(L.latLngBounds([originCoords, destCoords]), { padding: [50, 50] });

      // Refresh map
      setTimeout(() => this.mapLeaflet.invalidateSize(), 200);
      setTimeout(() => this.mapLeaflet.invalidateSize(), 1000);

    } catch (error) {
      console.error('Error showing origin/destination:', error);
    }
  }

  initializeLeafletMapWayPoint() {
    const containerEl2 = this.mapContainerRefWayPoint.nativeElement;
    const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

    // if (this.mapWayPoint || !containerEl2 || containerEl2._leaflet_id) {
    //   return;
    // }
    if (this.mapWayPoint) {
      this.mapWayPoint.remove(); // destroy existing map
      this.mapWayPoint = null;
    }
    this.mapWayPoint = L.map(containerEl2).setView(initialCoords1, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapWayPoint);

    // setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
    // setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
    // setTimeout(() => this.mapWayPoint.setZoom(7), 1000);

    this.showOriginDestinationWayPoint(this.Origin, this.Destination);
  }

  private isValidLatLng(lat: any, lng: any): boolean {
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);

    return (
      !isNaN(latNum) &&
      !isNaN(lngNum) &&
      latNum >= -90 && latNum <= 90 &&
      lngNum >= -180 && lngNum <= 180 &&
      !(latNum === 0 && lngNum === 0)
    );
  }

  // async showOriginDestinationWayPoint(origin: string, destination: string): Promise<void> {
  //   try {
  //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Center of India or your fallback center

  //     const isValidCoord = (lat: number, lng: number, lg: number) => lat && lng && lat !== 0 && lng !== 0;

  //     const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
  //     const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);
  //     const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0);

  //     const originCoords: L.LatLngExpression = hasValidOrigin
  //       ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
  //       : defaultCoords;

  //     const destCoords: L.LatLngExpression = hasValidDestination
  //       ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
  //       : defaultCoords;

  //     const cfsCoords: L.LatLngExpression = hasValidDestination
  //       ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
  //       : defaultCoords;

  //     // Initialize the map if needed
  //     if (!this.mapWayPoint) {
  //       this.mapWayPoint = L.map('Newmap').setView(defaultCoords, 5);
  //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  //       }).addTo(this.mapWayPoint);

  //       this.wayPointLayerGroup = L.layerGroup().addTo(this.mapWayPoint);
  //     }

  //     if (!this.mapWayPoint.hasLayer(this.wayPointLayerGroup)) {
  //       this.wayPointLayerGroup.addTo(this.mapWayPoint);
  //     }
  //     this.wayPointLayerGroup.clearLayers();

  //     if (this.routingControlWm) {
  //       this.mapWayPoint.removeControl(this.routingControlWm);
  //       this.routingControlWm = null;
  //     }

  //     // If no valid origin or destination, just show default view
  //     if (!hasValidOrigin || !hasValidDestination) {
  //       this.mapWayPoint.setView(defaultCoords, 5);
  //       setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
  //       setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
  //       return;
  //     }

  //     // Add origin marker and circle
  //     const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<b>Origin:</b><br>${origin}`);
  //     const originCircle = L.circle(originCoords, {
  //       radius: this.mapRadius,
  //       color: '#00bfff',
  //       fillColor: '#00bfff',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     });
  //     this.wayPointLayerGroup.addLayer(originMarker).addLayer(originCircle);

  //     // Add destination marker and circle
  //     const destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<b>Destination:</b><br>${destination}`);
  //     const destCircle = L.circle(destCoords, {
  //       radius: this.mapRadius,
  //       color: '#ff5733',
  //       fillColor: '#ff5733',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     });
  //     this.wayPointLayerGroup.addLayer(destMarker).addLayer(destCircle);

  //     // Add CFS marker and circle
  //     if (hasValidCFS) {
  //       const cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon }).bindPopup(`<b>CFS:</b><br>${this.CFSYARDAddress}`);
  //       const cfsCircle = L.circle(cfsCoords, {
  //         radius: this.mapRadius,
  //         color: '#ff5733',
  //         fillColor: '#ff5733',
  //         weight: 1,
  //         fillOpacity: 0.2
  //       });
  //       this.wayPointLayerGroup.addLayer(cfsMarker).addLayer(cfsCircle);
  //     }

  //     let wayPoints: L.LatLng[] = [];
  //     if (this.WayPoints && Array.isArray(this.WayPoints)) {
  //       wayPoints = this.WayPoints
  //         .filter(addr => this.isValidLatLng(addr.lat, addr.lng))
  //         .map(addr => L.latLng(addr.lat, addr.lng));

  //       this.WayPoints.forEach((addr, index) => {
  //         if (this.isValidLatLng(addr.lat, addr.lng)) {
  //           const waypointMarker = L.marker([addr.lat, addr.lng, 0], {
  //             icon: this.IdleIcon // Use a custom icon if you have one
  //           }).bindPopup(`<b>Waypoint ${index + 1}</b><br>Lat: ${addr.lat}<br>Lng: ${addr.lng}`);

  //           this.wayPointLayerGroup.addLayer(waypointMarker);
  //         }
  //       });
  //     }

  //     // Add routing
  //     // @ts-ignore
  //     this.routingControlWm = L.Routing.control({
  //       waypoints: [
  //         L.latLng(originCoords),
  //         L.latLng(destCoords),
  //         L.latLng(cfsCoords)
  //       ],
  //       routeWhileDragging: false,
  //       addWaypoints: false,
  //       draggableWaypoints: false,
  //       show: true,
  //       lineOptions: {
  //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
  //       },
  //       // @ts-ignore
  //       formatter: new L.Routing.Formatter({
  //         formatInstruction: (instruction) => {
  //           const text = instruction.text;
  //           return (
  //             text.startsWith('Continue onto') ||
  //             text.startsWith('Exit the traffic circle') ||
  //             text.startsWith('Enter the traffic circle')
  //           ) ? '' : text;
  //         }
  //       }),
  //       createMarker: () => null
  //     }).addTo(this.mapWayPoint);

  //     // Fit bounds
  //     const allCoords: L.LatLngTuple[] = [
  //       originCoords,
  //       destCoords,
  //       ...(hasValidCFS ? [cfsCoords] : []),
  //       ...wayPoints.map(wp => [wp.lat, wp.lng] as L.LatLngTuple)
  //     ];

  //     // Refresh map layout
  //     setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
  //     // setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
  //   } catch (error) {
  //     console.error('Error showing origin/destination with waypoints:', error);
  //   }
  // }

  async showOriginDestinationWayPoint(origin: string, destination: string): Promise<void> {
    try {
      const defaultCoords: [number, number, number] = [20.5937, 78.9629, 0]; // Center of India

      const isValidCoord = (lat: number, lng: number) =>
        lat !== undefined && lng !== undefined && lat !== 0 && lng !== 0;

      const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
      const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);
      const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude);

      const originCoords: L.LatLngTuple = hasValidOrigin
        ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
        : defaultCoords;

      const destCoords: L.LatLngTuple = hasValidDestination
        ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
        : defaultCoords;

      const cfsCoords: L.LatLngTuple = hasValidCFS
        ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
        : defaultCoords;

      // Initialize the map
      if (!this.mapWayPoint) {
        this.mapWayPoint = L.map('Newmap').setView(defaultCoords, 5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapWayPoint);
        this.wayPointLayerGroup = L.layerGroup().addTo(this.mapWayPoint);
      }

      if (!this.mapWayPoint.hasLayer(this.wayPointLayerGroup)) {
        this.wayPointLayerGroup.addTo(this.mapWayPoint);
      }
      this.wayPointLayerGroup.clearLayers();

      if (this.routingControlWm) {
        this.mapWayPoint.removeControl(this.routingControlWm);
        this.routingControlWm = null;
      }

      // If invalid, set default view
      if (!hasValidOrigin || !hasValidDestination) {
        this.mapWayPoint.setView(defaultCoords, 5);
        setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
        return;
      }

      // Add origin marker and circle
      const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<div style="padding: 10px;"><b>Origin:</b><br>${origin}</div>`);
      const originCircle = L.circle(originCoords, {
        radius: this.mapRadius,
        color: '#00bfff',
        fillColor: '#00bfff',
        weight: 1,
        fillOpacity: 0.2
      });
      this.wayPointLayerGroup.addLayer(originMarker).addLayer(originCircle);

      // Add destination marker and circle
      const destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<div style="padding: 10px;"><b>Destination:</b><br>${destination}</div>`);
      const destCircle = L.circle(destCoords, {
        radius: this.mapRadius,
        color: '#ff5733',
        fillColor: '#ff5733',
        weight: 1,
        fillOpacity: 0.2
      });
      this.wayPointLayerGroup.addLayer(destMarker).addLayer(destCircle);


      // Add CFS marker if valid
      if (hasValidCFS) {
        const cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon })
          .bindPopup(`<div style="padding: 10px;"><b>CFS:</b><br>${this.CFSYARDAddress}</div>`);
        const cfsCircle = L.circle(cfsCoords, {
          radius: this.mapRadius,
          color: '#8e44ad',
          fillColor: '#8e44ad',
          weight: 1,
          fillOpacity: 0.2
        });
        this.wayPointLayerGroup.addLayer(cfsMarker).addLayer(cfsCircle);
      }

      // Add intermediate waypoints
      let wayPoints: L.LatLng[] = [];
      if (Array.isArray(this.WayPoints)) {
        this.WayPoints.forEach((addr, index) => {
          if (this.isValidLatLng(addr.lat, addr.lng)) {
            const latlng = L.latLng(addr.lat, addr.lng);
            wayPoints.push(latlng);

            const wpMarker = L.marker(latlng, { icon: this.IdleIcon })
              .bindPopup(`<div style = "padding: 10px;"> <b>Vehicle No: </b>${addr.VehicleNo} (${addr.lat}, ${addr.lng})</div>`);
            this.wayPointLayerGroup.addLayer(wpMarker);
          }
        });
      }

      // Add routing line
      // @ts-ignore
      this.routingControlWm = L.Routing.control({
        waypoints: [
          L.latLng(originCoords),
          ...(hasValidCFS ? [L.latLng(cfsCoords)] : []),
          L.latLng(destCoords)
        ],
        routeWhileDragging: false,
        addWaypoints: false,
        draggableWaypoints: false,
        show: true,
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        createMarker: () => null
      }).addTo(this.mapWayPoint);

      // Fit all markers
      const allCoords: L.LatLngTuple[] = [
        originCoords,
        destCoords,
        ...(hasValidCFS ? [cfsCoords] : []),
        ...wayPoints.map(wp => [wp.lat, wp.lng] as L.LatLngTuple)
      ];

      const bounds = L.latLngBounds(allCoords);
      this.mapWayPoint.fitBounds(bounds, { padding: [50, 50] });


      setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
    } catch (error) {
      console.error('Error in showOriginDestinationWayPoint:', error);
    }
  }


  initializeLeafletMapWayPointTwo() {
    const containerEl2 = this.mapContainerRefWayPointTwo.nativeElement;
    const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

    // if (this.mapWayPointTwo || !containerEl2 || containerEl2._leaflet_id) {
    //   return;
    // }
    if (this.mapWayPointTwo) {
      this.mapWayPointTwo.remove(); // destroy existing map
      this.mapWayPointTwo = null;
    }
    this.mapWayPointTwo = L.map(containerEl2).setView(initialCoords1, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapWayPointTwo);

    // setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
    // setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);
    // setTimeout(() => this.mapWayPointTwo.setZoom(7), 1000);

    this.showOriginDestinationWayPointTwo(this.Origin, this.Destination);
  }

  // async showOriginDestinationWayPointTwo(): Promise<void> {
  //   try {
  //     const that = MapDetailsCardComponent.that;
  //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Fallback center

  //     const isValidCoord = (lat: number, lng: number, lg: number) =>
  //       typeof lat === 'number' && typeof lng === 'number' &&
  //       !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

  //     const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
  //     const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);
  //     const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0);

  //     const originCoords: L.LatLngTuple = hasValidOrigin
  //       ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
  //       : defaultCoords;

  //     const destCoords: L.LatLngTuple = hasValidDestination
  //       ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
  //       : defaultCoords;

  //     const cfsCoords: L.LatLngTuple = hasValidCFS
  //       ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
  //       : defaultCoords;

  //     // Initialize map if needed
  //     if (!this.mapWayPointTwo) {
  //       this.mapWayPointTwo = L.map('Newmap').setView(defaultCoords, 5);
  //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //         attribution: '&copy; OpenStreetMap contributors'
  //       }).addTo(this.mapWayPointTwo);
  //       this.mapLayerGroupWayPointTwo = L.layerGroup().addTo(this.mapWayPointTwo);
  //     }

  //     if (!this.mapWayPointTwo.hasLayer(this.mapLayerGroupWayPointTwo)) {
  //       this.wayPointLayerGroup.addTo(this.mapWayPointTwo);
  //     }
  //     this.mapLayerGroupWayPointTwo.clearLayers();

  //     if (this.routingControl) {
  //       this.mapWayPointTwo.removeControl(this.routingControl);
  //       this.routingControl = null;
  //     }

  //     // If any key coordinate is missing, show default view
  //     if (!hasValidOrigin || !hasValidDestination) {
  //       this.mapWayPointTwo.setView(defaultCoords, 5);
  //       setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
  //       // setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);
  //       return;
  //     }

  //     // Add markers and circles
  //     const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<b>Origin:</b><br>${origin}`);
  //     const originCircle = L.circle(originCoords, {
  //       radius: this.mapRadius,
  //       color: '#00bfff',
  //       fillColor: '#00bfff',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     });
  //     this.wayPointLayerGroup.addLayer(originMarker).addLayer(originCircle);

  //     const destMarker = L.marker(destCoords, { icon: this.originIcon }).bindPopup(`<b>Destination:</b><br>${that.Destination}`);
  //     const destCircle = L.circle(destCoords, {
  //       radius: this.mapRadius,
  //       color: '#ff5733',
  //       fillColor: '#ff5733',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     });
  //     this.wayPointLayerGroup.addLayer(destMarker).addLayer(destCircle);

    
  //     const cfsMarker = L.marker(destCoords, { icon: this.cfsIcon }).bindPopup(`<b>CFS:</b><br>${that.CFSYARDAddress}`);
  //     const cfsCircle = L.circle(destCoords, {
  //       radius: this.mapRadius,
  //       color: '#FFA500',
  //       fillColor: '#FFA500',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     });
  //     this.wayPointLayerGroup.addLayer(cfsMarker).addLayer(cfsCircle);

  //     // Build routing waypoints
  //     const routingWaypoints: L.LatLng[] = [L.latLng(cfsCoords), L.latLng(originCoords)];

  //     const midPoints = (this.WayPoints || [])
  //       .filter(wp => isValidCoord(wp.lat, wp.lng, 0))
  //       .map(wp => L.latLng(wp.lat, wp.lng));

  //     this.WayPoints.forEach((addr, index) => {
  //       if (this.isValidLatLng(addr.lat, addr.lng)) {
  //         const waypointMarker = L.marker([addr.lat, addr.lng, 0], {
  //           icon: this.IdleIcon // Use a custom icon if you have one
  //         }).bindPopup(`<b>Waypoint ${index + 1}</b><br>Lat: ${addr.lat}<br>Lng: ${addr.lng}`);

  //         this.wayPointLayerGroup.addLayer(waypointMarker);
  //       }
  //     });

  //     routingWaypoints.push(L.latLng(destCoords));

  //     // Add routing
  //     // @ts-ignore
  //     this.routingControl = L.Routing.control({
  //       waypoints: routingWaypoints,
  //       routeWhileDragging: false,
  //       addWaypoints: true,
  //       draggableWaypoints: false,
  //       show: true,
  //       lineOptions: {
  //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
  //       },
  //       // createMarker: (i, wp, n) => {
  //       //   let marker: L.Marker;

  //       //   // Common circle style function
  //       //   const createCircle = (latlng: L.LatLngExpression, color: string) =>
  //       //     L.circle(latlng, {
  //       //       radius: that.mapRadius,
  //       //       color,
  //       //       fillColor: color,
  //       //       weight: 1,
  //       //       fillOpacity: 0.2
  //       //     });

  //       //   if (hasValidCFS && i === 0) {
  //       //     marker = L.marker(wp.latLng, { icon: that.cfsIcon })
  //       //       .bindPopup(`<b>CFS</b><br>${that.CFSYARDAddress}`);
  //       //     that.wayPointLayerGroup.addLayer(createCircle(wp.latLng, '#FFA500'));

  //       //   } else if (hasValidCFS && i === 1) {
  //       //     marker = L.marker(wp.latLng, { icon: that.originIcon })
  //       //       .bindPopup(`<b>Origin</b><br>${that.Origin}`);
  //       //     that.wayPointLayerGroup.addLayer(createCircle(wp.latLng, '#00bfff'));

  //       //   } else if ((!hasValidCFS && i === 0) || i === n - 1) {
  //       //     marker = L.marker(wp.latLng, { icon: that.destinationIcon })
  //       //       .bindPopup(`<b>Destination</b><br>${that.Destination}`);
  //       //     that.wayPointLayerGroup.addLayer(createCircle(wp.latLng, '#ff5733'));

  //       //   } else {
  //       //     return null;
  //       //   }

  //       //   return marker;
  //       // },
  //       // @ts-ignore
  //       createMarker: () => null,
  //       // @ts-ignore
  //       formatter: new L.Routing.Formatter({
  //         formatInstruction: (text) => {
  //           if (
  //             text.startsWith('Continue onto') ||
  //             text.startsWith('Exit the traffic circle') ||
  //             text.startsWith('Enter the traffic circle')
  //           ) return '';
  //           return text;
  //         }
  //       })
  //     }).addTo(this.mapWayPointTwo);

  //     // Fit map to all relevant coordinates
  //     const allCoords: L.LatLngTuple[] = [originCoords, destCoords, cfsCoords, ...midPoints.map(mp => [mp.lat, mp.lng, 0] as L.LatLngTuple)];
  //     const bounds = L.latLngBounds(allCoords);
  //     this.mapWayPointTwo.fitBounds(bounds, { padding: [50, 50] });

  //     // Refresh view
  //     setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
  //     // setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);

  //   } catch (error) {
  //     console.error('Error showing origin/destination:', error);
  //   }
  // }

  async showOriginDestinationWayPointTwo(origin: string, destination: string): Promise<void> {
    try {
      const defaultCoords: [number, number, number] = [20.5937, 78.9629, 0]; // Center of India

      const isValidCoord = (lat: number, lng: number) =>
        lat !== undefined && lng !== undefined && lat !== 0 && lng !== 0;

      const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
      const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);
      const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude);

      const originCoords: L.LatLngTuple = hasValidOrigin
        ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
        : defaultCoords;

      const destCoords: L.LatLngTuple = hasValidDestination
        ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
        : defaultCoords;

      const cfsCoords: L.LatLngTuple = hasValidCFS
        ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
        : defaultCoords;

      // Initialize the map
      if (!this.mapWayPointTwo) {
        this.mapWayPointTwo = L.map('Newmap').setView(defaultCoords, 5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapWayPointTwo);
        this.mapLayerGroupWayPointTwo = L.layerGroup().addTo(this.mapWayPointTwo);
      }

      if (!this.mapWayPointTwo.hasLayer(this.mapLayerGroupWayPointTwo)) {
        this.mapLayerGroupWayPointTwo.addTo(this.mapWayPointTwo);
      }
      this.mapLayerGroupWayPointTwo.clearLayers();

      if (this.routingControlWm) {
        this.mapWayPointTwo.removeControl(this.routingControlWm);
        this.routingControlWm = null;
      }

      // If invalid, set default view
      if (!hasValidOrigin || !hasValidDestination) {
        this.mapWayPointTwo.setView(defaultCoords, 5);
        setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
        return;
      }

      // Add origin marker and circle
      const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<div style="padding: 10px;"><b>Origin:</b><br>${origin}</div>`);
      const originCircle = L.circle(originCoords, {
        radius: this.mapRadius,
        color: '#00bfff',
        fillColor: '#00bfff',
        weight: 1,
        fillOpacity: 0.2
      });
      this.mapLayerGroupWayPointTwo.addLayer(originMarker).addLayer(originCircle);

      // Add destination marker and circle
      const destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<div style="padding: 10px;"><b>Destination:</b><br>${destination}</div>`);
      const destCircle = L.circle(destCoords, {
        radius: this.mapRadius,
        color: '#ff5733',
        fillColor: '#ff5733',
        weight: 1,
        fillOpacity: 0.2
      });
      this.mapLayerGroupWayPointTwo.addLayer(destMarker).addLayer(destCircle);


      // Add CFS marker if valid
      if (hasValidCFS) {
        const cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon })
          .bindPopup(`<div style="padding: 10px;"><b>CFS:</b><br>${this.CFSYARDAddress}</div>`);
        const cfsCircle = L.circle(cfsCoords, {
          radius: this.mapRadius,
          color: '#8e44ad',
          fillColor: '#8e44ad',
          weight: 1,
          fillOpacity: 0.2
        });
        this.mapLayerGroupWayPointTwo.addLayer(cfsMarker).addLayer(cfsCircle);
      }

      // Add intermediate waypoints
      let wayPoints: L.LatLng[] = [];
      if (Array.isArray(this.WayPoints)) {
        this.WayPoints.forEach((addr, index) => {
          if (this.isValidLatLng(addr.lat, addr.lng)) {
            const latlng = L.latLng(addr.lat, addr.lng);
            wayPoints.push(latlng);

            const wpMarker = L.marker(latlng, { icon: this.IdleIcon })
              .bindPopup(`<div style = "padding: 10px;"> <b>Vehicle No: </b>${addr.VehicleNo} (${addr.lat}, ${addr.lng})</div>`);
            this.wayPointLayerGroup.addLayer(wpMarker);
          }
        });
      }

      // Add routing line
      // @ts-ignore
      this.routingControlWm = L.Routing.control({
        waypoints: [
          L.latLng(originCoords),
          ...(hasValidCFS ? [L.latLng(cfsCoords)] : []),
          L.latLng(destCoords)
        ],
        routeWhileDragging: false,
        addWaypoints: false,
        draggableWaypoints: false,
        show: true,
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        createMarker: () => null
      }).addTo(this.mapWayPointTwo);

      // Fit all markers
      const allCoords: L.LatLngTuple[] = [
        originCoords,
        destCoords,
        ...(hasValidCFS ? [cfsCoords] : []),
        ...wayPoints.map(wp => [wp.lat, wp.lng] as L.LatLngTuple)
      ];

      const bounds = L.latLngBounds(allCoords);
      this.mapWayPointTwo.fitBounds(bounds, { padding: [50, 50] });


      setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
    } catch (error) {
      console.error('Error in showOriginDestinationWayPoint:', error);
    }
  }

  initializeLeafletMapLiveTrack() {
    const containerEl2 = this.mapContainerLiveTracking.nativeElement;
    const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

    // if (this.mapLiveTracking || !containerEl2 || containerEl2._leaflet_id) {
    //   return;
    // }
    if (this.mapLiveTracking) {
      this.mapLiveTracking.remove(); // destroy existing map
      this.mapLiveTracking = null;
    }
    this.mapLiveTracking = L.map(containerEl2).setView(initialCoords1, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapLiveTracking);

    setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
    setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);

    setTimeout(() => this.showLiveTrackVehicleLeaflet(), 1000);
  }

  vehicleMarker: L.Marker | null = null; // Declare at class level
  // async showLiveTrackVehicle(): Promise<void> {
  //   try {
  //     const that = MapDetailsCardComponent.that;
  //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Fallback center

  //     const isValidCoord = (lat: number, lng: number, lg: number) =>
  //       typeof lat === 'number' && typeof lng === 'number' &&
  //       !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

  //     const hasValidCoords = isValidCoord(parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0);

  //     const liveTrackCoords: L.LatLngTuple = hasValidCoords
  //       ? [this.LiveTrackLatitude, this.LiveTrackLongtitude, 0]
  //       : defaultCoords;

  //     // Initialize map if needed
  //     if (!this.mapLiveTracking) {
  //       this.mapLiveTracking = L.map('Newmap').setView(defaultCoords, 5);
  //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //         attribution: '&copy; OpenStreetMap contributors'
  //       }).addTo(this.mapLiveTracking);
  //       this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
  //     }

  //     // Clear previous layers and routing
  //     this.mapLayerGroupLiveTracking.clearLayers();

  //     if (this.routingControl) {
  //       this.mapLiveTracking.removeControl(this.routingControl);
  //       this.routingControl = null;
  //     }

  //     // If any key coordinate is missing, show default view
  //     if (!hasValidCoords) {
  //       this.mapLiveTracking.setView(defaultCoords, 5);
  //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
  //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
  //       return;
  //     }

  //     // Add markers and circles
  //     const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
  //     const vehicleIcon = this.getRotatedIcon(bearing); // or use leaflet-rotatedmarker

  //     if (!this.vehicleMarker) {
  //       this.vehicleMarker = L.marker([this.LiveTrackLatitude, this.LiveTrackLongtitude, 0], {
  //         icon: vehicleIcon
  //       }).bindPopup(`
  //        <table>
  //         <tr>
  //           <td><b>Vehicle No</b></td>
  //           <td>${that.VehicleNo}</td>
  //         </tr>
  //         <tr>
  //           <td><b>Driver Name</b></td>
  //           <td>${that.Driver}</td>
  //         </tr>
  //         <tr>
  //           <td><b>Driver Mobile</b></td>
  //           <td>${that.DriverMobileNo}</td>
  //         </tr>
  //         <tr>
  //           <td><b>Track Through</b></td>
  //           <td>Sim</td>
  //         </tr>
  //         <tr>
  //           <td><b>Last Track</b></td>
  //           <td>${that.LastTrackDate}</td>
  //         </tr>
  //       </table>
  //       `);
  //       this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
  //     } else {
  //       this.vehicleMarker.setLatLng([this.LiveTrackLatitude, this.LiveTrackLongtitude, 0]);
  //       this.vehicleMarker.setIcon(vehicleIcon); // update bearing
  //     }

  //     // const originMarker = L.marker(liveTrackCoords, { icon: vehicleIcon }).bindPopup(`<b>Origin:</b><br>${that.Origin}`);
  //     // const originCircle = L.circle(liveTrackCoords, {
  //     //   radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
  //     // });

  //     this.mapLiveTracking.addLayer(this.vehicleMarker);
  //     // .addLayer(originCircle);

  //     // Add routing
  //     // @ts-ignore
  //     this.routingControl = L.Routing.control({
  //       waypoints: null,
  //       routeWhileDragging: false,
  //       addWaypoints: false,
  //       draggableWaypoints: false,
  //       show: true,
  //       lineOptions: {
  //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
  //       },
  //       createMarker: (i, wp, n) => {
  //         return L.marker(wp.latLng, { icon: vehicleIcon }).bindPopup(`<b>Vehicle No:</b>${that.VehicleNo}<br>
  //         <b>Driver Name:</b>${that.Driver}`);
  //       },
  //       // @ts-ignore
  //       formatter: new L.Routing.Formatter({
  //         formatInstruction: (text) => {
  //           if (
  //             text.startsWith('Continue onto') ||
  //             text.startsWith('Exit the traffic circle') ||
  //             text.startsWith('Enter the traffic circle')
  //           ) return '';
  //           return text;
  //         }
  //       })
  //     }).addTo(this.mapLiveTracking);

  //     // Fit map to all relevant coordinates
  //     const allCoords: L.LatLngTuple[] = [liveTrackCoords];
  //     const bounds = L.latLngBounds(allCoords);
  //     this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });

  //     // Refresh view
  //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
  //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);

  //   } catch (error) {
  //     console.error('Error showing origin/destination:', error);
  //   }
  // }

  // async showLiveTrackVehicle(): Promise<void> {
  //   try {
  //     const that = MapDetailsCardComponent.that;
  //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // India center as fallback

  //     // Helper to validate coordinates
  //     const isValidCoord = (lat: any, lng: any) =>
  //       !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng)) &&
  //       parseFloat(lat) !== 0 && parseFloat(lng) !== 0;

  //     const hasValidLiveCoords = isValidCoord(this.LiveTrackLatitude, this.LiveTrackLongtitude);
  //     const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
  //     const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);

  //     const liveTrackCoords: L.LatLngTuple = hasValidLiveCoords
  //       ? [parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0]
  //       : defaultCoords;

  //     const originCoords: L.LatLngTuple = hasValidOrigin
  //       ? [parseFloat(this.PickUpLatitude), parseFloat(this.PickUpLongtitude), 0]
  //       : defaultCoords;

  //     const destCoords: L.LatLngTuple = hasValidDestination
  //       ? [parseFloat(this.DeliverLatitude), parseFloat(this.DeliverLongtitude), 0]
  //       : defaultCoords;

  //     // Initialize map
  //     if (!this.mapLiveTracking) {
  //       this.mapLiveTracking = L.map('Newmap').setView(defaultCoords, 5);
  //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //         attribution: '&copy; OpenStreetMap contributors'
  //       }).addTo(this.mapLiveTracking);
  //       this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
  //     }

  //     this.mapLayerGroupLiveTracking.clearLayers();

  //     if (this.routingControl) {
  //       this.mapLiveTracking.removeControl(this.routingControl);
  //       this.routingControl = null;
  //     }

  //     if (!hasValidLiveCoords || !hasValidOrigin || !hasValidDestination) {
  //       this.mapLiveTracking.setView(defaultCoords, 5);
  //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
  //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
  //       return;
  //     }

  //     const originIcon = this.originIcon;
  //     const destinationIcon = this.destinationIcon;

  //     // Origin Marker & Circle
  //     const originMarker = L.marker(originCoords, { icon: originIcon })
  //       .bindPopup(`<b>Origin:</b><br>${that.Origin}`);
  //     const originCircle = L.circle(originCoords, {
  //       radius: this.mapRadius || 0,
  //       color: '#00bfff',
  //       fillColor: '#00bfff',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     }).bringToFront();
  //     this.mapLayerGroupLiveTracking.addLayer(originMarker).addLayer(originCircle);

  //     // Destination Marker & Circle
  //     const destMarker = L.marker(destCoords, { icon: destinationIcon })
  //       .bindPopup(`<b>Destination:</b><br>${that.Destination}`);
  //     const destCircle = L.circle(destCoords, {
  //       radius: this.mapRadius || 0,
  //       color: '#ff5733',
  //       fillColor: '#ff5733',
  //       weight: 1,
  //       fillOpacity: 0.2
  //     }).bringToFront();
  //     this.mapLayerGroupLiveTracking.addLayer(destMarker).addLayer(destCircle);

  //     // Bearing and Vehicle Icon
  //     const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
  //     const vehicleIcon = this.getRotatedIcon(bearing);

  //     if (!this.vehicleMarker) {
  //       this.vehicleMarker = L.marker(liveTrackCoords, {
  //         icon: vehicleIcon
  //       }).bindPopup(`
  //         <table>
  //           <tr><td><b>Vehicle No</b></td><td>${that.VehicleNo}</td></tr>
  //           <tr><td><b>Driver Name</b></td><td>${that.Driver}</td></tr>
  //           <tr><td><b>Driver Mobile</b></td><td>${that.DriverMobileNo}</td></tr>
  //           <tr><td><b>Track Through</b></td><td>Sim</td></tr>
  //           <tr><td><b>Last Track</b></td><td>${that.LastTrackDate}</td></tr>
  //         </table>`);
  //       this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
  //     } else {
  //       this.vehicleMarker.setLatLng(liveTrackCoords);
  //       this.vehicleMarker.setIcon(vehicleIcon);
  //     }

  //     this.mapLiveTracking.addLayer(this.vehicleMarker);
  //     this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);

  //     // Add Routing: Origin -> Live -> Destination
  //     // @ts-ignore
  //     this.routingControl = L.Routing.control({
  //       waypoints: [
  //         L.latLng(originCoords),
  //         L.latLng(liveTrackCoords),
  //         L.latLng(destCoords)
  //       ],
  //       routeWhileDragging: false,
  //       addWaypoints: false,
  //       draggableWaypoints: false,
  //       show: true,
  //       lineOptions: {
  //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
  //       },
  //       createMarker: (i, wp, n) => {
  //         if (i === 0) {
  //           // Add circle around origin
  //           const originCircle = L.circle(wp.latLng, {
  //             radius: 10000,  // radius in meters
  //             color: '#00bfff',
  //             fillColor: '#00bfff',
  //             fillOpacity: 0.2,
  //             weight: 1
  //           });
  //           this.mapLayerGroupLiveTracking.addLayer(originCircle);

  //           return L.marker(wp.latLng, { icon: this.originIcon }).bindPopup(`<b>Origin</b><br>${this.Origin}`);
  //         }
  //         // if (i === 1) return L.marker(wp.latLng, { icon: that.cfsIcon }).bindPopup(`<b>Origin</b><br>${that.Origin}`);
  //         if (i === n - 1) {
  //           // Add circle around destination
  //           const destCircle = L.circle(wp.latLng, {
  //             radius: this.mapRadius,
  //             color: '#ff5733',
  //             fillColor: '#ff5733',
  //             fillOpacity: 0.2,
  //             weight: 1
  //           });
  //           this.mapLayerGroupLiveTracking.addLayer(destCircle);

  //           return L.marker(wp.latLng, { icon: this.destinationIcon }).bindPopup(`<b>Destination</b><br>${this.Destination}`);
  //         }
  //         return null; // No marker for midpoints
  //       },
  //       // @ts-ignore
  //       formatter: new L.Routing.Formatter({
  //         formatInstruction: (text) => {
  //           if (
  //             text.startsWith('Continue onto') ||
  //             text.startsWith('Exit the traffic circle') ||
  //             text.startsWith('Enter the traffic circle')
  //           ) return '';
  //           return text;
  //         }
  //       })
  //     }).addTo(this.mapLiveTracking);

  //     // Fit all in view
  //     const bounds = L.latLngBounds([originCoords, liveTrackCoords, destCoords]);
  //     this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });

  //     // Refresh map
  //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
  //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
  //   } catch (error) {
  //     console.error('Error in showLiveTrackVehicle:', error);
  //   }
  // }

  InitialLoad: boolean = true;
  async showLiveTrackVehicleLeaflet(): Promise<void> {
    try {
      const that = MapDetailsCardComponent.that;
      const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // India center

      const isValidCoord = (lat: any, lng: any) =>
        !isNaN(parseFloat(lat)) &&
        !isNaN(parseFloat(lng)) &&
        parseFloat(lat) !== 0 &&
        parseFloat(lng) !== 0;

      const hasValidLiveCoords = isValidCoord(this.LiveTrackLatitude, this.LiveTrackLongtitude);
      const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
      const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);

      const liveTrackCoords: L.LatLngTuple = hasValidLiveCoords
        ? [parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0]
        : defaultCoords;

      const originCoords: L.LatLngTuple = hasValidOrigin
        ? [parseFloat(this.PickUpLatitude), parseFloat(this.PickUpLongtitude), 0]
        : defaultCoords;

      const destCoords: L.LatLngTuple = hasValidDestination
        ? [parseFloat(this.DeliverLatitude), parseFloat(this.DeliverLongtitude), 0]
        : defaultCoords;

      const radius = Number(this.mapRadius);

      // Initialize map only once
      if (!this.mapLiveTracking) {
        this.mapLiveTracking = L.map('LiveTrackingMap').setView(defaultCoords, 5);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapLiveTracking);
        this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
      }

      if (!this.mapLiveTracking.hasLayer(this.mapLayerGroupLiveTracking)) {
        this.mapLayerGroupLiveTracking.addTo(this.mapLiveTracking);
      }

      // Exit early if any coordinates are invalid
      if (!hasValidOrigin || !hasValidDestination) {
        this.mapLiveTracking.setView(defaultCoords, 5);
        setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
        setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
        return;
      }

      const originIcon = this.originIcon;
      const destinationIcon = this.destinationIcon;

      // Add origin marker & circle if not already added
      if (!this.originMarker) {
        this.originMarker = L.marker(originCoords, { icon: originIcon }).bindPopup(`<div style="padding: 10px;"><b>Origin:</b><br>${this.Origin}</div>`);
        this.originCircle = L.circle(originCoords, {
          radius: this.mapRadius,
          color: '#00bfff',
          fillColor: '#00bfff',
          fillOpacity: 0.2,
          weight: 1
        });
        this.mapLayerGroupLiveTracking.addLayer(this.originMarker).addLayer(this.originCircle);
      }

      // Add destination marker & circle if not already added
      if (!this.destMarker) {
        this.destMarker = L.marker(destCoords, { icon: destinationIcon }).bindPopup(`<div style="padding: 10px;"><b>Destination:</b><br>${this.Destination}</div>`);
        this.destCircle = L.circle(destCoords, {
          radius: this.mapRadius,
          color: '#ff5733',
          fillColor: '#ff5733',
          fillOpacity: 0.2,
          weight: 1
        });
        this.mapLayerGroupLiveTracking.addLayer(this.destMarker).addLayer(this.destCircle);
      }

      // Update or create vehicle marker
      const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
      const vehicleIcon = this.getRotatedIcon(bearing);

      if (!this.vehicleMarker) {
        this.vehicleMarker = L.marker(liveTrackCoords, {
          icon: vehicleIcon
        }).bindPopup(`
          <table style="padding: 10px;">
            <tr><td style="padding: 5px;"><b>Vehicle No</b></td><td style="padding: 5px;">${that.VehicleNo}</td></tr>
            <tr><td style="padding: 5px;"><b>Driver Name</b></td><td style="padding: 5px;">${that.Driver}</td></tr>
            <tr><td style="padding: 5px;"><b>Driver Mobile</b></td><td style="padding: 5px;">${that.DriverMobileNo}</td></tr>
            <tr><td style="padding: 5px;"><b>Track Through</b></td><td style="padding: 5px;">${that.TrackThrough}</td></tr>
            <tr><td style="padding: 5px;"><b>Last Track</b></td><td style="padding: 5px;">${that.LastTrackDate ? that.LastTrackDate : ""}</td></tr>
          </table>`);
        this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
      } else {
        this.vehicleMarker.setLatLng(liveTrackCoords);
        this.vehicleMarker.setIcon(vehicleIcon);
      }

      // Add routing control only once
      if (!this.routingControl) {
        // @ts-ignore
        this.routingControl = L.Routing.control({
          waypoints: [
            L.latLng(originCoords),
            L.latLng(liveTrackCoords),
            L.latLng(destCoords)
          ],
          routeWhileDragging: false,
          addWaypoints: false,
          draggableWaypoints: false,
          show: true,
          lineOptions: {
            styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
          },
          createMarker: (i, wp, n) => {
            if (i === 0) {
              return L.marker(wp.latLng, { icon: originIcon }).bindPopup(`<div style="padding: 10px;"><b>Origin:</b><br>${this.Origin}</div>`);
            }
            if (i === n - 1) {
              return L.marker(wp.latLng, { icon: destinationIcon }).bindPopup(`<div style="padding: 10px;"><b>Destination:</b><br>${this.Destination}</div>`);
            }
            return L.marker(wp.latLng, {
              icon: L.divIcon({ className: 'empty-marker' }),
              interactive: false
            });
          },
          // @ts-ignore
          formatter: L.Routing.Formatter ? new L.Routing.Formatter({
            formatInstruction: (text: string) => {
              if (
                text.startsWith('Continue onto') ||
                text.startsWith('Exit the traffic circle') ||
                text.startsWith('Enter the traffic circle')
              ) return '';
              return text;
            }
          }) : undefined
        }).addTo(this.mapLiveTracking);
      }

      // Adjust view
      if (this.InitialLoad == true) {
        const bounds = L.latLngBounds([originCoords, liveTrackCoords, destCoords]);
        this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });
      }

      setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
      setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);

      if (this.InitialLoad == true) {
        this.InitialLoad = false;
      }

    } catch (error) {
      console.error('Error in showLiveTrackVehicle:', error);
    }
  }

  showLiveTrackVehicle() {
    // Clear any existing markers if needed
    if (this.beachMarker && this.beachMarker.length) {
      this.beachMarker.forEach(marker => marker.setMap(null));
      this.beachMarker = [];
    }

    // Initialize the map
    // this.map = new google.maps.Map(document.getElementById("map"), {
    //   zoom: 18,
    //   center: {
    //     lat: this.LiveTrackLatitude,
    //     lng: this.LiveTrackLongtitude
    //   },
    //   mapTypeControl: true,
    //   mapTypeControlOptions: {
    //     position: google.maps.ControlPosition.TOP_RIGHT
    //   }
    // });

    // SVG icon for the vehicle
    var svgIcon = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';


    // Create the marker
    const bmMarker = new google.maps.Marker({
      position: {
        lat: this.LiveTrackLatitude,
        lng: this.LiveTrackLongtitude
      },
      map: this.map,
      icon: {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
        anchor: new google.maps.Point(21, 21),
        scaledSize: new google.maps.Size(42, 42)
      },
      title: this.VehicleNo
    });

    // InfoWindow
    const infoWindow = new google.maps.InfoWindow();

    bmMarker.addListener("click", () => {
      bmMarker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => {
        bmMarker.setAnimation(null);
      }, 2000);

      infoWindow.setContent(`
        <table style="table-layout: fixed;">
          <tr><td style="font-weight: bold">Vehicle No:</td><td>${this.VehicleNo}</td></tr>
          <tr><td style="font-weight: bold">Driver Name:</td><td>${this.Driver}</td></tr>
          <tr><td style="font-weight: bold">Driver Mobile:</td><td>${this.DriverMobileNo}</td></tr>
          <tr><td style="font-weight: bold">Last Tracked:</td><td>${this.LastTrackDate}&deg;</td></tr>
        </table>
      `);
      infoWindow.open(this.map, bmMarker);
    });

    // Store marker for later reference/removal
    this.beachMarker = [bmMarker];
  }

  vm_CalculateDegrees(start_latitude: any, start_longitude: any, stop_latitude: any, stop_longitude: any) {
    //Source
    var lat1 = parseFloat(start_latitude);
    var lng1 = parseFloat(start_longitude);

    // destination
    var lat2 = parseFloat(stop_latitude);
    var lng2 = parseFloat(stop_longitude);

    var fLat = this.degreeToRadians(lat1);
    var fLong = this.degreeToRadians(lng1);
    var tLat = this.degreeToRadians(lat2);
    var tLong = this.degreeToRadians(lng2);

    var dLon = (tLong - fLong);

    var degree = this.radiansToDegree(Math.atan2(Math.sin(dLon) * Math.cos(tLat),
      Math.cos(fLat) * Math.sin(tLat) - Math.sin(fLat) * Math.cos(tLat) * Math.cos(dLon)));

    if (degree >= 0) {
      this.VehicleDirectionDegree = degree;
    } else {
      this.VehicleDirectionDegree = 360 + degree;
    }

    var svg = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

    var icon = {
      anchor: new google.maps.Point(16, 16),
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),
      scale: 3,
      fillColor: "red",
      fillOpacity: 0.8,
      strokeWeight: 2,
      rotation: this.VehicleDirectionDegree //this is how to rotate the pointer
    };
    this.beachMarker[0].setIcon(icon);
  }

  calculateAndDisplayRouteV2(directionsService, directionsRenderer) {
    directionsService
      .route({
        origin: {
          query: this.Origin,
        },
        destination: {
          query: this.Destination,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);

        var route = response.routes[0];
        var bounds = new google.maps.LatLngBounds();
        route.legs.forEach(function (leg) {
          bounds.extend(leg.start_location);
          bounds.extend(leg.end_location);
        });

        // Calculate the center of the route
        var center = bounds.getCenter();

        // Draw a circle with a radius of 50km around the origin
        var originCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          map: this.map,
          center: route.legs[0].start_location,
          radius: this.mapRadius // km in meters
        });

        // Draw a circle with a radius of 50km around the destination
        var destinationCircle = new google.maps.Circle({
          strokeColor: '#00FF00',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#00FF00',
          fillOpacity: 0.35,
          map: this.map,
          center: route.legs[route.legs.length - 1].end_location,
          radius: this.mapRadius // km in meters
        });

        // Optionally, display the radius value on the map
        var originInfowindow = new google.maps.InfoWindow({
          content: "Origin Radius: 1km"
        });

        var destinationInfowindow = new google.maps.InfoWindow({
          content: "Destination Radius: 1km"
        });

        originInfowindow.open(this.map, originCircle);
        destinationInfowindow.open(this.map, destinationCircle);

      })
      .catch((e) => window.alert("Directions request failed due to " + status));
  }

  getBearing(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const toRad = (deg: number) => deg * Math.PI / 180;
    const toDeg = (rad: number) => rad * 180 / Math.PI;

    const dLng = toRad(lng2 - lng1);
    const y = Math.sin(dLng) * Math.cos(toRad(lat2));
    const x = Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
      Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLng);

    const bearing = toDeg(Math.atan2(y, x));
    return (bearing + 360) % 360; // Normalize to 0–360
  }

  getRotatedIcon(angle: number): L.DivIcon {
    var svg = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

    return L.divIcon({
      className: 'vehicle-icon',
      html: `
        <div style="
          width: 42px;
          height: 42px;
          transform: rotate(${angle}deg);
          transform-origin: center center;
        ">
          ${svg}
        </div>
      `,
      iconSize: [42, 42],
      iconAnchor: [21, 21]
    });
  }

  InitMapSelfFullFilled() {
    if (!this.UseLeafletMap) {
      const directionsService = new google.maps.DirectionsService();
      const directionsRenderer = new google.maps.DirectionsRenderer();
      const mapv2 = new google.maps.Map(document.getElementById("SelfFullfieldMap"), {
        zoom: 6,
        center: { lat: 41.85, lng: -87.65 }
      });

      directionsRenderer.setMap(mapv2);

      const geocoder = new google.maps.Geocoder(); // Geocoder to convert addresses into LatLng

      // This function will handle geocoding for each address
      const geocodeAddresses = async (addresses) => {
        const waypts = [];

        for (let i = 0; i < addresses.length; i++) {
          const loc = addresses[i];
          try {
            const result = await geocodeAddress(loc.location); // Geocode the address
            waypts.push({
              location: result,  // Add geocoded location
              stopover: true
            });

            // Create a marker for the geocoded location
            new google.maps.Marker({
              position: result,
              map: mapv2,
              label: '' //loc.tripNo,  // Label the marker with the order number
            });
          } catch (error) {
            console.error(`Geocode failed for address: ${loc.location}`, error);
          }
        }

        return waypts;  // Return the array of waypoints once all are geocoded
      };

      // Helper function to geocode an address and return a LatLng object
      const geocodeAddress = (address) => {
        return new Promise((resolve, reject) => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results[0].geometry.location);  // Return the LatLng object
            } else {
              reject(new Error('Geocode failed: ' + status));
            }
          });
        });
      };

      // Once geocoding is done, call the directions service
      geocodeAddresses(this.WayPoints).then((waypts) => {
        directionsService.route({
          origin: MapDetailsCardComponent.that.TransactionType === 'ContainerMovement' ? this.CFSYARDAddress : this.Origin,
          // origin: this.Origin,  // Ensure Origin is a LatLngLiteral or LatLng object
          destination: this.Destination,  // Ensure Destination is a LatLngLiteral or LatLng object
          // waypoints: waypts,  // Waypoints are set after geocoding
          waypoints: MapDetailsCardComponent.that.TransactionType === 'FTL' ? waypts : [{ location: this.Origin, stopover: true }],
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING
        }, (response, status) => {
          if (status === "OK") {
            directionsRenderer.setDirections(response);
            const route = response.routes[0];

            let totalDistance = 0;
            let totalDuration = 0;
            route.legs.forEach((leg) => {
              totalDistance += leg.distance.value;
              totalDuration += leg.duration.value;
            });

            setTimeout(() => {
              // Add polyline to show the route overview
              const polyline = new google.maps.Polyline({
                path: route.overview_path,  // The path is the polyline path
                strokeColor: "#3367FB", // Set polyline color
                strokeOpacity: 1.0,
                strokeWeight: 5,
              });
              polyline.setMap(mapv2);
            }, 1000);
          } else {
            // window.alert("Directions request failed due to " + status);
            this.toastr.error("Directions request failed due to " + status, "Error");
          }
        });
      }).catch((error) => {
        console.error('Error in geocoding waypoints:', error);
      });

      if (this.TransactionType == '') {
        this.calculateAndDisplayRouteForContainerMovement(directionsService, directionsRenderer);
      }
    } else {
      this.InitMapSelfFullFilledLeaflet();
    }
  }

  InitMapSelfFullFilledLeaflet() {
    const containerEl = this.mapContainerSelfFullfilled.nativeElement;
    var initialCoords = null;
    initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;

    if (this.mapSelfFullfilled) {
      this.mapSelfFullfilled.remove();
      this.mapSelfFullfilled = null;
    }

    this.mapSelfFullfilled = L.map(containerEl).setView(initialCoords, 7);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapSelfFullfilled);

    if (this.mapSelfFullfilled && this.mapContainerSelfFullfilled) {
      setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 100); // lower delay helps
    }
    // setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 200);
    // setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 1000);

    if (this.Origin && this.Destination) {
      setTimeout(() => this.showOriginDestinationSelfFullFilled(), 1000);
    }
  }

  async showOriginDestinationSelfFullFilled(): Promise<void> {
    try {
      const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0];

      const isValidCoord = (lat: number, lng: number) =>
        typeof lat === 'number' && typeof lng === 'number' &&
        !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

      const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
      const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);
      const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude);

      const originCoords: L.LatLngTuple = hasValidOrigin
        ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
        : defaultCoords;

      const destCoords: L.LatLngTuple = hasValidDestination
        ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
        : defaultCoords;

      const cfsCoords: L.LatLngTuple = hasValidCFS
        ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
        : defaultCoords;

      if (!this.mapSelfFullfilled) {
        this.mapSelfFullfilled = L.map('SelfFullfieldMap').setView(originCoords, 7);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapSelfFullfilled);
      }

      // Cleanup previous layers
      [this.originMarker, this.destMarker, this.originCircle, this.destCircle, this.routingControl, this.cfsMarker, this.cfsCircle]
        .forEach(layer => {
          if (layer) this.mapSelfFullfilled.removeLayer(layer);
        });

      var midPoints = [];
      // Waypoints and CFS
      const routingWaypoints: L.LatLng[] = [];
      if (this.IsDriveMapView) {
        // const { content: popupContent, ref: componentRef } = this.createDetailsPopup(this.SelectedInfo, this.orderDetails);
        // this.originMarker = L.marker(originCoords, { icon: this.DriverIcon })
        //   .bindPopup(popupContent, { maxWidth: 376 })
        //   .addTo(this.mapSelfFullfilled);

        // this.originMarker.on('popupclose', () => {
        //   this.appRef.detachView(componentRef.hostView);
        //   componentRef.destroy();
        // });

        // this.originCircle = L.circle(originCoords, {
        //   radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
        // }).addTo(this.mapSelfFullfilled);
      } 
      // else if(this.IsTollMapView){
      //   // Added by priya - 15/01/2026 - CN(PRIYA-JAN26-010)
      //   const { content: popupContent, ref: componentRef } = this.createDetailsPopup(this.SelectedOrderInfo, this.TollDetails);
      //   this.originMarker = L.marker(originCoords, { icon: this.originIcon })
      //     .bindPopup(popupContent, { maxWidth: 376 })
      //     .addTo(this.mapSelfFullfilled);

      //   this.originMarker.on('popupclose', () => {
      //     this.appRef.detachView(componentRef.hostView);
      //     componentRef.destroy();
      //   });

      //   this.originCircle = L.circle(originCoords, {
      //     radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
      //   }).addTo(this.mapSelfFullfilled);

      //   // Destination marker
      //   this.destMarker = L.marker(destCoords, { icon: this.destinationIcon })
      //     .bindPopup(popupContent, { maxWidth: 376 })
      //     .addTo(this.mapSelfFullfilled);

      //   this.destMarker.on('popupclose', () => {
      //     this.appRef.detachView(componentRef.hostView);
      //     componentRef.destroy();
      //   });

      //   this.destCircle = L.circle(destCoords, {
      //     radius: this.mapRadius, color: '#ff5733', fillColor: '#ff5733', weight: 1, fillOpacity: 0.2
      //   }).addTo(this.mapSelfFullfilled);


      //   if (this.TransactionType === 'ContainerMovement') {
      //     this.cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon })
      //       .bindPopup(popupContent, { maxWidth: 376 })
      //       .addTo(this.mapSelfFullfilled);

      //     this.cfsCircle = L.circle(cfsCoords, {
      //       radius: this.mapRadius, color: '#FFA500', fillColor: '#FFA500', weight: 1, fillOpacity: 0.2
      //     }).addTo(this.mapSelfFullfilled);

      //     routingWaypoints.push(L.latLng(cfsCoords[0], cfsCoords[1]));
      //   }

      //   routingWaypoints.push(L.latLng(originCoords[0], originCoords[1]));

      //   midPoints = this.WayPoints
      //     .filter(wp => wp.lat && wp.long && !isNaN(wp.lat) && !isNaN(wp.long))
      //     .map(wp => {
      //       const locationRow = [
      //         { deliveryTime: 'DeliveryTime', dataField10: 'Origin', dataField11: 'Destination', isLocationFTL: true }
      //       ];
      //       const currentlocationRow = [
      //         { label1: 'Current Location', dataField10: 'Origin', isOriginForCard: true }
      //       ];

      //       const vehicleDetails = {
      //         cardName: "",
      //         id: "Idle",
      //         listOfRow: [...this.vehicleDetailsIdle.listOfRow],
      //         footer: {
      //           actionBtn: false,
      //           actionList: [],
      //         },
      //         isHideFooter: true
      //       };

      //       if(!this.HideVehicleSvg){
      //         if (wp.VehicleStatus == 'In-Transit') {
      //           var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
      //             return row[0] && row[0].isHrLine;
      //           });
      //           vehicleDetails.listOfRow.push(
      //             [
      //               { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
      //               // { dataField: '', },
      //               { dataField: 'BookingNo', BookingId: 'BookingId', valueType: 'isTripRedirect', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
      //             ]
      //           )
      //           // Insert before the horizontal line row, if exists
      //           if (hrLineIndex !== -1) {
      //             vehicleDetails.listOfRow.splice(hrLineIndex, 0, locationRow);
      //           } else {
      //             vehicleDetails.listOfRow.push(locationRow); // fallback
      //           }
      //         } else {
      //           var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
      //             return row[0] && row[0].isHrLine;
      //           });
      //           vehicleDetails.listOfRow.push(
      //             [
      //               { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
      //               // { dataField: '', },
      //               { dataField: '', BookingId: '', valueType: '', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
      //             ]
      //           )
      //           // Insert before the horizontal line row, if exists
      //           if (hrLineIndex !== -1) {
      //             vehicleDetails.listOfRow.splice(hrLineIndex, 0, currentlocationRow);
      //           } else {
      //             vehicleDetails.listOfRow.push(currentlocationRow); // fallback
      //           }
      //         }
      //       }

      //       // Choose appropriate icon
      //       let icon;
      //       switch (wp.VehicleStatus) {
      //         case 'Idle':
      //           icon = this.IdleIcon;
      //           break;
      //         case 'In-Transit':
      //           icon = this.InTransitIcon;
      //           break;
      //         case 'Repair':
      //           icon = this.RepairIcon;
      //           break;
      //         default:
      //           icon = this.IdleIcon;
      //           break;
      //       }

      //       // Create popup content for this specific marker
      //       const { content: popupContent, ref: componentRef } = this.createDetailsPopup(wp, vehicleDetails);

      //       // Add marker with popup
      //       const marker = L.marker([wp.lat, wp.long, 0], { icon: icon })
      //         .bindPopup(popupContent, { maxWidth: 376 })
      //         .addTo(this.mapSelfFullfilled);

      //       marker.on('popupclose', () => {
      //         this.appRef.detachView(componentRef.hostView);
      //         componentRef.destroy();
      //       });

      //       return L.latLng(wp.lat, wp.long);
      //     });
      //   // routingWaypoints.push(...midPoints);
      //   routingWaypoints.push(L.latLng(destCoords[0], destCoords[1]));
      // } 
      else {
        // Origin marker
        const { content: popupContent, ref: componentRef } = this.createDetailsPopup(this.SelectedOrderInfo, this.orderDetails);
        this.originMarker = L.marker(originCoords, { icon: this.originIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapSelfFullfilled);

        this.originMarker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });

        this.originCircle = L.circle(originCoords, {
          radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
        }).addTo(this.mapSelfFullfilled);

        // Destination marker
        this.destMarker = L.marker(destCoords, { icon: this.destinationIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapSelfFullfilled);

        this.destMarker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });

        this.destCircle = L.circle(destCoords, {
          radius: this.mapRadius, color: '#ff5733', fillColor: '#ff5733', weight: 1, fillOpacity: 0.2
        }).addTo(this.mapSelfFullfilled);


        if (this.TransactionType === 'ContainerMovement') {
          this.cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon })
            .bindPopup(popupContent, { maxWidth: 376 })
            .addTo(this.mapSelfFullfilled);

          this.cfsCircle = L.circle(cfsCoords, {
            radius: this.mapRadius, color: '#FFA500', fillColor: '#FFA500', weight: 1, fillOpacity: 0.2
          }).addTo(this.mapSelfFullfilled);

          routingWaypoints.push(L.latLng(cfsCoords[0], cfsCoords[1]));
        }

        routingWaypoints.push(L.latLng(originCoords[0], originCoords[1]));

        midPoints = this.WayPoints
          .filter(wp => wp.lat && wp.long && !isNaN(wp.lat) && !isNaN(wp.long))
          .map(wp => {
            const locationRow = [
              { deliveryTime: 'DeliveryTime', dataField10: 'Origin', dataField11: 'Destination', isLocationFTL: true }
            ];
            const currentlocationRow = [
              { label1: 'Current Location', dataField10: 'Origin', isOriginForCard: true }
            ];

            const vehicleDetails = {
              cardName: "",
              id: "Idle",
              listOfRow: [...this.vehicleDetailsIdle.listOfRow],
              footer: {
                actionBtn: false,
                actionList: [],
              },
              isHideFooter: true
            };

            // const hrLineIndex = vehicleDetails.listOfRow.findIndex(row => Array.isArray(row) && row[0].isHrLine);
            // const rowToInsert = wp.VehicleStatus === 'In-Transit' ? locationRow : currentlocationRow;

            // if (hrLineIndex !== -1) {
            //   vehicleDetails.listOfRow.splice(hrLineIndex, 0, rowToInsert);
            // } else {
            //   vehicleDetails.listOfRow.push(rowToInsert);
            // }
          if(!this.HideVehicleSvg){
            if (wp.VehicleStatus == 'In-Transit') {
              var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
                return row[0] && row[0].isHrLine;
              });
              vehicleDetails.listOfRow.push(
                [
                  { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
                  // { dataField: '', },
                  { dataField: 'BookingNo', BookingId: 'BookingId', valueType: 'isTripRedirect', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
                ]
              )
              // Insert before the horizontal line row, if exists
              if (hrLineIndex !== -1) {
                vehicleDetails.listOfRow.splice(hrLineIndex, 0, locationRow);
              } else {
                vehicleDetails.listOfRow.push(locationRow); // fallback
              }
            } else {
              var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
                return row[0] && row[0].isHrLine;
              });
              vehicleDetails.listOfRow.push(
                [
                  { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
                  // { dataField: '', },
                  { dataField: '', BookingId: '', valueType: '', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
                ]
              )
              // Insert before the horizontal line row, if exists
              if (hrLineIndex !== -1) {
                vehicleDetails.listOfRow.splice(hrLineIndex, 0, currentlocationRow);
              } else {
                vehicleDetails.listOfRow.push(currentlocationRow); // fallback
              }
            }
          }

            // Choose appropriate icon
            let icon;
            switch (wp.VehicleStatus) {
              case 'Idle':
                icon = this.IdleIcon;
                break;
              case 'In-Transit':
                icon = this.InTransitIcon;
                break;
              case 'Repair':
                icon = this.RepairIcon;
                break;
              default:
                icon = this.IdleIcon;
                break;
            }

            // Create popup content for this specific marker
            const { content: popupContent, ref: componentRef } = this.createDetailsPopup(wp, vehicleDetails);

            // Add marker with popup
            const marker = L.marker([wp.lat, wp.long, 0], { icon: icon })
              .bindPopup(popupContent, { maxWidth: 376 })
              .addTo(this.mapSelfFullfilled);

            marker.on('popupclose', () => {
              this.appRef.detachView(componentRef.hostView);
              componentRef.destroy();
            });

            return L.latLng(wp.lat, wp.long);
          });


        // routingWaypoints.push(...midPoints);
        routingWaypoints.push(L.latLng(destCoords[0], destCoords[1]));
      }


      // Routing control WITHOUT automatic markers
      // @ts-ignore
      this.routingControl = L.Routing.control({
        waypoints: routingWaypoints,
        routeWhileDragging: false,
        addWaypoints: false,
        draggableWaypoints: false,
        show: true,
        createMarker: () => null, // ❌ disable default blue markers
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        // Optional formatter to hide unwanted directions
        // @ts-ignore
        formatter: new L.Routing.Formatter({
          formatInstruction: (text) => {
            if (
              text.startsWith('Continue onto') ||
              text.startsWith('Exit the traffic circle') ||
              text.startsWith('Enter the traffic circle')
            ) return '';
            return text;
          }
        })
      }).addTo(this.mapSelfFullfilled);

      // Zoom to fit all points
      const allCoords: L.LatLngExpression[] = [
        originCoords,
        destCoords,
        ...(this.TransactionType === 'ContainerMovement' ? [cfsCoords] : []),
        ...midPoints.map(mp => [mp.lat, mp.lng] as L.LatLngTuple)
      ];

      const bounds = L.latLngBounds(allCoords);
      this.mapSelfFullfilled.fitBounds(bounds, { padding: [50, 50] });

      setTimeout(() => this.mapSelfFullfilled.invalidateSize(), 200);

    } catch (error) {
      console.error('Error showing origin/destination:', error);
    }
  }

  InitMapViewPageLeaflet() {
    // Added by priya - 16/01/2026 - Added loader for toll map - cn(PRIYA-JAN26-011)
    if (this.IsTollMapView) {
      Helpers.setLoading(true); // START LOADER
    }
    const containerEl = this.mapContainerViewPage.nativeElement;
    var initialCoords = null;
    // Added and commented by priya - 16/01/2026 - displayed by default center of indian map on map screen - cn(PRIYA-JAN26-011)
    // initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;
    initialCoords = [22.0, 79.0] as L.LatLngExpression;

    if (this.mapViewPage) {
      this.mapViewPage.remove();
      this.mapViewPage = null;
    }

    this.mapViewPage = L.map(containerEl).setView(initialCoords, 5);

    const tileLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.mapViewPage);

    // Added by priya - 16/01/2026 - Loading map first - cn(PRIYA-JAN26-011)
    tileLayer.on('load', () => {
      if (this.IsTollMapView) {
        Helpers.setLoading(false); // ✅ MAP READY
      }
    });
    if (this.mapViewPage && this.mapContainerViewPage) {
      setTimeout(() => this.mapViewPage.invalidateSize(), 100); // lower delay helps
    }
    // setTimeout(() => this.mapViewPage.invalidateSize(), 200);
    // setTimeout(() => this.mapViewPage.invalidateSize(), 1000);

    // Added by priya - 16/01/2026 - calling function for toll map - cn(PRIYA-JAN26-011)
    if (this.IsTollMapView) {
      setTimeout(() => this.showTollMarkersDeferred(), 300);
    } else {
      this.showOriginDestinationViewPage();
    }
  }

  // Added by priya - 16/01/2026 -  displayed markers on map - cn(PRIYA-JAN26-011)
  private async showTollMarkersDeferred() {
    if (!this.mapViewPage) return;

    Helpers.setLoading(true); // START LOADER
    this.tollMarkerById.clear();
    this.isTollMarkerFocused = false;

    // Collect all toll markers
    const allMarkers: { point: L.LatLng, data: any, type: string }[] = [];

    this.OrderList.forEach(item => {
      if (!item.lat || !item.long) return;
      allMarkers.push({
        point: L.latLng(item.lat, item.long),
        data: item,
        type: 'toll'
      });
    });

    const BATCH_SIZE = 15;

    for (let i = 0; i < allMarkers.length; i += BATCH_SIZE) {
      const batch = allMarkers.slice(i, i + BATCH_SIZE);

      batch.forEach(({ point, data }) => {
        const { content: popupContent, ref: componentRef } = this.createDetailsPopup(data, this.TollDetails);

        const marker = L.marker(point, { icon: this.destinationLocIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapViewPage);

        if (data.Id) this.tollMarkerById.set(data.Id, marker);

        marker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });
      });

      // Give the UI a chance to update
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    // Fit map bounds to show all toll markers
    if (!this.isTollMarkerFocused && this.tollMarkerById.size > 0) {
      const bounds = L.latLngBounds(Array.from(this.tollMarkerById.values()).map(m => m.getLatLng()));
      if (bounds.isValid()) {
        this.mapViewPage.fitBounds(bounds, { padding: [50, 50] });
      }
    }
    Helpers.setLoading(false);
  }

  // Added by priya - 16/01/2026 -  TOLL MAP – CARD CLICK → FOCUS MARKER - cn(PRIYA-JAN26-011)
  private focusTollMarker(id: number) {
    const marker = this.tollMarkerById.get(id);
    if (!marker || !this.mapViewPage) return;

    Helpers.setLoading(true);

    const currentZoom = this.mapViewPage.getZoom();
    const targetZoom = Math.max(currentZoom, 7); // or 8-9 if you want closer

    this.mapViewPage.setView(marker.getLatLng(), targetZoom, { animate: true });
    marker.openPopup();

    this.isTollMarkerFocused = true;
    Helpers.setLoading(false);
  }

  // Added by priya - 16/01/2026 -  resetting markers on map when we filter or search from view - cn(PRIYA-JAN26-011)
  private async resetTollMarkers(newData: any[]) {
    if (!this.mapViewPage) return;

    Helpers.setLoading(true);

    // Remove existing markers from map
    this.tollMarkerById.forEach(marker => this.mapViewPage.removeLayer(marker));
    this.tollMarkerById.clear();
    this.isTollMarkerFocused = false;

    // Add new markers
    const BATCH_SIZE = 15;
    for (let i = 0; i < newData.length; i += BATCH_SIZE) {
      const batch = newData.slice(i, i + BATCH_SIZE);

      batch.forEach(item => {
        if (!item.lat || !item.long) return;

        const point = L.latLng(item.lat, item.long);
        const { content: popupContent, ref: componentRef } = this.createDetailsPopup(item, this.TollDetails);

        const marker = L.marker(point, { icon: this.destinationLocIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapViewPage);

        if (item.Id) this.tollMarkerById.set(item.Id, marker);

        marker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });
      });

      await new Promise(resolve => setTimeout(resolve, 50));
    }

    // Fit map to new markers
    if (this.tollMarkerById.size > 0) {
      const bounds = L.latLngBounds(Array.from(this.tollMarkerById.values()).map(m => m.getLatLng()));
      if (bounds.isValid()) {
        this.mapViewPage.fitBounds(bounds, { padding: [50, 50] });
      }
    }

    Helpers.setLoading(false);
  }

  originMarkers: L.Marker[] = [];
  destMarkers: L.Marker[] = [];
  cfsMarkers: L.Marker[] = [];
  originCircles: L.Circle[] = [];
  destCircles: L.Circle[] = [];
  cfsCircles: L.Circle[] = [];
  selectedOrder: any = {};
  selectedRowId: any = null;
  OrderData: any = [];
  vehicleMarkers: L.Marker[] = [];
  vehicleCircles: L.Circle[] = [];
  checkAll: boolean = true;
  async showOriginDestinationViewPage(): Promise<void> {
    try {
      const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0];

      const isValidCoord = (lat: number, lng: number) =>
        typeof lat === 'number' && typeof lng === 'number' &&
        !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

      const firstValidOrigin = this.OrderList.find(wp =>
        isValidCoord(wp.PickUpLatitude, wp.PickUpLongtitude)
      );
      const firstValidDestination = this.OrderList.find(wp =>
        isValidCoord(wp.DeliverLatitude, wp.DeliverLongtitude)
      );

      const originCoords: [number, number] = firstValidOrigin
        ? [firstValidOrigin.PickUpLatitude, firstValidOrigin.PickUpLongtitude]
        : [0, 0];

      const destCoords: [number, number] = firstValidDestination
        ? [firstValidDestination.DeliverLatitude, firstValidDestination.DeliverLongtitude]
        : [0, 0];

      const cfsCoords: [number, number] = firstValidDestination
        ? [firstValidDestination.CFSYARDLocationLatitude, firstValidDestination.CFSYARDLocationLongtitude]
        : [0, 0];

      if (!this.mapViewPage) {
        this.mapViewPage = L.map('SelfFullfieldMap').setView(defaultCoords, 7);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors'
        }).addTo(this.mapViewPage);
      }

      // Clear all existing map layers
      [this.originMarkers, this.destMarkers, this.cfsMarkers, this.originCircles, this.destCircles, this.cfsCircles, this.vehicleMarkers, this.vehicleCircles, this.routingControl].forEach(layerGroup => {
        if (layerGroup) {
          if (Array.isArray(layerGroup)) {
            layerGroup.forEach(layer => this.mapViewPage.removeLayer(layer));
          } else {
            this.mapViewPage.removeControl(layerGroup);
          }
        }
      });

      // Reset arrays
      this.originMarkers = [];
      this.destMarkers = [];
      this.cfsMarkers = [];
      this.originCircles = [];
      this.destCircles = [];
      this.cfsCircles = [];
      this.vehicleMarkers = [];
      this.vehicleCircles = [];

      var originLocationData = [];
      var destinationLocationData = [];
      var cfsLocationData = [];
      const hasBoth = this.selectedLocations.some(item => item.Label.toLowerCase() === 'both');
      if (hasBoth == true) {
        originLocationData = this.OrderList
          .filter(wp => isValidCoord(wp.PickUpLatitude, wp.PickUpLongtitude))
          .map(wp => {
            const [lat, lng] = this.getOffsetCoord(wp.PickUpLatitude, wp.PickUpLongtitude);
            return { point: L.latLng(lat, lng), data: wp };
          });

        destinationLocationData = this.OrderList
          .filter(wp => isValidCoord(wp.DeliverLatitude, wp.DeliverLongtitude))
          .map(wp => {
            const [lat, lng] = this.getOffsetCoord(wp.DeliverLatitude, wp.DeliverLongtitude);
            return { point: L.latLng(lat, lng), data: wp };
          });

        cfsLocationData = this.OrderList
          .filter(wp => isValidCoord(wp.CFSYARDLocationLatitude, wp.CFSYARDLocationLongtitude))
          .map(wp => {
            const [lat, lng] = this.getOffsetCoord(wp.CFSYARDLocationLatitude, wp.CFSYARDLocationLongtitude);
            return { point: L.latLng(lat, lng), data: wp };
          });
      } else {
        if (this.selectedLocations.length > 0) {
          const hasOrigin = this.selectedLocations.some(item => item.Label.toLowerCase() === 'origin');
          if (hasOrigin == true) {
            originLocationData = this.OrderList
              .filter(wp => isValidCoord(wp.PickUpLatitude, wp.PickUpLongtitude))
              .map(wp => {
                const [lat, lng] = this.getOffsetCoord(wp.PickUpLatitude, wp.PickUpLongtitude);
                return { point: L.latLng(lat, lng), data: wp };
              });
          }

          const hasDestination = this.selectedLocations.some(item => item.Label.toLowerCase() === 'destination');
          if (hasDestination == true) {
            destinationLocationData = this.OrderList
              .filter(wp => isValidCoord(wp.DeliverLatitude, wp.DeliverLongtitude))
              .map(wp => {
                const [lat, lng] = this.getOffsetCoord(wp.DeliverLatitude, wp.DeliverLongtitude);
                return { point: L.latLng(lat, lng), data: wp };
              });
          }

          const hascfs = this.selectedLocations.some(item => item.Label.toLowerCase() === 'cfs');
          if (hascfs == true) {
            cfsLocationData = this.OrderList
              .filter(wp => isValidCoord(wp.CFSYARDLocationLatitude, wp.CFSYARDLocationLongtitude))
              .map(wp => {
                const [lat, lng] = this.getOffsetCoord(wp.CFSYARDLocationLatitude, wp.CFSYARDLocationLongtitude);
                return { point: L.latLng(lat, lng), data: wp };
              });
          }
        }
      }


      var vehicleLocationData = null;
      const hasAll = this.selectedOwnerships.some(item => item.Label.toLowerCase() === 'all');

      if (hasAll == true) {
        vehicleLocationData = this.VehicleList
          .filter(wp => isValidCoord(wp.lat, wp.long))
          .map(wp => {
            const [lat, lng] = this.getOffsetCoord(wp.lat, wp.long);
            return { point: L.latLng(lat, lng), data: wp };
          });
      } else {
        if (this.selectedOwnerships.length > 0) {
          const selectedLabels = this.selectedOwnerships.map(o => o.Label.toLowerCase());
          vehicleLocationData = this.VehicleList
            .filter(wp =>
              isValidCoord(wp.lat, wp.long) &&
              wp.OwnershipName && selectedLabels.includes(wp.OwnershipName.toLowerCase())
            )
            .map(wp => {
              const [lat, lng] = this.getOffsetCoord(wp.lat, wp.long);
              return { point: L.latLng(lat, lng), data: wp };
            });
        } else {
          vehicleLocationData = [];
        }
      }

      const bounds = L.latLngBounds([]);

      // Add origin markers
      originLocationData.forEach(({ point, data }) => {
        // Added condition for toll map by priya - 15/01/2026 - CN(PRIYA-JAN26-010)
        const popupResult = this.IsTollMapView
          ? this.createDetailsPopup(data, this.TollDetails)
          : this.createDetailsPopup(data, this.orderDetails);

        const { content: popupContent, ref: componentRef } = popupResult;

        const marker = L.marker(point, { icon: this.originLocIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapViewPage);
        this.originMarkers.push(marker);

        marker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });

        const circle = L.circle(point, {
          radius: this.mapRadius || 500,
          color: '#00bfff',
          fillColor: '#00bfff',
          fillOpacity: 0.2,
          weight: 1
        }).addTo(this.mapViewPage);
        this.originCircles.push(circle);

        bounds.extend(circle.getBounds());
      });

      // Add destination markers
      destinationLocationData.forEach(({ point, data }) => {
        // Added condition for tollmap by priya - 15/01/2026 - CN(PRIYA-JAN26-010)
        const popupResult = this.IsTollMapView
          ? this.createDetailsPopup(data, this.TollDetails)
          : this.createDetailsPopup(data, this.orderDetails);

        const { content: popupContent, ref: componentRef } = popupResult;
        //const { content: popupContent, ref: componentRef } = this.createDetailsPopup(data, this.orderDetails);

        const marker = L.marker(point, { icon: this.destinationLocIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapViewPage);
        this.destMarkers.push(marker);

        // // 🔥 REGISTER FOR TOLL MAP ONLY
        // if (this.IsTollMapView && data.Id) {
        //   this.tollMarkerById.set(data.Id, marker);
        // }

        marker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });

        const circle = L.circle(point, {
          radius: this.mapRadius || 500,
          color: '#ff5733',
          fillColor: '#ff5733',
          fillOpacity: 0.2,
          weight: 1
        }).addTo(this.mapViewPage);
        this.destCircles.push(circle);

        bounds.extend(circle.getBounds());
      });

      // Add cfs markers
      cfsLocationData.forEach(({ point, data }) => {
        const { content: popupContent, ref: componentRef } = this.createDetailsPopup(data, this.orderDetails);

        const marker = L.marker(point, { icon: this.cfsLocIcon })
          .bindPopup(popupContent, { maxWidth: 376 })
          .addTo(this.mapViewPage);
        this.cfsMarkers.push(marker);

        marker.on('popupclose', () => {
          this.appRef.detachView(componentRef.hostView);
          componentRef.destroy();
        });

        const circle = L.circle(point, {
          radius: this.mapRadius || 500,
          color: '#8e44ad',
          fillColor: '#8e44ad',
          fillOpacity: 0.2,
          weight: 1
        }).addTo(this.mapViewPage);
        this.cfsCircles.push(circle);

        bounds.extend(circle.getBounds());
      });

      // Add vehicle markers
        vehicleLocationData.forEach(({ point, data }) => {
          const locationRow = [
            { deliveryTime: 'DeliveryTime', dataField10: 'Origin', dataField11: 'Destination', isLocationFTL: true }
          ];
          const currentlocationRow = [
            { label1: 'Current Location', dataField10: 'Origin', isOriginForCard: true }
          ];
          var tripRow = [];
          const vehicleDetails = {
            cardName: "",
            id: "Idle",
            listOfRow: [...this.vehicleDetailsIdle.listOfRow],
            footer: {
              actionBtn: false,
              actionList: [],
            },
            isHideFooter: true
          };
          if (!this.IsDriveMapView) {
            // Added condition by priya - 15/01/2026 - CN(PRIYA-JAN26-010)
            if (!this.HideVehicleSvg) {
              if (data.VehicleStatus == 'In-Transit') {
                var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
                  return row[0] && row[0].isHrLine;
                });
                vehicleDetails.listOfRow.push(
                  [
                    { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
                    // { dataField: '', },
                    { dataField: 'BookingNo', BookingId: 'BookingId', valueType: 'isTripRedirect', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
                  ]
                )
                // Insert before the horizontal line row, if exists
                if (hrLineIndex !== -1) {
                  vehicleDetails.listOfRow.splice(hrLineIndex, 0, locationRow);
                } else {
                  vehicleDetails.listOfRow.push(locationRow); // fallback
                }
              } else {
                var hrLineIndex = vehicleDetails.listOfRow.findIndex(function (row) {
                  return row[0] && row[0].isHrLine;
                });
                vehicleDetails.listOfRow.push(
                  [
                    { dataField: 'VehicleTypes', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/truck.svg', IsVehicleOnwership: true, OwneshipType: 'OwnershipName' },
                    // { dataField: '', },
                    { dataField: '', BookingId: '', valueType: '', isIcon: true, logoIcon: '../../../../assets/svg/FTL List/Trip.svg', color: 'var(--colors-primary-blue-blue-200, #3367FB)' }
                  ]
                )
                // Insert before the horizontal line row, if exists
                if (hrLineIndex !== -1) {
                  vehicleDetails.listOfRow.splice(hrLineIndex, 0, currentlocationRow);
                } else {
                  vehicleDetails.listOfRow.push(currentlocationRow); // fallback
                }
              }
            }
          }

          const { content: popupContent, ref: componentRef } = this.createDetailsPopup(data, vehicleDetails);

          let icon;
          if (!this.IsDriveMapView) {
            if (data.VehicleStatus == 'Idle') {
              icon = this.IdleIcon;
            } else if (data.VehicleStatus == 'In-Transit') {
              icon = this.InTransitIcon;
            } else if (data.VehicleStatus == 'Repair') {
              icon = this.RepairIcon;
            } else {
              icon = this.IdleIcon;
            }
          } else {
            icon = this.DriverIcon;
          }
          const marker = L.marker(point, { icon: icon })
            .bindPopup(popupContent, { maxWidth: 376 })
            .addTo(this.mapViewPage);
          this.vehicleMarkers.push(marker);

          marker.on('popupclose', () => {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
          });

          const circle = L.circle(point, {
            radius: this.mapRadius || 500,
            color: '#ffa500',
            fillColor: '#ffa500',
            fillOpacity: 0.2,
            weight: 1
          }).addTo(this.mapViewPage);
          this.vehicleCircles.push(circle);

          bounds.extend(circle.getBounds());
        });

      if (isValidCoord(destCoords[0], destCoords[1])) {
        bounds.extend(L.latLng(destCoords[0], destCoords[1]));
      }

      // if (bounds.isValid()) {
      //   this.mapViewPage.fitBounds(bounds, { padding: [50, 50] });
      // } else {
      //   this.mapViewPage.setView(defaultCoords, 7);
      // }

      // setTimeout(() => {
      //   const MAX_ALLOWED_ZOOM = 15;
      //   if (this.mapViewPage.getZoom() > MAX_ALLOWED_ZOOM) {
      //     this.mapViewPage.setZoom(7);
      //   }
      // }, 500);

      const routingWaypoints: L.LatLng[] = [];

      if (isValidCoord(originCoords[0], originCoords[1])) {
        routingWaypoints.push(L.latLng(originCoords[0], originCoords[1]));
      }

      routingWaypoints.push(...originLocationData.map(d => d.point));

      if (isValidCoord(destCoords[0], destCoords[1])) {
        routingWaypoints.push(L.latLng(destCoords[0], destCoords[1]));
      }

      // Routing logic (optional - uncomment if needed)
      /*
      this.routingControl = L.Routing.control({
        waypoints: routingWaypoints,
        routeWhileDragging: false,
        addWaypoints: true,
        draggableWaypoints: false,
        show: true,
        lineOptions: {
          styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
        },
        createMarker: (i, wp, n) => {
          if (i === 0) {
            return L.marker(wp.latLng).bindPopup(`<b>Origin</b><br>${this.Origin || ''}`);
          } else if (i === n - 1) {
            return L.marker(wp.latLng).bindPopup(`<b>Destination</b><br>${this.Destination || ''}`);
          } else {
            const wpData = this.OrderList[i - 1];
            return L.marker(wp.latLng).bindPopup(`<b>Vehicle No</b><br>Vehicle No: ${wpData?.VehicleNo || 'N/A'}`);
          }
        },
        formatter: new L.Routing.Formatter({
          formatInstruction: (text) => {
            if (
              text.startsWith('Continue onto') ||
              text.startsWith('Exit the traffic circle') ||
              text.startsWith('Enter the traffic circle')
            ) return '';
            return text;
          }
        })
      }).addTo(this.mapViewPage);
      */

      // this.mapViewPage.setZoom(7);
      // this.mapViewPage.fitBounds(bounds, { padding: [50, 50] });
        this.mapViewPage.setZoom(7);
        this.mapViewPage.fitBounds(bounds, { padding: [50, 50] });
      // setTimeout(() => this.mapViewPage.invalidateSize(), 200);
      // setTimeout(() => this.mapViewPage.invalidateSize(), 1000);

    } catch (error) {
      console.error('Error showing origin/destination:', error);
    }
  }

  private createDetailsPopup(orderData: any, orderDetails: any, Typ = null): { content: HTMLElement, ref: ComponentRef<DetailsCardComponent> } {
    const factory = this.componentFactoryResolver.resolveComponentFactory(DetailsCardComponent);
    const componentRef = factory.create(this.injector);

    componentRef.instance.data = orderData;
    componentRef.instance.cardDetails = orderDetails;
    componentRef.instance.isTableCardView = true;
    componentRef.instance.isActive = false;

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;

    return { content: domElem, ref: componentRef };
  }

  coordCountMap = new Map<string, number>();
  getOffsetCoord(lat: number, lng: number): [number, number] {
    const key = `${lat.toFixed(5)},${lng.toFixed(5)}`;
    const count = this.coordCountMap.get(key) || 0;

    const offsetDistance = 0.0001; // ~11 meters, adjust as needed
    const angle = count * 45; // Degrees to spread in different directions

    const offsetLat = lat + offsetDistance * Math.cos(angle * Math.PI / 180);
    const offsetLng = lng + offsetDistance * Math.sin(angle * Math.PI / 180);

    this.coordCountMap.set(key, count + 1);
    return [offsetLat, offsetLng];
  }

  BookingVehicleListForMap() {
    if (this.VehicleList.length <= 0) {
      this._appService.GetById("OrdersByVehicle", "BookingVehicleListForMap", this.CompanyId).subscribe((response) => {
        this.VehicleList = [];
        this.VehicleList = response;

        if (this.IsDriveMapView) {
          this.VehicleList = this.VehicleList.filter(v => v.DriverId !== null && v.DriverId !== undefined);
        }
      },
        (err) => {
          this.UseLeafletMapInitialized = false;
          this.toastr.error("Error occurred while fetching Status data !", "error");
        });
    }
  }

  openMenu: string | null = null;
  toggleMenu(menu: string): void {
    this.openMenu = this.openMenu === menu ? null : menu;
    this.cdr.detectChanges();
  }

  // Close dropdown if clicking outside
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.location-container')) {
      this.openMenu = null;
      this.cdr.detectChanges();
    }
  }

  selectedOwnerships: any = [];
  selectedLocations: any = [];
  onCheckBoxClick(event: boolean, row: any, type: any) {
    if (type == 'Vehicle') {
      if (event === true) {
        if (!row) {
          row = { Id: null, Label: 'All' };
        }

        // Avoid duplicates
        const exists = this.selectedOwnerships.some(item => item.Label.toLowerCase() === row.Label.toLowerCase());
        if (!exists) {
          this.selectedOwnerships.push(row);
        }
      } else {
        if (!row) {
          row = { Id: null, Label: 'All' };
        }
        // Remove matching record
        this.selectedOwnerships = this.selectedOwnerships.filter(
          item => item.Label.toLowerCase() !== row.Label.toLowerCase()
        );
      }
    } else {
      if (event === true) {
        if (!row) {
          row = { Id: null, Label: 'Both' };
        }

        // Avoid duplicates
        const exists = this.selectedLocations.some(item => item.Label.toLowerCase() === row.Label.toLowerCase());
        if (!exists) {
          this.selectedLocations.push(row);
        }
      } else {
        if (!row) {
          row = { Id: null, Label: 'Both' };
        }
        // Remove matching record
        this.selectedLocations = this.selectedLocations.filter(
          item => item.Label.toLowerCase() !== row.Label.toLowerCase()
        );
      }
    }
    this.showOriginDestinationViewPage();
  }

  clearFilter() {
    this.IsViewSingleMap = false;
    this.IsViewPageMap = true;
    this.IsSelfFullfilledMap = false;
    this.BookingVehicleListForMap();

    setTimeout(() => {
      this.InitMapViewPageLeaflet();
    }, 200);
  }

}


// liftlef map backup code
// import {
//   AfterViewChecked,
//   AfterViewInit,
//   Component,
//   ElementRef,
//   EventEmitter,
//   HostListener,
//   Input,
//   OnChanges,
//   OnInit,
//   Output,
//   SimpleChanges,
//   ViewChild,
// } from "@angular/core";
// import { TranslateService } from "@ngx-translate/core";
// import * as L from "leaflet";
// import { CommonService } from "../../services/commen/commen.services";
// import { DatePipe } from "@angular/common";
// import { Http } from "@angular/http";
// import { ActivatedRoute, Router } from "@angular/router";
// import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
// import { CookieService } from "ngx-cookie-service";
// import { ToastrService } from "ngx-toastr";
// import { appService } from "../../../_services/app.service";
// import { DecryptPipe } from "../../../auth/_services/encrypt-decrypt.pipe";
// import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
// import { OrdersService } from "../../services/orders/orders.service";
// import { Helpers } from "../../../helpers";
// import { IDetails } from "../details-card/model/IDetails";
// import 'leaflet-routing-machine';
// import { environment } from "../../../../environments/environment";
// declare var google: any;
// // delete (L.Icon.Default.prototype as any)._getIconUrl;

// // L.Icon.Default.mergeOptions({
// //   iconRetinaUrl: 'assets/img/leaflet/images/marker-icon-2x.png',
// //   iconUrl: 'assets/img/leaflet/images/marker-icon.png',
// //   shadowUrl: 'assets/img/leaflet/images/marker-shadow.png',
// // });

// @Component({
//   selector: "app-map-details-card",
//   templateUrl: "./map-details-card.component.html",
//   styleUrls: ["./map-details-card.component.scss"],
// })
// export class MapDetailsCardComponent implements AfterViewInit, OnChanges, AfterViewChecked {
//   // private map: L.Map;
//   // private map: L.Map;
//   @ViewChild('mapContainer') mapContainerRef: ElementRef;
//   private map: L.Map | null = null;
//   @ViewChild('WayPointMap') mapContainerRefWayPoint: ElementRef;
//   private mapWayPoint: L.Map | null = null;
//   @ViewChild('WayPointMapTwo') mapContainerRefWayPointTwo: ElementRef;
//   private mapWayPointTwo: L.Map | null = null;
//   @ViewChild('LiveTrackingMap') mapContainerLiveTracking: ElementRef;
//   private mapLiveTracking: L.Map | null = null;
//   beachMarker: any;
//   @Input() PickUpLatitude: any;
//   @Input() PickUpLongtitude: any;
//   @Input() DeliverLatitude: any;
//   @Input() DeliverLongtitude: any;
//   @Input() Origin: any;
//   @Input() Destination: any;
//   @Input() data: any;
//   @Input() addressData: any;
//   svg: any;
//   static that: MapDetailsCardComponent;
//   Distance: any;
//   TraavelTime: any;
//   @Output() OnCatchData = new EventEmitter<any>();
//   isGPS: boolean = false;
//   @Input() BookingId: any;
//   @Input() ConsignmentDetailId: any;
//   liveTrackData: any = { orderDetailsList: [{ starRating: "" }] };
//   VehicleDirectionDegree: any = 0;
//   position: any = [40.748774, -73.985763];
//   numDeltas: any = 60000;
//   delay: any = 600; //milliseconds
//   i: any = 0;
//   deltaLat: any;
//   deltaLng: any;
//   GPSUrl: any;
//   selectedDriverId: any;
//   fullAddress: any
//   currentUrl: any;
//   isShowMap: boolean = false
//   @Output() isShowMapChange = new EventEmitter<boolean>();
//   IsMapShow: boolean;
//   WayPointsres: any = [];
//   LiveTrackingThrowWarehouseLatLongFlage: any = false;
//   TripRouteBaseOnDeliveryDateFlag: any = false;
//   OrderDestinationLocation: any = [];
//   OrderInfoLatLong: any = [{ origin: 'jamnagar', destination: 'jamnagar' }];
//   @Input() IsWayPointsMap: boolean = false;
//   @Input() WayPoints: any = [];
//   @Input() CFSYARDLocationLatitude: any;
//   @Input() CFSYARDLocationLongtitude: any;
//   @Input() CFSYARDAddress: any;
//   @Input() FTLType: any;
//   @Input() IsWayPointsMapTwo: boolean = false;
//   mapPickup: any;
//   originIcon = L.icon({
//     iconUrl: 'assets/img/leaflet/images/origin.png',
//     iconSize: [24, 24],
//     iconAnchor: [12, 12],       // Center of circle
//     popupAnchor: [0, -12]       // Popup shows above center
//   });
//   destinationIcon = L.icon({
//     iconUrl: 'assets/img/leaflet/images/destination.png',
//     iconSize: [24, 24],
//     iconAnchor: [12, 12],
//     popupAnchor: [0, -12]
//   });
//   cfsIcon = L.icon({
//     iconUrl: 'assets/img/leaflet/images/cfs.png',
//     iconSize: [24, 24],
//     iconAnchor: [12, 12],       // Center of circle
//     popupAnchor: [0, -12]       // Popup shows above center
//   });
//   @Input() TabName: any;
//   private cfsMarker: L.Marker;
//   cfsCircle: any;
//   private mapLayerGroupWayPointTwo: L.LayerGroup = L.layerGroup();
//   private mapLayerGroup: L.LayerGroup = L.layerGroup();
//   private originMarker: L.Marker;
//   private destMarker: L.Marker;
//   private routingControl: any;
//   originCircle: any;
//   destCircle: any;
//   private wayPointLayerGroup: L.LayerGroup = L.layerGroup();
//   @Input() IsLiveTracking: boolean = false;
//   @Input() LiveTrackLatitude: any;
//   @Input() LiveTrackLongtitude: any;
//   private mapLayerGroupLiveTracking: L.LayerGroup = L.layerGroup();
//   svgImg: any = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';
//   svgIcon = L.divIcon({
//     className: '',  // remove default class styles
//     html: this.svgImg,      // this is your full SVG string
//     iconSize: [42, 42],         // size of the div container
//     iconAnchor: [21, 21],       // center the icon
//     popupAnchor: [0, -21]       // adjust popup position if needed
//   });
//   @Input() PrevLiveTrackLatitude: any;
//   @Input() PrevLiveTrackLongtitude: any;
//   hostUrl: any = 'https://sawariya.ifreightbox.net/';// environment.apiUrl;
//   @Input() DriverMobileNo: any;
//   mockCoordinatesIndex = 0;
//   mockCoordinates = [
//     { latitude: 19.3322, longitude: 73.1664 }, // Start - Antariksh Logidrome, Bhiwandi
//     { latitude: 19.4010, longitude: 73.2390 }, // Moving east
//     { latitude: 19.4800, longitude: 73.3100 }, // Between Padgha and Atgaon
//     { latitude: 19.5600, longitude: 73.3900 }, // Moving through rural area
//     { latitude: 19.6300, longitude: 73.4700 }, // Toward Igatpuri area
//     { latitude: 19.7100, longitude: 73.5700 }, // Ghat section start
//     { latitude: 19.8000, longitude: 73.6500 }, // Moving on Mumbai-Nashik highway
//     { latitude: 19.8800, longitude: 73.7100 }, // Near Nashik outskirts
//     { latitude: 19.9400, longitude: 73.7600 }, // Inside Nashik city
//     { latitude: 19.9974, longitude: 73.7898 }, // Final - Approx Nashik location
//   ];
//   @Input() VehicleNo: any;
//   @Input() Driver: any;

//   constructor(
//     private route: ActivatedRoute,
//     private _appService: appService,
//     private toastr: ToastrService,
//     private cookieService: CookieService,
//     private translate: TranslateService,
//     private anghttp: Http,
//     private commonService: CommonService,
//     private decryptpipe: DecryptPipe,
//     private service: TranslateConfigService,
//     private modalService: NgbModal,
//     private orderService: OrdersService,
//     private router: Router,
//     private dp: DatePipe
//   ) {
//     MapDetailsCardComponent.that = this;

//     // setTimeout(() => {
//     //   if (this.BookingId != null && this.BookingId != "") {
//     //     setInterval(function () {
//     //       if (MapDetailsCardComponent.that.isGPS == false) {
//     //         MapDetailsCardComponent.that.getDriverCurrentLatLong();
//     //       }
//     //     }, 5000);

//     //     setInterval(function () {
//     //       if (MapDetailsCardComponent.that.isGPS == true) {
//     //         MapDetailsCardComponent.that.getDriverCurrentLatLong_GPS();
//     //       }
//     //     }, 5000);
//     //   }
//     // }, 2500);
//   }

//   ngOnInit() {
//     this.svg =
//       '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' +
//       this.VehicleDirectionDegree +
//       ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

//     this.selectedDriverId = this.route.snapshot.params['id'] ? this.route.snapshot.params['id'] : this.selectedDriverId;
//     this.currentUrl = this.router.url;
//     // if (this.currentUrl.includes('so_Orders')) {
//     //   this.getSOAddresstoPlot()
//     // }
//     // if (this.currentUrl.includes('NewDriver/view')) {
//     //   this.getFullAddress()
//     // }
//     // this.LoadLiveTrackingThrowWarehouseLatLong();
//     // this.LoadTripRouteBaseOnDeliveryDate();

//     // setTimeout(() => {

//     //   if (
//     //     this.PickUpLatitude == null ||
//     //     this.PickUpLatitude == undefined ||
//     //     this.PickUpLongtitude == null ||
//     //     this.PickUpLongtitude == undefined
//     //   )
//     //     this.getLatLng(this.Origin, "Origin");

//     //   if (
//     //     this.DeliverLatitude == null ||
//     //     this.DeliverLatitude == undefined ||
//     //     this.DeliverLongtitude == null ||
//     //     this.DeliverLongtitude == undefined
//     //   )
//     //     this.getLatLng(this.Destination, "Destination");

//     //   setTimeout(() => {
//     //     if (this.BookingId != null && this.BookingId != "") {
//     //       this.GetLiveTrackListForBooking();
//     //     } else {
//     //       this.initializeMap();
//     //     }
//     //   }, 500);

//     // }, 2500); // Adjust delay as needed
//     const showMap = localStorage.getItem('showMap');
//     if (showMap) {
//       this.IsMapShow = true;
//     } else {
//       this.IsMapShow = false
//     }
//     this.getMapRadius();


//     let intervalTime;
//     let index = 0;
//     if (MapDetailsCardComponent.that.hostUrl === 'https://sawariya.ifreightbox.net/') {
//       intervalTime = 5000;
//       setInterval(() => {
//         if (this.BookingId && this.DriverMobileNo) {
//           //Testing
//           // if (index >= this.mockCoordinates.length) {
//           //   clearInterval(intervalTime);
//           //   return;
//           // }
//           MapDetailsCardComponent.that.GetTrackingDataContinusSawariya(this.BookingId, this.DriverMobileNo);
//         }
//       }, intervalTime);
//     }
//   }

//   LastTrackDate: any;
//   GetTrackingDataContinusSawariya(BookingId, DriverMobileNo) {
//     this._appService
//       .GetByTwoId("OrdersByVehicle", "GetTrackingDataSawariya", BookingId, DriverMobileNo)
//       .subscribe(
//         (response) => {
//           this.PrevLiveTrackLatitude = this.LiveTrackLatitude;
//           this.PrevLiveTrackLongtitude = this.LiveTrackLongtitude;
//           this.LiveTrackLatitude = response[0].latitude;
//           this.LiveTrackLongtitude = response[0].longitude;
//           this.LastTrackDate = response[0].CreatedDate;

//           this.showLiveTrackVehicle();
//         },
//         (err) => {

//         }
//       );


//     //Testing
//     // const location = this.mockCoordinates[this.mockCoordinatesIndex];

//     // // Update previous and current coordinates
//     // this.PrevLiveTrackLatitude = this.LiveTrackLatitude;
//     // this.PrevLiveTrackLongtitude = this.LiveTrackLongtitude;

//     // this.LiveTrackLatitude = location.latitude;
//     // this.LiveTrackLongtitude = location.longitude;

//     // this.showLiveTrackVehicle(); // Show movement on map

//     // // Move to next coordinate, loop if at end
//     // this.mockCoordinatesIndex = (this.mockCoordinatesIndex + 1) % this.mockCoordinates.length;
//   }


//   ngOnDestroy() {
//     if (this.map) {
//       this.map.remove();
//       this.map = null;
//     }

//     if (this.mapWayPoint) {
//       this.mapWayPoint.remove();
//       this.mapWayPoint = null;
//     }

//     if (this.mapWayPointTwo) {
//       this.mapWayPointTwo.remove();
//       this.mapWayPointTwo = null;
//     }
//   }

//   ngAfterViewInit(): void {
//     if (this.mapContainerRefWayPoint && !this.mapWayPoint && this.IsWayPointsMap) {
//       this.initializeLeafletMapWayPoint();
//     } else if (this.mapContainerRefWayPointTwo && !this.mapWayPointTwo && this.IsWayPointsMapTwo) {
//       this.initializeLeafletMapWayPointTwo();
//     } else if (this.mapContainerLiveTracking && !this.mapLiveTracking && this.IsLiveTracking) {
//       this.initializeLeafletMapLiveTrack();
//     } else if (this.mapContainerRef && !this.map && !this.IsWayPointsMap && !this.IsWayPointsMapTwo && !this.IsLiveTracking) {
//       this.initializeLeafletMap();
//     }
//   }

//   ngAfterViewChecked(): void {
//     // if (!this.mapPickup && document.getElementById('Newmap')) {
//     //   this.initMap();
//     // }
//   }

//   // ngOnChanges(changes: SimpleChanges) {
//   //   if (changes['data']) {
//   //     this.getFullAddress();

//   //     setTimeout(() => {
//   //       this.initializeMap();
//   //     }, 500);
//   //   }

//   //   if (changes['BookingId'] && changes['Destination'] && changes['Origin']) {

//   //     this.BookingId = changes['BookingId'].currentValue;
//   //     this.Destination = changes['Destination'].currentValue;
//   //     this.Origin = changes['Origin'].currentValue;

//   //     if (this.Origin != null && this.Origin != "" && this.Destination != null && this.Destination != "") {
//   //       this.getLatLng(this.Origin, 'Origin');
//   //       this.getLatLng(this.Destination, 'Destination');
//   //       if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement') {
//   //         this.getLatLng(this.CFSYARDAddress, 'CFSYARDLocation');
//   //       }
//   //     }
//   //     setTimeout(() => {

//   //       if (this.BookingId != null && this.BookingId != "" && this.Origin != null && this.Origin != "" && this.Destination != null && this.Destination != "") {
//   //         setTimeout(() => {
//   //           if (this.IsWayPointsMap) {
//   //             if (this.BookingId != null && this.BookingId != "") {
//   //               this.IsMapShow = true;
//   //               this.InitWayPointsMap();
//   //             }
//   //           } else if (this.IsWayPointsMapTwo) {
//   //             if (this.BookingId != null && this.BookingId != "") {
//   //               this.IsMapShow = true;
//   //               this.InitWayPointsMapTwo();
//   //             }
//   //           } else {
//   //             if (this.BookingId != null && this.BookingId != "") {
//   //               alert(this.BookingId);
//   //               this.GetLiveTrackListForBooking();
//   //             } else {
//   //               this.initializeMap();
//   //             }
//   //           }
//   //         }, 500);

//   //         // setInterval(function () {
//   //         //   if (MapDetailsCardComponent.that.isGPS == false) {
//   //         //     MapDetailsCardComponent.that.getDriverCurrentLatLong();
//   //         //   }
//   //         // }, 5000);

//   //         // setInterval(function () {
//   //         //   if (MapDetailsCardComponent.that.isGPS == true) {
//   //         //     MapDetailsCardComponent.that.getDriverCurrentLatLong_GPS();
//   //         //   }
//   //         // }, 5000);
//   //       } else {
//   //         if (this.Origin != null && this.Origin != "" && this.Destination != null && this.Destination != ""){
//   //           this.initializeMap();
//   //         }
//   //       }
//   //     }, 5000);
//   //   }
//   // }

//   private isLiveTrackCalled = false; // Flag to prevent multiple calls
//   ngOnChanges(changes: SimpleChanges) {
//     // if (changes['data']) {
//     //   this.getFullAddress();

//     //   setTimeout(() => {
//     //     this.initializeMap();
//     //   }, 500);
//     // }
//     if (changes['TabName']) {
//       this.TabName = changes['TabName'].currentValue;
//       if (this.TabName == 'Details') {
//         this.IsWayPointsMap = false;

//         if (this.map) {
//           setTimeout(() => this.map.invalidateSize(), 200);
//           setTimeout(() => this.map.invalidateSize(), 1000);
//         }
//       } else if (this.TabName == 'Trips') {
//         this.IsWayPointsMap = true;
//         if (this.mapWayPoint) {
//           setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
//           setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
//         }
//       }
//     }

//     // if (changes['Destination'] && changes['Origin']) {
//     // Reset the flag when BookingId changes
//     if (changes['BookingId']) {
//       if (changes['BookingId'].previousValue !== changes['BookingId'].currentValue) {
//         this.isLiveTrackCalled = false;
//       }
//     }

//     const keys = [
//       'BookingId',
//       'Destination',
//       'Origin',
//       'PickUpLatitude',
//       'PickUpLongtitude',
//       'DeliverLatitude',
//       'DeliverLongtitude',
//       'CFSYARDLocationLatitude',
//       'CFSYARDLocationLongtitude',
//       'CFSYARDAddress'
//     ];

//     for (const key of keys) {
//       const change = changes[key];
//       if (change) {
//         // Only update if there is a valid current value
//         if (change.currentValue !== undefined) {
//           // Specifically for Origin and Destination, only update if there's a change
//           if (key === 'Destination' || key === 'Origin') {
//             if (change.previousValue !== change.currentValue) {
//               (this as any)[key] = change.currentValue;
//             }
//           } else {
//             // For other keys, just update the value
//             (this as any)[key] = change.currentValue;
//           }
//         }
//       }
//     }
//     setTimeout(() => {
//       if (this.Origin && this.Origin !== "" && this.Destination && this.Destination !== "") {
//         setTimeout(() => {
//           if (this.BookingId && this.BookingId !== "") {
//             if (this.IsWayPointsMap) {
//               this.IsMapShow = true;
//               this.showOriginDestinationWayPoint(this.Origin, this.Destination);
//             } else if (this.IsWayPointsMapTwo) {
//               this.IsMapShow = true;
//               this.showOriginDestinationWayPointTwo();
//             } else if (this.IsLiveTracking == true) {
//               this.showLiveTrackVehicle();
//             } else {
//               this.showOriginDestination(this.Origin, this.Destination);
//             }

//             if (!this.isLiveTrackCalled) {
//               this.IsMapShow = false;
//               this.isLiveTrackCalled = true; // Prevent multiple calls unless BookingId changes
//               //this.GetLiveTrackListForBooking();
//             }
//           } else {
//             if (this.IsWayPointsMapTwo) {
//               this.IsMapShow = true;
//               this.showOriginDestinationWayPointTwo();
//             } else {
//               this.showOriginDestination(this.Origin, this.Destination);
//             }
//           }
//         }, 500);

//         // Uncomment if needed
//         // setInterval(() => {
//         //   if (!MapDetailsCardComponent.that.isGPS) {
//         //     MapDetailsCardComponent.that.getDriverCurrentLatLong();
//         //   }
//         // }, 5000);

//         // setInterval(() => {
//         //   if (MapDetailsCardComponent.that.isGPS) {
//         //     MapDetailsCardComponent.that.getDriverCurrentLatLong_GPS();
//         //   }
//         // }, 5000);
//       }
//     }, 5000);
//     // }


//   }


//   getLatLng(address: string, from: string) {

//     const geocoder = new google.maps.Geocoder();
//     geocoder.geocode({ address: address }, (results, status) => {
//       console.log('address:', address, 'from:', from, 'results:', results, 'status:', status);
//       if (status === "OK") {
//         const location = results[0].geometry.location;
//         if (from === "Origin") {
//           this.PickUpLatitude = location.lat();
//           this.PickUpLongtitude = location.lng();
//         }
//         if (from === "Destination") {
//           this.DeliverLatitude = location.lat();
//           this.DeliverLongtitude = location.lng();
//         }
//         if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement') {
//           if (from === "CFSYARDLocation") {
//             this.CFSYARDLocationLatitude = location.lat();
//             this.CFSYARDLocationLongtitude = location.lng();
//           }
//         }
//         if (from == "SOaddress") {
//           this.PickUpLatitude = location.lat();
//           this.PickUpLongtitude = location.lng();
//           this.DeliverLatitude = location.lat();
//           this.DeliverLongtitude = location.lng();
//         }
//         this.isShowMap = true; // Successfully found location
//       } else {
//         this.isShowMap = false; // Failed to find location
//         console.log("Geocode was not successful for the following reason: " + status);
//       }
//     });
//     this.isShowMapChange.emit(this.isShowMap);
//   }

//   WayPointsMap: any;
//   initializeMap() {

//     // const directionsService = new google.maps.DirectionsService();
//     // const directionsRenderer = new google.maps.DirectionsRenderer();
//     // if (this.fullAddress) {
//     //   this.map = new google.maps.Map(document.getElementById("map"), {
//     //     zoom: 13,
//     //     center: {
//     //       lat: MapDetailsCardComponent.that.PickUpLatitude ? MapDetailsCardComponent.that.DeliverLatitude : 41.85,
//     //       lng: MapDetailsCardComponent.that.PickUpLongtitude ? MapDetailsCardComponent.that.PickUpLongtitude : -87.65
//     //     },
//     //   });
//     //   const infoWindow = new google.maps.InfoWindow();
//     //   this.beachMarker = new google.maps.Marker({
//     //     position: {
//     //       lat: MapDetailsCardComponent.that.DeliverLatitude,
//     //       lng: MapDetailsCardComponent.that.DeliverLongtitude,
//     //     },
//     //     map: this.map,
//     //     icon: {
//     //       anchor: new google.maps.Point(16, 16),
//     //       url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
//     //       scale: 3,
//     //       fillColor: "red",
//     //       fillOpacity: 0.8,
//     //       strokeWeight: 2,
//     //       rotation: this.VehicleDirectionDegree,
//     //     },
//     //     title: this.fullAddress,
//     //   });
//     //   this.beachMarker.addListener("click", () => {
//     //     this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
//     //     setTimeout(() => {
//     //       this.beachMarker.setAnimation(null);
//     //     }, 2000);
//     //   });

//     //   this.beachMarker.setMap(this.map);
//     //   directionsRenderer.setMap(this.map);
//     //   this.calculateAndDisplayRoute(directionsService, directionsRenderer);
//     // } else {
//     //   this.map = new google.maps.Map(document.getElementById("map"), {
//     //     zoom: 6,
//     //     center: {
//     //       lat: this.liveTrackData.driverLocationLAT
//     //         ? this.liveTrackData.driverLocationLAT
//     //         : 41.85,
//     //       lng: this.liveTrackData.driverLocationLNG
//     //         ? this.liveTrackData.driverLocationLNG
//     //         : -87.65,
//     //     },
//     //   });
//     //   const image = "../../assets/img/truck_inactive.png";
//     //   const infoWindow = new google.maps.InfoWindow();
//     //   this.beachMarker = new google.maps.Marker({
//     //     position: {
//     //       lat: this.liveTrackData.driverLocationLAT,
//     //       lng: this.liveTrackData.driverLocationLNG,
//     //     },
//     //     map: this.map,
//     //     // icon: image,
//     //     icon: {
//     //       anchor: new google.maps.Point(16, 16),
//     //       url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
//     //       scale: 3,
//     //       fillColor: "red",
//     //       fillOpacity: 0.8,
//     //       strokeWeight: 2,
//     //       rotation: this.VehicleDirectionDegree, //this is how to rotate the pointer
//     //     },
//     //     title: this.liveTrackData.vehicleNo,
//     //   });
//     //   this.beachMarker.addListener("click", () => {
//     //     this.beachMarker.setAnimation(google.maps.Animation.BOUNCE);
//     //     setTimeout(() => {
//     //       this.beachMarker.setAnimation(null);
//     //     }, 2000);
//     //     infoWindow.close();
//     //     infoWindow.setContent(
//     //       '<table style="table-layout: fixed;">' +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Vehicle No:</td>' +
//     //       "<td>" +
//     //       (this.liveTrackData.vehicleNo
//     //         ? this.liveTrackData.vehicleNo
//     //         : "N/A") +
//     //       "</td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Driver:</td>' +
//     //       "<td>" +
//     //       (this.liveTrackData.driverName
//     //         ? this.liveTrackData.driverName
//     //         : "N/A") +
//     //       "</td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Driver Mobile No:</td>' +
//     //       "<td>" +
//     //       (this.liveTrackData.driverMobileNo
//     //         ? this.liveTrackData.driverMobileNo
//     //         : "N/A") +
//     //       "</td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Last Tracked:</td>' +
//     //       "<td>" +
//     //       this.liveTrackData.LastTracked +
//     //       "</td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Speed:</td>' +
//     //       "<td>" +
//     //       this.liveTrackData.Speed +
//     //       "</td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Status:</td>' +
//     //       "<td><b>" +
//     //       this.liveTrackData.TrackStatus +
//     //       "</b></td>" +
//     //       "</tr>" +
//     //       "<tr>" +
//     //       '<td style="font-weight: bold">Track By:</td>' +
//     //       "<td><b>" +
//     //       this.liveTrackData.TrackThrough +
//     //       "</b></td>" +
//     //       "</tr>" +
//     //       "</table>"
//     //     );
//     //     infoWindow.open(this.beachMarker.getMap(), this.beachMarker);
//     //   });

//     //   this.beachMarker.setMap(this.map);
//     //   directionsRenderer.setMap(this.map);
//     //   this.calculateAndDisplayRoute(directionsService, directionsRenderer);
//     // }
//   }

//   calculateAndDisplayRoute(directionsService, directionsRenderer) {
//     if (!directionsService || !directionsRenderer) {
//       console.error(
//         "DirectionsService or DirectionsRenderer is not initialized."
//       );
//       return;
//     }

//     if (!this.Origin || !this.Destination) {
//       console.error("Origin or Destination is not set.");
//       return;
//     }

//     directionsService
//       .route({
//         origin: this.Origin,
//         destination: this.Destination,
//         travelMode: google.maps.TravelMode.DRIVING,
//       })
//       .then((response) => {
//         directionsRenderer.setDirections(response);
//         const route = response.routes[0].legs[0];
//         const distance = route.distance.text; // e.g., "2,459 km"
//         const duration = route.duration.text; // e.g., "24 hours 30 mins"

//         var obj: any = {};
//         obj.distance = distance;
//         obj.duration = duration;
//         MapDetailsCardComponent.that.OnCatchData.emit(obj);
//       })
//       .catch((e) => {
//         console.error(e);
//         // window.alert("Directions request failed due to " + e.message);
//         this.toastr.error("Directions request failed due to " + e.message, "Error");
//       });
//   }

//   getDriverCurrentLatLong() {
//     this._appService
//       .GetByTwoId(
//         "Booking",
//         "LT_getDriverCurrentLatLong",
//         this.BookingId,
//         this.ConsignmentDetailId
//       )
//       .subscribe(
//         (response) => {
//           var objOldLatLong: any = [
//             this.liveTrackData.driverLocationLAT,
//             this.liveTrackData.driverLocationLNG,
//           ];
//           if (response.length > 0) {
//             if (
//               this.liveTrackData.driverLocationLAT == null ||
//               this.liveTrackData.driverLocationLNG == null
//             ) {
//               objOldLatLong = [
//                 response[0].driverLocationLAT,
//                 response[0].driverLocationLNG,
//               ];
//             }
//             var newOldLatLong: any = [
//               response[0].driverLocationLAT,
//               response[0].driverLocationLNG,
//             ];
//             if (
//               this.liveTrackData.driverLocationLAT != newOldLatLong[0] &&
//               this.liveTrackData.driverLocationLNG != newOldLatLong[1]
//             ) {
//               this.transition(newOldLatLong, objOldLatLong);
//             }
//             this.liveTrackData.driverLocationLAT =
//               response[0].driverLocationLAT;
//             this.liveTrackData.driverLocationLNG =
//               response[0].driverLocationLNG;
//             this.liveTrackData.LastTracked = response[0].LastTracked;
//             this.liveTrackData.TrackStatus = response[0].TrackStatus;
//             this.liveTrackData.TrackThrough = response[0].TrackThrough;
//             this.liveTrackData.Speed = response[0].Speed;
//           }
//         },
//         (err) => {
//           this.toastr.error(err._body.replace(/"/g, ""), "Error");
//         }
//       );
//   }

//   transition(result, position) {
//     this.position = position;
//     this.i = 0;
//     this.deltaLat = (result[0] - this.position[0]) / this.numDeltas;
//     this.deltaLng = (result[1] - this.position[1]) / this.numDeltas;
//     this.CalculateDegrees(position[0], position[1], result[0], result[1]);
//     this.moveMarker();
//   }

//   moveMarker() {
//     this.position[0] = parseFloat(this.position[0] + this.deltaLat);
//     this.position[1] = parseFloat(this.position[1] + this.deltaLng);
//     var latlng = new google.maps.LatLng(this.position[0], this.position[1]);
//     this.beachMarker.setPosition(latlng);
//     if (this.i != this.numDeltas) {
//       this.i = this.i + 1;
//       setTimeout(() => {
//         this.moveMarker();
//       }, this.delay);
//     }
//   }

//   degreeToRadians(latLong) {
//     return (Math.PI * latLong) / 180.0;
//   }

//   radiansToDegree(latLong) {
//     return (latLong * 180.0) / Math.PI;
//   }

//   CalculateDegrees(
//     start_latitude: any,
//     start_longitude: any,
//     stop_latitude: any,
//     stop_longitude: any
//   ) {
//     console.log(
//       "coordinates",
//       "[",
//       start_latitude,
//       "]",
//       "[",
//       start_longitude,
//       "]",
//       "[",
//       stop_latitude,
//       "]",
//       "[",
//       stop_longitude,
//       "]"
//     );
//     //Source
//     var lat1 = parseFloat(start_latitude);
//     var lng1 = parseFloat(start_longitude);

//     // destination
//     var lat2 = parseFloat(stop_latitude);
//     var lng2 = parseFloat(stop_longitude);

//     var fLat = this.degreeToRadians(lat1);
//     var fLong = this.degreeToRadians(lng1);
//     var tLat = this.degreeToRadians(lat2);
//     var tLong = this.degreeToRadians(lng2);

//     var dLon = tLong - fLong;

//     var degree = this.radiansToDegree(
//       Math.atan2(
//         Math.sin(dLon) * Math.cos(tLat),
//         Math.cos(fLat) * Math.sin(tLat) -
//         Math.sin(fLat) * Math.cos(tLat) * Math.cos(dLon)
//       )
//     );

//     if (degree >= 0) {
//       this.VehicleDirectionDegree = degree;
//     } else {
//       this.VehicleDirectionDegree = 360 + degree;
//     }

//     this.svg =
//       '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64" transform="rotate(' +
//       this.VehicleDirectionDegree +
//       ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

//     var icon = {
//       anchor: new google.maps.Point(16, 16),
//       url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(this.svg),
//       scale: 3,
//       fillColor: "red",
//       fillOpacity: 0.8,
//       strokeWeight: 2,
//       rotation: this.VehicleDirectionDegree, //this is how to rotate the pointer
//     };
//     this.beachMarker.setIcon(icon);
//   }

//   getDriverCurrentLatLong_GPS() {
//     this._appService
//       .GetByTwoId(
//         "OrdersByVehicle",
//         "opa_getTripLiveData_GPSWise_fromTable",
//         this.liveTrackData.vehicleNo,
//         this.BookingId
//       )
//       .subscribe(
//         (data) => {
//           try {
//             var response1_obj: any = [];
//             response1_obj = data;
//             if (response1_obj.length > 0) {
//               this.isGPS = true;
//               this.GPSUrl = this.liveTrackData.GPSTrackingUrl;
//               this.liveTrackData.Speed = response1_obj[0].Speed;

//               var objOldLatLong: any = [
//                 this.liveTrackData.driverLocationLAT,
//                 this.liveTrackData.driverLocationLNG,
//               ];
//               var newOldLatLong: any = [
//                 response1_obj[0].Latitude,
//                 response1_obj[0].Longitude,
//               ];
//               if (
//                 this.liveTrackData.driverLocationLAT != newOldLatLong[0] &&
//                 this.liveTrackData.driverLocationLNG != newOldLatLong[1]
//               ) {
//                 this.transition(newOldLatLong, objOldLatLong);
//               }

//               this.liveTrackData.driverLocationLAT = parseFloat(
//                 response1_obj[0].Latitude
//               );
//               this.liveTrackData.driverLocationLNG = parseFloat(
//                 response1_obj[0].Longitude
//               );

//               this.liveTrackData.LastTracked = response1_obj[0].GPSActualTime;

//               var today = new Date();
//               var gpsDate = new Date(response1_obj[0].GPSActualTime);
//               var diff = today.getTime() - gpsDate.getTime();
//               var days = Math.floor(diff / (60 * 60 * 24 * 1000));
//               var hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
//               var minutes =
//                 Math.floor(diff / (60 * 1000)) - (days * 24 * 60 + hours * 60);

//               var image = "../../assets/img/truck_inactive.png";

//               if (minutes > 1) {
//                 this.liveTrackData.TrackStatus = "InActive";
//                 image = "../../assets/img/truck_inactive.png";
//               } else {
//                 this.liveTrackData.TrackStatus = "Active";
//                 image = "../../assets/img/truck_active.png";
//               }
//               this.liveTrackData.TrackThrough = "GPS";
//             }
//           } catch (e) { }
//           // this.initMap();
//         },
//         (error) => {
//           this.toastr.error(error._body.replace(/"/g, ""), "Error");
//           Helpers.setLoading(false);
//         }
//       );
//   }

//   GetLiveTrackListForBooking() {
//     Helpers.setLoading(true);
//     this._appService
//       .GetByTwoId(
//         "Booking",
//         "GetLiveTrackListForBooking",
//         this.BookingId,
//         this.ConsignmentDetailId
//       )
//       .subscribe(
//         (response) => {
//           Helpers.setLoading(false);
//           this.liveTrackData = response.Table[0];
//           this.liveTrackData.documentList = [];
//           this.liveTrackData.documentList = response.Table1;
//           this.liveTrackData.orderDetailsList = [];
//           this.liveTrackData.orderDetailsList.push(response.Table2[0]);
//           this.liveTrackData.documentList.forEach((element) => {
//             if (element.documentFileName !== null) {
//               element.documentFileName =
//                 element.documentFileName.split(/_(.+)/)[1] +
//                 "." +
//                 element.documentFileExtension;
//             }
//           });
//           this.initializeMap();
//         },
//         (err) => {
//           this.toastr.error(err._body.replace(/"/g, ""), "Error");
//           Helpers.setLoading(false);
//         }
//       );
//   }

//   async getFullAddress() {
//     // const originLatLng = await this.getCoordinatesFromAddress(this.Origin);
//     // const destLatLng = await this.getCoordinatesFromAddress(this.Destination);

//     // this.fullAddress = this.data.fullAddress;
//     // this.getLatLng(this.fullAddress, 'Origin');
//     // this.getLatLng(this.fullAddress, 'Destination');
//     // if (MapDetailsCardComponent.that.FTLType === 'ContainerMovement') {
//     //   this.getLatLng(this.fullAddress, 'CFSYARDLocation');
//     // }
//   }

//   getSOAddresstoPlot() {
//     this.fullAddress = this.data.fullAddress;
//     this.getLatLng(this.fullAddress, 'SOAddress');
//   }

//   async LoadTripRouteBaseOnDeliveryDate() {
//     this._appService
//       .GetById("Common", "GetSystemSettingByName", "TripRouteBaseOnDeliveryDate")
//       .subscribe(
//         async (response) => {
//           if (response == '1') {
//             this.TripRouteBaseOnDeliveryDateFlag = true;
//           } else {
//             this.TripRouteBaseOnDeliveryDateFlag = false;
//           }
//         },
//         async (err) => {
//         }
//       );
//   }

//   async LoadLiveTrackingThrowWarehouseLatLong() {
//     this._appService
//       .GetById("Common", "GetSystemSettingByName", "LiveTrackingThrowWarehouseLatLong")
//       .subscribe(
//         async (response) => {
//           if (response == '1') {
//             this.LiveTrackingThrowWarehouseLatLongFlage = true;
//           } else {
//             this.LiveTrackingThrowWarehouseLatLongFlage = false;
//           }
//         },
//         async (err) => {
//         }
//       );
//   }

//   MapRadious: any;
//   OrderInfo: any = [];
//   // async InitWayPointsMap() {
//   //
//   //   var WayPointsManualvehicleOrderList = [];
//   //   this._appService
//   //     .GetById(
//   //       "Booking",
//   //       "GetOrderAddressFromLocationCodeMobile",
//   //       this.BookingId
//   //     )
//   //     .subscribe(
//   //       async (response: any) => {
//   //         var DestinationLocation = "";
//   //         DestinationLocation = response.Table[0].DeliveryAddress;
//   //         this.WayPointsres = [];
//   //         let res = [];
//   //         let PickUpPoints = [];
//   //         var CheckForSamePickup: boolean = false;
//   //         WayPointsManualvehicleOrderList = response.Table1;
//   //         response.Table1.map(function (item) {
//   //           var existItem = res.find((x) => x.PickupLocationCode != item.PickupLocationCode);
//   //           var existItemDelivery = MapDetailsCardComponent.that.WayPointsres.find((x) => x.DeliveryAddress == item.DeliveryAddress);
//   //           if (!existItemDelivery || MapDetailsCardComponent.that.TripRouteBaseOnDeliveryDateFlag == true) {
//   //             var objDeliveryLocation: any = {};
//   //             objDeliveryLocation.location = MapDetailsCardComponent.that.LiveTrackingThrowWarehouseLatLongFlage == true ? item.DeliveryAddressLatLong : item.DeliveryAddress1;
//   //             objDeliveryLocation.stopover = true;
//   //             objDeliveryLocation.Order = 0;
//   //             objDeliveryLocation.RouteOrder = "A";
//   //             objDeliveryLocation.OrderNo = item.OrderNo;
//   //             objDeliveryLocation.PickUpContactPersonDetail = item.PickUpContactPersonDetail;
//   //             objDeliveryLocation.DeliveryContactPersonDetail = item.DeliveryContactPersonDetail;
//   //             objDeliveryLocation.OrderAddress = item.DeliveryAddress;
//   //             objDeliveryLocation.OrderLatLong = item.DeliveryAddressLatLong;
//   //             objDeliveryLocation.OrderDate = new Date(item.DeliviryDate);
//   //             objDeliveryLocation.OrderDateFormated = item.DeliviryDateFormated;
//   //             objDeliveryLocation.weight = item.weight;
//   //             objDeliveryLocation.Qty = item.Qty;
//   //             objDeliveryLocation.cbm = item.CBM;
//   //             MapDetailsCardComponent.that.WayPointsres.push(objDeliveryLocation);
//   //           }
//   //           if (existItem) {
//   //             CheckForSamePickup = true;
//   //           } else {
//   //             CheckForSamePickup = false;
//   //             res.push(item);
//   //             var objPickupLocation: any = {};
//   //             if (PickUpPoints.length == 0) {
//   //               objPickupLocation.origin = item.PickupAddress1;
//   //               objPickupLocation.destination = DestinationLocation;
//   //               objPickupLocation.TripNo = "";
//   //               objPickupLocation.DispatchDate = "";
//   //               objPickupLocation.Transporter = "";
//   //               objPickupLocation.TransporterPhone = "";
//   //               objPickupLocation.Driver = "";
//   //               objPickupLocation.DriverPhone = "";
//   //               objPickupLocation.Vehicle = "";
//   //               objPickupLocation.VehicleType = "";
//   //               PickUpPoints.push(objPickupLocation);
//   //             }
//   //           }
//   //           MapDetailsCardComponent.that.MapRadious = item.MapRadious;
//   //         });
//   //         if (CheckForSamePickup == false) {
//   //           this.OrderInfoLatLong = [
//   //             {
//   //               origin: WayPointsManualvehicleOrderList[0].PickupAddress, //.PickupAddressLatLong,
//   //               destination: WayPointsManualvehicleOrderList[0].DeliveryAddressLatLong,
//   //             },
//   //           ];

//   //           this.OrderInfo = PickUpPoints;
//   //           this.OrderDestinationLocation = this.WayPointsres;
//   //           if (this.TripRouteBaseOnDeliveryDateFlag == true) {
//   //             this.OrderDestinationLocation = this.WayPointsres.sort((a, b) => a.OrderDate - b.OrderDate);
//   //           }
//   //           this.ShowWayPointsMap();
//   //         }
//   //       },
//   //       async (err) => {
//   //       }
//   //     );
//   // }

//   InitWayPointsMap() {
//     //
//     const directionsService = new google.maps.DirectionsService();
//     const directionsRenderer = new google.maps.DirectionsRenderer();
//     const mapv2 = new google.maps.Map(document.getElementById("WayPointMap"), {
//       zoom: 6,
//       center: { lat: 41.85, lng: -87.65 }
//     });

//     directionsRenderer.setMap(mapv2);

//     const geocoder = new google.maps.Geocoder(); // Geocoder to convert addresses into LatLng

//     // This function will handle geocoding for each address
//     const geocodeAddresses = async (addresses) => {
//       const waypts = [];

//       for (let i = 0; i < addresses.length; i++) {
//         const loc = addresses[i];
//         try {
//           const result = await geocodeAddress(loc.location); // Geocode the address
//           waypts.push({
//             location: result,  // Add geocoded location
//             stopover: true
//           });

//           // Create a marker for the geocoded location
//           new google.maps.Marker({
//             position: result,
//             map: mapv2,
//             label: '' //loc.tripNo,  // Label the marker with the order number
//           });
//         } catch (error) {
//           console.error(`Geocode failed for address: ${loc.location}`, error);
//         }
//       }

//       return waypts;  // Return the array of waypoints once all are geocoded
//     };

//     // Helper function to geocode an address and return a LatLng object
//     const geocodeAddress = (address) => {
//       return new Promise((resolve, reject) => {
//         geocoder.geocode({ address: address }, (results, status) => {
//           if (status === google.maps.GeocoderStatus.OK) {
//             resolve(results[0].geometry.location);  // Return the LatLng object
//           } else {
//             reject(new Error('Geocode failed: ' + status));
//           }
//         });
//       });
//     };

//     // Once geocoding is done, call the directions service
//     geocodeAddresses(this.WayPoints).then((waypts) => {
//       directionsService.route({
//         origin: MapDetailsCardComponent.that.FTLType === 'ContainerMovement' ? this.CFSYARDAddress : this.Origin,
//         // origin: this.Origin,  // Ensure Origin is a LatLngLiteral or LatLng object
//         destination: this.Destination,  // Ensure Destination is a LatLngLiteral or LatLng object
//         // waypoints: waypts,  // Waypoints are set after geocoding
//         waypoints: MapDetailsCardComponent.that.FTLType === 'FTL' ? waypts : [{ location: this.Origin, stopover: true }],
//         optimizeWaypoints: true,
//         travelMode: google.maps.TravelMode.DRIVING
//       }, (response, status) => {
//         if (status === "OK") {
//           directionsRenderer.setDirections(response);
//           const route = response.routes[0];

//           let totalDistance = 0;
//           let totalDuration = 0;
//           route.legs.forEach((leg) => {
//             totalDistance += leg.distance.value;
//             totalDuration += leg.duration.value;
//           });

//           setTimeout(() => {
//             // Add polyline to show the route overview
//             const polyline = new google.maps.Polyline({
//               path: route.overview_path,  // The path is the polyline path
//               strokeColor: "#3367FB", // Set polyline color
//               strokeOpacity: 1.0,
//               strokeWeight: 5,
//             });
//             polyline.setMap(mapv2);
//           }, 1000);
//         } else {
//           // window.alert("Directions request failed due to " + status);
//           this.toastr.error("Directions request failed due to " + status, "Error");
//         }
//       });
//     }).catch((error) => {
//       console.error('Error in geocoding waypoints:', error);
//     });
//   }

//   InitWayPointsMapTwo() {
//     //
//     const directionsService = new google.maps.DirectionsService();
//     const directionsRenderer = new google.maps.DirectionsRenderer();
//     const mapv2 = new google.maps.Map(document.getElementById("WayPointMapTwo"), {
//       zoom: 6,
//       center: { lat: 41.85, lng: -87.65 }
//     });

//     directionsRenderer.setMap(mapv2);

//     const geocoder = new google.maps.Geocoder(); // Geocoder to convert addresses into LatLng

//     // This function will handle geocoding for each address
//     const geocodeAddresses = async (addresses) => {
//       const waypts = [];

//       for (let i = 0; i < addresses.length; i++) {
//         const loc = addresses[i];
//         try {
//           const result = await geocodeAddress(loc.location); // Geocode the address
//           waypts.push({
//             location: result,  // Add geocoded location
//             stopover: true
//           });

//           // Create a marker for the geocoded location
//           new google.maps.Marker({
//             position: result,
//             map: mapv2,
//             label: '' //loc.tripNo,  // Label the marker with the order number
//           });
//         } catch (error) {
//           console.error(`Geocode failed for address: ${loc.location}`, error);
//         }
//       }

//       return waypts;  // Return the array of waypoints once all are geocoded
//     };

//     // Helper function to geocode an address and return a LatLng object
//     const geocodeAddress = (address) => {
//       return new Promise((resolve, reject) => {
//         geocoder.geocode({ address: address }, (results, status) => {
//           if (status === google.maps.GeocoderStatus.OK) {
//             resolve(results[0].geometry.location);  // Return the LatLng object
//           } else {
//             reject(new Error('Geocode failed: ' + status));
//           }
//         });
//       });
//     };

//     // Once geocoding is done, call the directions service
//     geocodeAddresses(this.WayPoints).then((waypts) => {
//       directionsService.route({
//         origin: MapDetailsCardComponent.that.FTLType === 'ContainerMovement' ? this.CFSYARDAddress : this.Origin,
//         // origin: this.Origin,  // Ensure Origin is a LatLngLiteral or LatLng object
//         destination: this.Destination,  // Ensure Destination is a LatLngLiteral or LatLng object
//         // waypoints: waypts,  // Waypoints are set after geocoding
//         waypoints: MapDetailsCardComponent.that.FTLType === 'FTL' ? waypts : [{ location: this.Origin, stopover: true }],
//         optimizeWaypoints: true,
//         travelMode: google.maps.TravelMode.DRIVING
//       }, (response, status) => {
//         if (status === "OK") {
//           directionsRenderer.setDirections(response);
//           const route = response.routes[0];

//           let totalDistance = 0;
//           let totalDuration = 0;
//           route.legs.forEach((leg) => {
//             totalDistance += leg.distance.value;
//             totalDuration += leg.duration.value;
//           });

//           setTimeout(() => {
//             // Add polyline to show the route overview
//             const polyline = new google.maps.Polyline({
//               path: route.overview_path,  // The path is the polyline path
//               strokeColor: "#3367FB", // Set polyline color
//               strokeOpacity: 1.0,
//               strokeWeight: 5,
//             });
//             polyline.setMap(mapv2);
//           }, 1000);
//         } else {
//           // window.alert("Directions request failed due to " + status);
//           this.toastr.error("Directions request failed due to " + status, "Error");
//         }
//       });
//     }).catch((error) => {
//       console.error('Error in geocoding waypoints:', error);
//     });
//     this.calculateAndDisplayRouteForContainerMovement(directionsService, directionsRenderer);
//   }

//   calculateAndDisplayRouteForContainerMovement(directionsService, directionsRenderer) {
//     if (!directionsService || !directionsRenderer) {
//       console.error(
//         "DirectionsService or DirectionsRenderer is not initialized."
//       );
//       return;
//     }

//     if (!this.Origin || !this.Destination) {
//       console.error("Origin or Destination is not set.");
//       return;
//     }

//     directionsService
//       .route({
//         origin: this.CFSYARDAddress,
//         destination: this.Destination,
//         waypoints: [{ location: this.Origin, stopover: true }],
//         travelMode: google.maps.TravelMode.DRIVING,
//       })
//       .then((response) => {
//         directionsRenderer.setDirections(response);
//         let totalDistance = 0;
//         let totalDuration = 0;

//         response.routes[0].legs.forEach((leg) => {
//           totalDistance += leg.distance.value; // in meters
//           totalDuration += leg.duration.value; // in seconds
//         });

//         // Convert distance to kilometers and duration to hours & minutes
//         const distanceKm = (totalDistance / 1000).toFixed(2) + " km";
//         const durationHrMin = new Date(totalDuration * 1000)
//           .toISOString()
//           .substr(11, 8); // Converts seconds to HH:MM:SS format


//         var obj: any = {};
//         obj.distance = distanceKm;
//         obj.duration = durationHrMin;
//         MapDetailsCardComponent.that.OnCatchData.emit(obj);
//       })
//       .catch((e) => {
//         console.error(e);
//         // window.alert("Directions request failed due to " + e.message);
//         this.toastr.error("Directions request failed due to " + e.message, "Error");
//       });
//   }

//   //Leaflet Map
//   private originMarkerWm: L.Marker;
//   private destMarkerWm: L.Marker;
//   private routingControlWm: any;
//   originCircleWm: any;
//   destCircleWm: any;

//   @HostListener('window:resize', ['$event'])
//   onResize() {
//     // this.map.invalidateSize();
//     // this.mapWayPoint.invalidateSize();
//   }

//   getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
//     return new Promise((resolve, reject) => {
//       var obj: any = {};
//       obj.address = address;
//       this._appService.Post('OrdersByVehicle', 'GetCoordinatesFromAddressAsync', obj).subscribe(
//         (response: any) => {
//           // Assuming response has 'Latitude', 'Longitude', 'Altitude'
//           if (response) {
//             const lat: number = response.Latitude;
//             const lon: number = response.Longitude;
//             const alt: number = response.Altitude || 0; // Default to 0 if Altitude is not provided

//             resolve([lat, lon, alt]);
//           } else {
//             this.toastr.error('Address not found!');
//             reject('Address not found');
//           }
//         },
//         error => {
//           this.toastr.error('Error fetching coordinates!');
//           reject('Error fetching coordinates');
//         }
//       );
//     });
//   }

//   // getCoordinatesFromAddress(address: string): Promise<[number, number, number]> {
//   //   const cleanedAddress = address
//   //     .replace(/-/g, ',')
//   //     .replace(/,\s*$/, '');
//   //   const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(cleanedAddress)}`;

//   //   const userAgent = navigator.userAgent;
//   //   console.log(cleanedAddress);
//   //   return fetch(url, {
//   //     headers: {
//   //       'Accept-Language': 'en',
//   //       'User-Agent': userAgent // Replace with real app name/email
//   //     }
//   //   })
//   //     .then(response => {
//   //       if (!response.ok) {
//   //         throw new Error('Failed to fetch coordinates');
//   //       }
//   //       return response.json();
//   //     })
//   //     .then(data => {
//   //       if (data && data.length > 0) {
//   //         const { lat, lon } = data[0];
//   //         return [parseFloat(lat), parseFloat(lon), 0] as [number, number, number];
//   //       } else {
//   //         // If using Toastr in Angular or similar
//   //         if (typeof this !== 'undefined' && this.toastr) {
//   //           this.toastr.error('Address not found!', 'Error');
//   //         }
//   //         throw new Error('Address not found');
//   //       }
//   //     });
//   // }

//   mapRadius: any = 0;
//   getMapRadius() {
//     this._appService
//       .Get(
//         "OrdersByVehicle",
//         "getMapRadius"
//       )
//       .subscribe(
//         (response) => {
//           this.mapRadius = response;
//         },
//         (err) => {
//           this.toastr.error(err._body.replace(/"/g, ""), "Error");
//         }
//       );
//   }

//   initializeLeafletMap() {
//     const containerEl = this.mapContainerRef.nativeElement;
//     const initialCoords = [18.9836681, 73.0525676] as L.LatLngExpression;

//     if (this.map) {
//       return;
//     }
//     this.map = L.map(containerEl).setView(initialCoords, 7);

//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//     }).addTo(this.map);

//     setTimeout(() => this.map.invalidateSize(), 200);
//     setTimeout(() => this.map.invalidateSize(), 1000);
//   }

//   async showOriginDestination(origin: string, destination: string): Promise<void> {
//     try {
//       const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0];

//       const isValidCoord = (lat: number, lng: number, lg: number) =>
//         typeof lat === 'number' && typeof lng === 'number' &&
//         !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

//       const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
//       const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);

//       const originCoords: L.LatLngTuple = hasValidOrigin
//         ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
//         : defaultCoords;

//       const destCoords: L.LatLngTuple = hasValidDestination
//         ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
//         : defaultCoords;

//       const containerEl = this.mapContainerRef.nativeElement;

//       // Initialize map if not already
//       if (containerEl && !containerEl._leaflet_id) {
//         this.map = L.map(containerEl).setView(defaultCoords, 5);
//         L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//           attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         }).addTo(this.map);
//         this.mapLayerGroup = L.layerGroup().addTo(this.map);
//       }

//       if (!this.map.hasLayer(this.mapLayerGroup)) {
//         this.mapLayerGroup.addTo(this.map);
//       }

//       // Clear all layers and remove routing
//       this.mapLayerGroup.clearLayers();
//       if (this.routingControl) {
//         this.map.removeControl(this.routingControl);
//         this.routingControl = null;
//       }

//       // Early exit if data is invalid
//       if (!hasValidOrigin || !hasValidDestination) {
//         this.map.setView(defaultCoords, 5);
//         setTimeout(() => this.map.invalidateSize(), 200);
//         setTimeout(() => this.map.invalidateSize(), 1000);
//         return;
//       }

//       // Origin marker and circle
//       this.originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<b>Origin:</b><br>${origin}`);
//       this.originCircle = L.circle(originCoords, {
//         radius: this.mapRadius,
//         color: '#00bfff',
//         fillColor: '#00bfff',
//         weight: 1,
//         fillOpacity: 0.2
//       });
//       this.mapLayerGroup.addLayer(this.originMarker).addLayer(this.originCircle);

//       // Destination marker and circle
//       this.destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<b>Destination:</b><br>${destination}`);
//       this.destCircle = L.circle(destCoords, {
//         radius: this.mapRadius,
//         color: '#ff5733',
//         fillColor: '#ff5733',
//         weight: 1,
//         fillOpacity: 0.2
//       });
//       this.mapLayerGroup.addLayer(this.destMarker).addLayer(this.destCircle);

//       // Add routing
//       // @ts-ignore
//       this.routingControl = L.Routing.control({
//         waypoints: [
//           L.latLng(originCoords),
//           L.latLng(destCoords)
//         ],
//         routeWhileDragging: false,
//         addWaypoints: false,
//         draggableWaypoints: false,
//         show: true,
//         lineOptions: {
//           styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//         },
//         // @ts-ignore
//         formatter: new L.Routing.Formatter({
//           formatInstruction: (instruction) => {
//             const text = instruction.text;
//             return (
//               text.startsWith('Continue onto') ||
//               text.startsWith('Exit the traffic circle') ||
//               text.startsWith('Enter the traffic circle')
//             ) ? '' : text;
//           }
//         }),
//         createMarker: () => null
//       }).addTo(this.map);

//       // Fit bounds
//       this.map.fitBounds(L.latLngBounds([originCoords, destCoords]), { padding: [50, 50] });

//       // Refresh map
//       setTimeout(() => this.map.invalidateSize(), 200);
//       setTimeout(() => this.map.invalidateSize(), 1000);

//     } catch (error) {
//       console.error('Error showing origin/destination:', error);
//     }
//   }

//   initializeLeafletMapWayPoint() {
//     const containerEl2 = this.mapContainerRefWayPoint.nativeElement;
//     const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

//     if (this.mapWayPoint || !containerEl2 || containerEl2._leaflet_id) {
//       return;
//     }
//     this.mapWayPoint = L.map(containerEl2).setView(initialCoords1, 7);

//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//     }).addTo(this.mapWayPoint);

//     setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
//     setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
//     setTimeout(() => this.mapWayPoint.setZoom(7), 1000);
//   }

//   async showOriginDestinationWayPoint(origin: string, destination: string): Promise<void> {
//     try {
//       const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Center of India or your fallback center

//       const isValidCoord = (lat: number, lng: number, lg: number) => lat && lng && lat !== 0 && lng !== 0;

//       const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
//       const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);

//       const originCoords: L.LatLngExpression = hasValidOrigin
//         ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
//         : defaultCoords;

//       const destCoords: L.LatLngExpression = hasValidDestination
//         ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
//         : defaultCoords;

//       let wayPoints: L.LatLng[] = [];

//       if (this.WayPoints && Array.isArray(this.WayPoints)) {
//         wayPoints = this.WayPoints.map(addr => L.latLng(addr.lat, addr.lng));
//       }

//       // Initialize the map if needed
//       if (!this.mapWayPoint) {
//         this.mapWayPoint = L.map('Newmap').setView(defaultCoords, 5);
//         L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//           attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         }).addTo(this.mapWayPoint);

//         this.wayPointLayerGroup = L.layerGroup().addTo(this.mapWayPoint);
//       }

//       this.wayPointLayerGroup.clearLayers();

//       if (this.routingControlWm) {
//         this.mapWayPoint.removeControl(this.routingControlWm);
//         this.routingControlWm = null;
//       }

//       // If no valid origin or destination, just show default view
//       if (!hasValidOrigin || !hasValidDestination) {
//         this.mapWayPoint.setView(defaultCoords, 5);
//         setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
//         setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
//         return;
//       }

//       // Add origin marker and circle
//       const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<b>Origin:</b><br>${origin}`);
//       const originCircle = L.circle(originCoords, {
//         radius: this.mapRadius,
//         color: '#00bfff',
//         fillColor: '#00bfff',
//         weight: 1,
//         fillOpacity: 0.2
//       });
//       this.wayPointLayerGroup.addLayer(originMarker).addLayer(originCircle);

//       // Add destination marker and circle
//       const destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<b>Destination:</b><br>${destination}`);
//       const destCircle = L.circle(destCoords, {
//         radius: this.mapRadius,
//         color: '#ff5733',
//         fillColor: '#ff5733',
//         weight: 1,
//         fillOpacity: 0.2
//       });
//       this.wayPointLayerGroup.addLayer(destMarker).addLayer(destCircle);

//       // Add routing
//       // @ts-ignore
//       this.routingControlWm = L.Routing.control({
//         waypoints: [
//           L.latLng(originCoords),
//           ...wayPoints,
//           L.latLng(destCoords)
//         ],
//         routeWhileDragging: false,
//         addWaypoints: false,
//         draggableWaypoints: false,
//         show: true,
//         lineOptions: {
//           styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//         },
//         // @ts-ignore
//         formatter: new L.Routing.Formatter({
//           formatInstruction: (instruction) => {
//             const text = instruction.text;
//             return (
//               text.startsWith('Continue onto') ||
//               text.startsWith('Exit the traffic circle') ||
//               text.startsWith('Enter the traffic circle')
//             ) ? '' : text;
//           }
//         }),
//         createMarker: () => null
//       }).addTo(this.mapWayPoint);

//       // Fit bounds
//       const allCoords = [originCoords, ...wayPoints, destCoords];
//       this.mapWayPoint.fitBounds(L.latLngBounds(allCoords), { padding: [50, 50] });

//       // Refresh map layout
//       setTimeout(() => this.mapWayPoint.invalidateSize(), 200);
//       setTimeout(() => this.mapWayPoint.invalidateSize(), 1000);
//     } catch (error) {
//       console.error('Error showing origin/destination with waypoints:', error);
//     }
//   }

//   initializeLeafletMapWayPointTwo() {
//     const containerEl2 = this.mapContainerRefWayPointTwo.nativeElement;
//     const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

//     if (this.mapWayPointTwo || !containerEl2 || containerEl2._leaflet_id) {
//       return;
//     }
//     this.mapWayPointTwo = L.map(containerEl2).setView(initialCoords1, 7);

//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//     }).addTo(this.mapWayPointTwo);

//     setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
//     setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);
//     setTimeout(() => this.mapWayPointTwo.setZoom(7), 1000);
//   }

//   async showOriginDestinationWayPointTwo(): Promise<void> {
//     try {
//       const that = MapDetailsCardComponent.that;
//       const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Fallback center

//       const isValidCoord = (lat: number, lng: number, lg: number) =>
//         typeof lat === 'number' && typeof lng === 'number' &&
//         !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

//       const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude, 0);
//       const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude, 0);
//       const hasValidCFS = isValidCoord(this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0);

//       const originCoords: L.LatLngTuple = hasValidOrigin
//         ? [this.PickUpLatitude, this.PickUpLongtitude, 0]
//         : defaultCoords;

//       const destCoords: L.LatLngTuple = hasValidDestination
//         ? [this.DeliverLatitude, this.DeliverLongtitude, 0]
//         : defaultCoords;

//       const cfsCoords: L.LatLngTuple = hasValidCFS
//         ? [this.CFSYARDLocationLatitude, this.CFSYARDLocationLongtitude, 0]
//         : defaultCoords;

//       // Initialize map if needed
//       if (!this.mapWayPointTwo) {
//         this.mapWayPointTwo = L.map('Newmap').setView(defaultCoords, 5);
//         L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//           attribution: '&copy; OpenStreetMap contributors'
//         }).addTo(this.mapWayPointTwo);
//         this.mapLayerGroupWayPointTwo = L.layerGroup().addTo(this.mapWayPointTwo);
//       }

//       // Clear previous layers and routing
//       this.mapLayerGroupWayPointTwo.clearLayers();

//       if (this.routingControl) {
//         this.mapWayPointTwo.removeControl(this.routingControl);
//         this.routingControl = null;
//       }

//       // If any key coordinate is missing, show default view
//       if (!hasValidOrigin || !hasValidDestination || !hasValidCFS) {
//         this.mapWayPointTwo.setView(defaultCoords, 5);
//         setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
//         setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);
//         return;
//       }

//       // Add markers and circles
//       const originMarker = L.marker(originCoords, { icon: this.originIcon }).bindPopup(`<b>Origin:</b><br>${that.Origin}`);
//       const originCircle = L.circle(originCoords, {
//         radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
//       });

//       const destMarker = L.marker(destCoords, { icon: this.destinationIcon }).bindPopup(`<b>Destination:</b><br>${that.Destination}`);
//       const destCircle = L.circle(destCoords, {
//         radius: this.mapRadius, color: '#ff5733', fillColor: '#ff5733', weight: 1, fillOpacity: 0.2
//       });

//       const cfsMarker = L.marker(cfsCoords, { icon: this.cfsIcon }).bindPopup(`<b>CFS:</b><br>${that.CFSYARDAddress}`);
//       const cfsCircle = L.circle(cfsCoords, {
//         radius: this.mapRadius, color: '#FFA500', fillColor: '#FFA500', weight: 1, fillOpacity: 0.2
//       });

//       this.mapLayerGroupWayPointTwo.addLayer(originMarker)
//         .addLayer(originCircle)
//         .addLayer(destMarker)
//         .addLayer(destCircle)
//         .addLayer(cfsMarker)
//         .addLayer(cfsCircle);

//       // Build routing waypoints
//       const routingWaypoints: L.LatLng[] = [L.latLng(cfsCoords), L.latLng(originCoords)];

//       const midPoints = (this.WayPoints || [])
//         .filter(wp => isValidCoord(wp.lat, wp.lng, 0))
//         .map(wp => L.latLng(wp.lat, wp.lng));

//       routingWaypoints.push(...midPoints, L.latLng(destCoords));

//       // Add routing
//       // @ts-ignore
//       this.routingControl = L.Routing.control({
//         waypoints: routingWaypoints,
//         routeWhileDragging: false,
//         addWaypoints: true,
//         draggableWaypoints: false,
//         show: true,
//         lineOptions: {
//           styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//         },
//         createMarker: (i, wp, n) => {
//           if (i === 0) return L.marker(wp.latLng, { icon: that.cfsIcon }).bindPopup(`<b>CFS</b><br>${that.CFSYARDAddress}`);
//           if (i === 1) return L.marker(wp.latLng, { icon: that.originIcon }).bindPopup(`<b>Origin</b><br>${that.Origin}`);
//           if (i === n - 1) return L.marker(wp.latLng, { icon: that.destinationIcon }).bindPopup(`<b>Destination</b><br>${that.Destination}`);
//           return null; // No marker for midpoints
//         },
//         // @ts-ignore
//         formatter: new L.Routing.Formatter({
//           formatInstruction: (text) => {
//             if (
//               text.startsWith('Continue onto') ||
//               text.startsWith('Exit the traffic circle') ||
//               text.startsWith('Enter the traffic circle')
//             ) return '';
//             return text;
//           }
//         })
//       }).addTo(this.mapWayPointTwo);

//       // Fit map to all relevant coordinates
//       const allCoords: L.LatLngTuple[] = [originCoords, destCoords, cfsCoords, ...midPoints.map(mp => [mp.lat, mp.lng, 0] as L.LatLngTuple)];
//       const bounds = L.latLngBounds(allCoords);
//       this.mapWayPointTwo.fitBounds(bounds, { padding: [50, 50] });

//       // Refresh view
//       setTimeout(() => this.mapWayPointTwo.invalidateSize(), 200);
//       setTimeout(() => this.mapWayPointTwo.invalidateSize(), 1000);

//     } catch (error) {
//       console.error('Error showing origin/destination:', error);
//     }
//   }

//   initializeLeafletMapLiveTrack() {
//     const containerEl2 = this.mapContainerLiveTracking.nativeElement;
//     const initialCoords1 = [18.9836681, 73.0525676] as L.LatLngExpression;

//     if (this.mapLiveTracking || !containerEl2 || containerEl2._leaflet_id) {
//       return;
//     }
//     this.mapLiveTracking = L.map(containerEl2).setView(initialCoords1, 7);

//     L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//       attribution:
//         '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//     }).addTo(this.mapLiveTracking);

//     setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//     setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
//     setTimeout(() => this.mapLiveTracking.setZoom(7), 1000);
//   }

//   vehicleMarker: L.Marker | null = null; // Declare at class level
//   // async showLiveTrackVehicle(): Promise<void> {
//   //   try {
//   //     const that = MapDetailsCardComponent.that;
//   //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // Fallback center

//   //     const isValidCoord = (lat: number, lng: number, lg: number) =>
//   //       typeof lat === 'number' && typeof lng === 'number' &&
//   //       !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;

//   //     const hasValidCoords = isValidCoord(parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0);

//   //     const liveTrackCoords: L.LatLngTuple = hasValidCoords
//   //       ? [this.LiveTrackLatitude, this.LiveTrackLongtitude, 0]
//   //       : defaultCoords;

//   //     // Initialize map if needed
//   //     if (!this.mapLiveTracking) {
//   //       this.mapLiveTracking = L.map('Newmap').setView(defaultCoords, 5);
//   //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//   //         attribution: '&copy; OpenStreetMap contributors'
//   //       }).addTo(this.mapLiveTracking);
//   //       this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
//   //     }

//   //     // Clear previous layers and routing
//   //     this.mapLayerGroupLiveTracking.clearLayers();

//   //     if (this.routingControl) {
//   //       this.mapLiveTracking.removeControl(this.routingControl);
//   //       this.routingControl = null;
//   //     }

//   //     // If any key coordinate is missing, show default view
//   //     if (!hasValidCoords) {
//   //       this.mapLiveTracking.setView(defaultCoords, 5);
//   //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//   //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
//   //       return;
//   //     }

//   //     // Add markers and circles
//   //     const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
//   //     const vehicleIcon = this.getRotatedIcon(bearing); // or use leaflet-rotatedmarker

//   //     if (!this.vehicleMarker) {
//   //       this.vehicleMarker = L.marker([this.LiveTrackLatitude, this.LiveTrackLongtitude, 0], {
//   //         icon: vehicleIcon
//   //       }).bindPopup(`
//   //        <table>
//   //         <tr>
//   //           <td><b>Vehicle No</b></td>
//   //           <td>${that.VehicleNo}</td>
//   //         </tr>
//   //         <tr>
//   //           <td><b>Driver Name</b></td>
//   //           <td>${that.Driver}</td>
//   //         </tr>
//   //         <tr>
//   //           <td><b>Driver Mobile</b></td>
//   //           <td>${that.DriverMobileNo}</td>
//   //         </tr>
//   //         <tr>
//   //           <td><b>Track Through</b></td>
//   //           <td>Sim</td>
//   //         </tr>
//   //         <tr>
//   //           <td><b>Last Track</b></td>
//   //           <td>${that.LastTrackDate}</td>
//   //         </tr>
//   //       </table>
//   //       `);
//   //       this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
//   //     } else {
//   //       this.vehicleMarker.setLatLng([this.LiveTrackLatitude, this.LiveTrackLongtitude, 0]);
//   //       this.vehicleMarker.setIcon(vehicleIcon); // update bearing
//   //     }

//   //     // const originMarker = L.marker(liveTrackCoords, { icon: vehicleIcon }).bindPopup(`<b>Origin:</b><br>${that.Origin}`);
//   //     // const originCircle = L.circle(liveTrackCoords, {
//   //     //   radius: this.mapRadius, color: '#00bfff', fillColor: '#00bfff', weight: 1, fillOpacity: 0.2
//   //     // });

//   //     this.mapLiveTracking.addLayer(this.vehicleMarker);
//   //     // .addLayer(originCircle);

//   //     // Add routing
//   //     // @ts-ignore
//   //     this.routingControl = L.Routing.control({
//   //       waypoints: null,
//   //       routeWhileDragging: false,
//   //       addWaypoints: false,
//   //       draggableWaypoints: false,
//   //       show: true,
//   //       lineOptions: {
//   //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//   //       },
//   //       createMarker: (i, wp, n) => {
//   //         return L.marker(wp.latLng, { icon: vehicleIcon }).bindPopup(`<b>Vehicle No:</b>${that.VehicleNo}<br>
//   //         <b>Driver Name:</b>${that.Driver}`);
//   //       },
//   //       // @ts-ignore
//   //       formatter: new L.Routing.Formatter({
//   //         formatInstruction: (text) => {
//   //           if (
//   //             text.startsWith('Continue onto') ||
//   //             text.startsWith('Exit the traffic circle') ||
//   //             text.startsWith('Enter the traffic circle')
//   //           ) return '';
//   //           return text;
//   //         }
//   //       })
//   //     }).addTo(this.mapLiveTracking);

//   //     // Fit map to all relevant coordinates
//   //     const allCoords: L.LatLngTuple[] = [liveTrackCoords];
//   //     const bounds = L.latLngBounds(allCoords);
//   //     this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });

//   //     // Refresh view
//   //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//   //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);

//   //   } catch (error) {
//   //     console.error('Error showing origin/destination:', error);
//   //   }
//   // }

//   // async showLiveTrackVehicle(): Promise<void> {
//   //   try {
//   //     const that = MapDetailsCardComponent.that;
//   //     const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // India center as fallback

//   //     // Helper to validate coordinates
//   //     const isValidCoord = (lat: any, lng: any) =>
//   //       !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng)) &&
//   //       parseFloat(lat) !== 0 && parseFloat(lng) !== 0;

//   //     const hasValidLiveCoords = isValidCoord(this.LiveTrackLatitude, this.LiveTrackLongtitude);
//   //     const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
//   //     const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);

//   //     const liveTrackCoords: L.LatLngTuple = hasValidLiveCoords
//   //       ? [parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0]
//   //       : defaultCoords;

//   //     const originCoords: L.LatLngTuple = hasValidOrigin
//   //       ? [parseFloat(this.PickUpLatitude), parseFloat(this.PickUpLongtitude), 0]
//   //       : defaultCoords;

//   //     const destCoords: L.LatLngTuple = hasValidDestination
//   //       ? [parseFloat(this.DeliverLatitude), parseFloat(this.DeliverLongtitude), 0]
//   //       : defaultCoords;

//   //     // Initialize map
//   //     if (!this.mapLiveTracking) {
//   //       this.mapLiveTracking = L.map('Newmap').setView(defaultCoords, 5);
//   //       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//   //         attribution: '&copy; OpenStreetMap contributors'
//   //       }).addTo(this.mapLiveTracking);
//   //       this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
//   //     }

//   //     this.mapLayerGroupLiveTracking.clearLayers();

//   //     if (this.routingControl) {
//   //       this.mapLiveTracking.removeControl(this.routingControl);
//   //       this.routingControl = null;
//   //     }

//   //     if (!hasValidLiveCoords || !hasValidOrigin || !hasValidDestination) {
//   //       this.mapLiveTracking.setView(defaultCoords, 5);
//   //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//   //       setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
//   //       return;
//   //     }

//   //     const originIcon = this.originIcon;
//   //     const destinationIcon = this.destinationIcon;

//   //     // Origin Marker & Circle
//   //     const originMarker = L.marker(originCoords, { icon: originIcon })
//   //       .bindPopup(`<b>Origin:</b><br>${that.Origin}`);
//   //     const originCircle = L.circle(originCoords, {
//   //       radius: this.mapRadius || 0,
//   //       color: '#00bfff',
//   //       fillColor: '#00bfff',
//   //       weight: 1,
//   //       fillOpacity: 0.2
//   //     }).bringToFront();
//   //     this.mapLayerGroupLiveTracking.addLayer(originMarker).addLayer(originCircle);

//   //     // Destination Marker & Circle
//   //     const destMarker = L.marker(destCoords, { icon: destinationIcon })
//   //       .bindPopup(`<b>Destination:</b><br>${that.Destination}`);
//   //     const destCircle = L.circle(destCoords, {
//   //       radius: this.mapRadius || 0,
//   //       color: '#ff5733',
//   //       fillColor: '#ff5733',
//   //       weight: 1,
//   //       fillOpacity: 0.2
//   //     }).bringToFront();
//   //     this.mapLayerGroupLiveTracking.addLayer(destMarker).addLayer(destCircle);

//   //     // Bearing and Vehicle Icon
//   //     const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
//   //     const vehicleIcon = this.getRotatedIcon(bearing);

//   //     if (!this.vehicleMarker) {
//   //       this.vehicleMarker = L.marker(liveTrackCoords, {
//   //         icon: vehicleIcon
//   //       }).bindPopup(`
//   //         <table>
//   //           <tr><td><b>Vehicle No</b></td><td>${that.VehicleNo}</td></tr>
//   //           <tr><td><b>Driver Name</b></td><td>${that.Driver}</td></tr>
//   //           <tr><td><b>Driver Mobile</b></td><td>${that.DriverMobileNo}</td></tr>
//   //           <tr><td><b>Track Through</b></td><td>Sim</td></tr>
//   //           <tr><td><b>Last Track</b></td><td>${that.LastTrackDate}</td></tr>
//   //         </table>`);
//   //       this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
//   //     } else {
//   //       this.vehicleMarker.setLatLng(liveTrackCoords);
//   //       this.vehicleMarker.setIcon(vehicleIcon);
//   //     }

//   //     this.mapLiveTracking.addLayer(this.vehicleMarker);
//   //     this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);

//   //     // Add Routing: Origin -> Live -> Destination
//   //     // @ts-ignore
//   //     this.routingControl = L.Routing.control({
//   //       waypoints: [
//   //         L.latLng(originCoords),
//   //         L.latLng(liveTrackCoords),
//   //         L.latLng(destCoords)
//   //       ],
//   //       routeWhileDragging: false,
//   //       addWaypoints: false,
//   //       draggableWaypoints: false,
//   //       show: true,
//   //       lineOptions: {
//   //         styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//   //       },
//   //       createMarker: (i, wp, n) => {
//   //         if (i === 0) {
//   //           // Add circle around origin
//   //           const originCircle = L.circle(wp.latLng, {
//   //             radius: 10000,  // radius in meters
//   //             color: '#00bfff',
//   //             fillColor: '#00bfff',
//   //             fillOpacity: 0.2,
//   //             weight: 1
//   //           });
//   //           this.mapLayerGroupLiveTracking.addLayer(originCircle);

//   //           return L.marker(wp.latLng, { icon: this.originIcon }).bindPopup(`<b>Origin</b><br>${this.Origin}`);
//   //         }
//   //         // if (i === 1) return L.marker(wp.latLng, { icon: that.cfsIcon }).bindPopup(`<b>Origin</b><br>${that.Origin}`);
//   //         if (i === n - 1) {
//   //           // Add circle around destination
//   //           const destCircle = L.circle(wp.latLng, {
//   //             radius: this.mapRadius,
//   //             color: '#ff5733',
//   //             fillColor: '#ff5733',
//   //             fillOpacity: 0.2,
//   //             weight: 1
//   //           });
//   //           this.mapLayerGroupLiveTracking.addLayer(destCircle);

//   //           return L.marker(wp.latLng, { icon: this.destinationIcon }).bindPopup(`<b>Destination</b><br>${this.Destination}`);
//   //         }
//   //         return null; // No marker for midpoints
//   //       },
//   //       // @ts-ignore
//   //       formatter: new L.Routing.Formatter({
//   //         formatInstruction: (text) => {
//   //           if (
//   //             text.startsWith('Continue onto') ||
//   //             text.startsWith('Exit the traffic circle') ||
//   //             text.startsWith('Enter the traffic circle')
//   //           ) return '';
//   //           return text;
//   //         }
//   //       })
//   //     }).addTo(this.mapLiveTracking);

//   //     // Fit all in view
//   //     const bounds = L.latLngBounds([originCoords, liveTrackCoords, destCoords]);
//   //     this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });

//   //     // Refresh map
//   //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//   //     setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
//   //   } catch (error) {
//   //     console.error('Error in showLiveTrackVehicle:', error);
//   //   }
//   // }

//   InitialLoad: boolean = true;
//   async showLiveTrackVehicle(): Promise<void> {
//     try {
//       const that = MapDetailsCardComponent.that;
//       const defaultCoords: L.LatLngTuple = [20.5937, 78.9629, 0]; // India center

//       const isValidCoord = (lat: any, lng: any) =>
//         !isNaN(parseFloat(lat)) &&
//         !isNaN(parseFloat(lng)) &&
//         parseFloat(lat) !== 0 &&
//         parseFloat(lng) !== 0;

//       const hasValidLiveCoords = isValidCoord(this.LiveTrackLatitude, this.LiveTrackLongtitude);
//       const hasValidOrigin = isValidCoord(this.PickUpLatitude, this.PickUpLongtitude);
//       const hasValidDestination = isValidCoord(this.DeliverLatitude, this.DeliverLongtitude);

//       const liveTrackCoords: L.LatLngTuple = hasValidLiveCoords
//         ? [parseFloat(this.LiveTrackLatitude), parseFloat(this.LiveTrackLongtitude), 0]
//         : defaultCoords;

//       const originCoords: L.LatLngTuple = hasValidOrigin
//         ? [parseFloat(this.PickUpLatitude), parseFloat(this.PickUpLongtitude), 0]
//         : defaultCoords;

//       const destCoords: L.LatLngTuple = hasValidDestination
//         ? [parseFloat(this.DeliverLatitude), parseFloat(this.DeliverLongtitude), 0]
//         : defaultCoords;

//       const radius = Number(this.mapRadius);

//       // Initialize map only once
//       if (!this.mapLiveTracking) {
//         this.mapLiveTracking = L.map('LiveTrackingMap').setView(defaultCoords, 5);
//         L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
//           attribution: '&copy; OpenStreetMap contributors'
//         }).addTo(this.mapLiveTracking);
//         this.mapLayerGroupLiveTracking = L.layerGroup().addTo(this.mapLiveTracking);
//       }

//       if (!this.mapLiveTracking.hasLayer(this.mapLayerGroupLiveTracking)) {
//         this.mapLayerGroupLiveTracking.addTo(this.mapLiveTracking);
//       }

//       // Exit early if any coordinates are invalid
//       if (!hasValidLiveCoords || !hasValidOrigin || !hasValidDestination) {
//         this.mapLiveTracking.setView(defaultCoords, 5);
//         setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//         setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);
//         return;
//       }

//       const originIcon = this.originIcon;
//       const destinationIcon = this.destinationIcon;

//       // Add origin marker & circle if not already added
//       if (!this.originMarker) {
//         this.originMarker = L.marker(originCoords, { icon: originIcon }).bindPopup(`<b>Origin:</b><br>${that.Origin}`);
//         this.originCircle = L.circle(originCoords, {
//           radius: this.mapRadius,
//           color: '#00bfff',
//           fillColor: '#00bfff',
//           fillOpacity: 0.2,
//           weight: 1
//         });
//         this.mapLayerGroupLiveTracking.addLayer(this.originMarker).addLayer(this.originCircle);
//       }

//       // Add destination marker & circle if not already added
//       if (!this.destMarker) {
//         this.destMarker = L.marker(destCoords, { icon: destinationIcon }).bindPopup(`<b>Destination:</b><br>${that.Destination}`);
//         this.destCircle = L.circle(destCoords, {
//           radius: this.mapRadius,
//           color: '#ff5733',
//           fillColor: '#ff5733',
//           fillOpacity: 0.2,
//           weight: 1
//         });
//         this.mapLayerGroupLiveTracking.addLayer(this.destMarker).addLayer(this.destCircle);
//       }

//       // Update or create vehicle marker
//       const bearing = this.getBearing(this.PrevLiveTrackLatitude, this.PrevLiveTrackLongtitude, this.LiveTrackLatitude, this.LiveTrackLongtitude);
//       const vehicleIcon = this.getRotatedIcon(bearing);

//       if (!this.vehicleMarker) {
//         this.vehicleMarker = L.marker(liveTrackCoords, {
//           icon: vehicleIcon
//         }).bindPopup(`
//           <table>
//             <tr><td><b>Vehicle No</b></td><td>${that.VehicleNo}</td></tr>
//             <tr><td><b>Driver Name</b></td><td>${that.Driver}</td></tr>
//             <tr><td><b>Driver Mobile</b></td><td>${that.DriverMobileNo}</td></tr>
//             <tr><td><b>Track Through</b></td><td>Sim</td></tr>
//             <tr><td><b>Last Track</b></td><td>${that.LastTrackDate}</td></tr>
//           </table>`);
//         this.mapLayerGroupLiveTracking.addLayer(this.vehicleMarker);
//       } else {
//         this.vehicleMarker.setLatLng(liveTrackCoords);
//         this.vehicleMarker.setIcon(vehicleIcon);
//       }

//       // Add routing control only once
//       if (!this.routingControl) {
//         // @ts-ignore
//         this.routingControl = L.Routing.control({
//           waypoints: [
//             L.latLng(originCoords),
//             L.latLng(liveTrackCoords),
//             L.latLng(destCoords)
//           ],
//           routeWhileDragging: false,
//           addWaypoints: false,
//           draggableWaypoints: false,
//           show: true,
//           lineOptions: {
//             styles: [{ color: '#3b67fb', weight: 4, opacity: 0.8 }]
//           },
//           createMarker: (i, wp, n) => {
//             if (i === 0) {
//               return L.marker(wp.latLng, { icon: originIcon }).bindPopup(`<b>Origin</b><br>${that.Origin}`);
//             }
//             if (i === n - 1) {
//               return L.marker(wp.latLng, { icon: destinationIcon }).bindPopup(`<b>Destination</b><br>${that.Destination}`);
//             }
//             return L.marker(wp.latLng, {
//               icon: L.divIcon({ className: 'empty-marker' }),
//               interactive: false
//             });
//           },
//           // @ts-ignore
//           formatter: L.Routing.Formatter ? new L.Routing.Formatter({
//             formatInstruction: (text: string) => {
//               if (
//                 text.startsWith('Continue onto') ||
//                 text.startsWith('Exit the traffic circle') ||
//                 text.startsWith('Enter the traffic circle')
//               ) return '';
//               return text;
//             }
//           }) : undefined
//         }).addTo(this.mapLiveTracking);
//       }

//       // Adjust view
//       if (this.InitialLoad == true) {
//         const bounds = L.latLngBounds([originCoords, liveTrackCoords, destCoords]);
//         this.mapLiveTracking.fitBounds(bounds, { padding: [50, 50] });
//       }

//       setTimeout(() => this.mapLiveTracking.invalidateSize(), 200);
//       setTimeout(() => this.mapLiveTracking.invalidateSize(), 1000);

//       if (this.InitialLoad == true) {
//         this.InitialLoad = false;
//       }

//     } catch (error) {
//       console.error('Error in showLiveTrackVehicle:', error);
//     }
//   }


//   getBearing(lat1: number, lng1: number, lat2: number, lng2: number): number {
//     const toRad = (deg: number) => deg * Math.PI / 180;
//     const toDeg = (rad: number) => rad * 180 / Math.PI;

//     const dLng = toRad(lng2 - lng1);
//     const y = Math.sin(dLng) * Math.cos(toRad(lat2));
//     const x = Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
//       Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLng);

//     const bearing = toDeg(Math.atan2(y, x));
//     return (bearing + 360) % 360; // Normalize to 0–360
//   }

//   getRotatedIcon(angle: number): L.DivIcon {
//     var svg = '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="42" transform="rotate(' + this.VehicleDirectionDegree + ')" viewBox="0, 0, 400,711.5311909262759"><g id="svgg"><path id="path0" d="M125.900 48.699 C 128.375 48.769,132.425 48.769,134.900 48.699 C 137.375 48.628,135.350 48.571,130.400 48.571 C 125.450 48.571,123.425 48.628,125.900 48.699 M178.532 48.700 C 197.634 48.757,228.774 48.757,247.732 48.700 C 266.689 48.643,251.060 48.596,213.000 48.596 C 174.940 48.596,159.429 48.643,178.532 48.700 M118.800 49.200 C 118.800 49.420,119.070 49.600,119.400 49.600 C 119.730 49.600,120.000 49.420,120.000 49.200 C 120.000 48.980,119.730 48.800,119.400 48.800 C 119.070 48.800,118.800 48.980,118.800 49.200 M140.600 49.200 C 140.736 49.420,141.107 49.600,141.424 49.600 C 141.741 49.600,142.000 49.420,142.000 49.200 C 142.000 48.980,141.629 48.800,141.176 48.800 C 140.723 48.800,140.464 48.980,140.600 49.200 M106.153 51.303 C 105.739 51.789,105.670 51.988,106.000 51.747 C 106.330 51.505,106.861 51.226,107.180 51.127 C 107.552 51.011,107.607 50.852,107.334 50.683 C 107.099 50.538,106.568 50.817,106.153 51.303 M120.200 51.176 C 112.914 51.891,109.863 54.742,109.817 60.879 C 109.796 63.633,109.878 63.980,110.597 64.173 C 111.935 64.533,149.340 64.369,150.200 64.000 C 150.640 63.811,150.758 63.644,150.462 63.628 C 150.048 63.606,149.989 63.135,150.205 61.565 C 150.816 57.121,148.014 52.809,143.775 51.669 C 141.434 51.039,125.077 50.697,120.200 51.176 M257.724 51.227 C 249.861 51.832,246.731 54.556,246.643 60.870 C 246.604 63.640,246.683 63.981,247.400 64.174 C 248.630 64.505,286.146 64.428,286.600 64.094 C 286.820 63.932,287.061 62.618,287.136 61.172 C 287.606 52.057,280.068 49.508,257.724 51.227 M303.396 153.000 C 303.396 201.620,303.443 221.569,303.500 197.332 C 303.557 173.095,303.557 133.315,303.500 108.932 C 303.443 84.549,303.396 104.380,303.396 153.000 M106.943 71.997 C 104.732 72.889,104.800 71.997,104.800 99.929 L 104.800 125.679 106.042 126.840 L 107.285 128.000 198.223 128.000 C 262.758 128.000,289.439 127.874,290.115 127.566 C 292.458 126.498,292.400 127.208,292.400 99.598 L 292.400 74.320 291.040 72.960 L 289.680 71.600 198.740 71.625 C 148.587 71.639,107.416 71.806,106.943 71.997 M290.618 73.382 L 291.600 74.364 291.600 99.800 L 291.600 125.236 290.618 126.218 L 289.636 127.200 198.400 127.200 L 107.164 127.200 106.182 126.218 L 105.200 125.236 105.200 99.800 L 105.200 74.364 106.182 73.382 L 107.164 72.400 198.400 72.400 L 289.636 72.400 290.618 73.382 M130.267 177.467 C 130.120 177.613,130.000 192.464,130.000 210.468 L 130.000 243.202 198.500 243.101 L 267.000 243.000 267.102 210.425 C 267.183 184.630,267.100 177.784,266.702 177.531 C 266.099 177.148,130.649 177.084,130.267 177.467 M318.813 242.071 C 318.806 242.221,319.075 242.617,319.410 242.953 C 319.923 243.466,320.023 245.151,320.036 253.581 C 320.046 259.513,320.205 263.600,320.426 263.600 C 320.648 263.600,320.800 259.616,320.800 253.822 L 320.800 244.045 319.813 242.922 C 319.270 242.305,318.820 241.922,318.813 242.071 M106.600 263.588 C 112.760 263.704,118.025 263.946,118.300 264.124 C 119.223 264.721,118.980 273.475,118.026 273.986 C 117.548 274.242,113.137 274.400,106.469 274.400 C 96.990 274.400,95.656 274.477,95.442 275.035 C 95.308 275.384,95.200 364.878,95.201 473.910 C 95.202 607.095,95.070 672.233,94.799 672.401 C 94.567 672.544,94.824 673.024,95.400 673.525 L 96.406 674.400 198.803 674.400 C 266.801 674.400,301.200 674.266,301.200 674.000 C 301.200 673.734,266.733 673.600,198.600 673.600 C 130.467 673.600,96.000 673.466,96.000 673.200 C 96.000 672.934,130.467 672.800,198.600 672.800 L 301.200 672.800 301.200 473.600 L 301.200 274.400 290.300 274.394 C 284.305 274.391,279.163 274.238,278.874 274.054 C 278.307 273.695,278.047 264.620,278.587 264.079 C 278.740 263.925,283.936 263.704,290.133 263.588 C 296.330 263.471,255.050 263.375,198.400 263.375 C 141.750 263.375,100.440 263.471,106.600 263.588 M303.398 473.400 C 303.398 582.520,303.444 627.100,303.500 572.467 C 303.556 517.834,303.556 428.554,303.500 374.067 C 303.444 319.580,303.398 364.280,303.398 473.400 " stroke="none" fill="#6f6f77" fill-rule="evenodd"></path><path id="path1" d="M114.124 48.573 C 113.862 48.871,113.757 49.224,113.891 49.357 C 114.024 49.491,113.923 49.600,113.667 49.600 C 113.410 49.600,113.197 49.375,113.194 49.100 C 113.190 48.761,113.051 48.793,112.763 49.200 C 112.444 49.652,112.289 49.676,112.136 49.300 C 111.890 48.693,110.800 48.630,110.800 49.224 C 110.800 49.457,110.620 49.536,110.400 49.400 C 110.180 49.264,110.000 49.354,110.000 49.600 C 110.000 49.846,109.820 49.936,109.600 49.800 C 109.380 49.664,109.200 49.743,109.200 49.976 C 109.200 50.209,108.739 50.400,108.176 50.400 C 107.613 50.400,107.238 50.538,107.342 50.707 C 107.446 50.875,107.097 51.218,106.565 51.469 C 106.034 51.720,105.699 51.764,105.820 51.567 C 105.942 51.370,105.762 51.316,105.421 51.447 C 105.079 51.578,104.800 51.857,104.800 52.066 C 104.800 52.276,104.639 52.348,104.442 52.226 C 104.245 52.104,103.981 52.274,103.854 52.602 C 103.728 52.931,103.322 53.200,102.952 53.200 C 102.275 53.200,98.800 56.579,98.800 57.237 C 98.800 57.561,98.047 58.595,96.975 59.745 C 96.742 59.995,96.301 60.766,95.997 61.457 C 95.671 62.195,95.229 62.632,94.925 62.516 C 94.640 62.406,94.302 62.651,94.174 63.058 C 94.046 63.466,93.775 64.113,93.571 64.495 C 93.346 64.915,93.200 99.988,93.200 153.395 L 93.200 241.600 85.658 241.600 C 78.208 241.600,78.104 241.612,77.058 242.581 L 76.000 243.562 76.000 253.781 C 76.000 263.052,76.062 264.000,76.667 264.000 C 77.033 264.000,77.216 264.117,77.073 264.260 C 76.113 265.220,78.528 265.575,86.100 265.587 L 94.000 265.600 94.000 469.000 C 94.000 649.533,94.067 672.400,94.600 672.400 C 95.027 672.400,95.200 671.966,95.201 670.900 C 95.201 670.075,95.201 580.811,95.200 472.535 C 95.199 364.259,95.308 275.384,95.442 275.035 C 95.656 274.477,96.990 274.400,106.469 274.400 C 113.137 274.400,117.548 274.242,118.026 273.986 C 119.203 273.356,119.203 264.644,118.026 264.014 C 117.524 263.745,110.538 263.600,98.103 263.600 C 83.412 263.600,78.794 263.484,78.269 263.100 C 77.651 262.648,77.595 261.671,77.693 253.000 L 77.800 243.400 86.600 243.200 L 95.400 243.000 95.600 153.400 L 95.800 63.800 102.841 63.691 L 109.882 63.582 109.850 60.691 C 109.796 55.765,112.177 52.850,117.325 51.540 C 120.370 50.764,140.153 50.792,143.352 51.576 C 147.966 52.707,150.846 56.904,150.205 61.565 L 149.925 63.600 198.336 63.600 L 246.748 63.600 246.701 60.700 C 246.600 54.442,249.780 51.877,258.476 51.201 C 280.214 49.511,287.999 52.250,287.057 61.260 L 286.812 63.600 293.506 63.606 C 297.188 63.609,300.425 63.755,300.699 63.929 C 301.095 64.181,301.219 82.730,301.299 153.623 L 301.400 243.000 310.200 243.200 L 319.000 243.400 319.107 253.172 C 319.190 260.723,319.099 263.017,318.707 263.266 C 318.428 263.443,309.470 263.593,298.800 263.600 C 288.130 263.607,279.155 263.768,278.855 263.958 C 278.088 264.443,278.105 273.567,278.874 274.054 C 279.163 274.238,284.305 274.391,290.300 274.394 L 301.200 274.400 301.200 473.600 L 301.200 672.800 198.600 672.800 C 130.467 672.800,96.000 672.934,96.000 673.200 C 96.000 673.868,301.613 673.717,302.494 673.048 C 302.875 672.758,303.070 672.404,302.927 672.260 C 302.784 672.117,302.832 672.000,303.033 672.000 C 303.403 672.000,303.384 275.389,303.014 274.335 C 302.911 274.041,302.776 271.955,302.713 269.699 L 302.600 265.598 310.500 265.599 C 314.845 265.600,318.510 265.611,318.645 265.623 C 320.142 265.767,320.859 244.402,319.406 242.949 C 319.069 242.612,318.893 242.174,319.015 241.976 C 319.142 241.770,315.867 241.571,311.318 241.509 L 303.400 241.400 303.304 152.626 L 303.209 63.851 301.804 62.526 C 301.032 61.798,300.400 60.944,300.400 60.630 C 300.400 60.315,299.945 59.700,299.389 59.263 C 298.833 58.825,298.428 58.293,298.489 58.081 C 298.618 57.631,294.208 53.237,293.486 53.095 C 293.219 53.043,292.695 52.668,292.321 52.263 C 291.948 51.858,291.472 51.632,291.263 51.761 C 291.055 51.890,290.776 51.715,290.645 51.372 C 290.513 51.030,290.215 50.867,289.982 51.011 C 289.748 51.156,289.197 50.858,288.756 50.350 C 288.084 49.575,287.895 49.520,287.584 50.013 C 287.332 50.411,287.210 50.439,287.206 50.100 C 287.203 49.825,286.840 49.600,286.400 49.600 C 285.960 49.600,285.597 49.375,285.594 49.100 C 285.590 48.766,285.457 48.799,285.194 49.200 C 284.947 49.576,284.688 49.651,284.500 49.400 C 284.027 48.769,286.570 48.791,213.325 48.798 C 158.215 48.803,143.347 48.909,142.862 49.302 C 142.370 49.700,142.307 49.699,142.547 49.300 C 142.712 49.025,142.672 48.800,142.457 48.800 C 142.242 48.800,141.985 49.025,141.886 49.300 C 141.742 49.695,141.531 49.698,140.879 49.313 C 139.720 48.630,121.207 48.542,120.789 49.218 C 120.572 49.568,120.441 49.550,120.280 49.145 C 120.126 48.758,120.054 48.745,120.032 49.100 C 119.997 49.646,118.800 49.808,118.800 49.267 C 118.800 48.900,118.092 48.782,116.067 48.811 C 115.245 48.822,114.833 48.671,114.991 48.415 C 115.364 47.812,114.683 47.935,114.124 48.573 M106.182 73.382 L 105.200 74.364 105.200 99.800 L 105.200 125.236 106.182 126.218 L 107.164 127.200 198.400 127.200 L 289.636 127.200 290.618 126.218 L 291.600 125.236 291.600 99.800 L 291.600 74.364 290.618 73.382 L 289.636 72.400 198.400 72.400 L 107.164 72.400 106.182 73.382 " stroke="none" fill="#c9dbe2" fill-rule="evenodd"></path><path id="path2" d="M95.786 64.100 C 95.682 64.375,95.553 104.740,95.498 153.800 L 95.400 243.000 86.600 243.200 L 77.800 243.400 77.693 252.973 C 77.634 258.238,77.724 262.684,77.893 262.853 C 78.062 263.023,78.149 258.910,78.086 253.715 C 78.023 248.520,78.124 244.116,78.311 243.929 C 78.498 243.742,89.886 243.490,103.618 243.369 C 122.220 243.204,128.662 243.027,128.886 242.674 C 129.052 242.413,129.191 227.485,129.194 209.500 L 129.200 176.800 130.500 176.797 C 196.402 176.624,267.407 176.886,267.672 177.303 C 267.846 177.577,267.991 192.515,267.994 210.500 C 267.999 236.400,268.104 243.196,268.500 243.182 C 273.075 243.017,318.249 243.689,318.486 243.926 C 318.667 244.107,318.767 248.473,318.708 253.628 L 318.600 263.000 309.800 263.212 L 301.000 263.424 309.600 263.506 C 314.330 263.551,318.428 263.443,318.707 263.266 C 319.099 263.017,319.190 260.723,319.107 253.172 L 319.000 243.400 310.200 243.200 L 301.400 243.000 301.299 153.623 C 301.219 82.730,301.095 64.181,300.699 63.929 C 299.949 63.453,287.200 63.519,287.200 64.000 C 287.200 64.251,289.733 64.400,294.000 64.400 L 300.800 64.400 300.800 100.001 L 300.800 135.602 198.500 135.501 L 96.200 135.400 96.086 101.200 C 96.024 82.390,96.077 66.415,96.204 65.700 L 96.436 64.400 103.242 64.400 C 107.677 64.400,109.961 64.261,109.800 64.000 C 109.413 63.374,96.024 63.470,95.786 64.100 M150.400 64.000 C 150.011 64.252,166.848 64.390,198.324 64.394 C 230.572 64.398,246.764 64.266,246.600 64.000 C 246.266 63.459,151.237 63.459,150.400 64.000 M82.900 263.498 C 85.265 263.569,89.135 263.569,91.500 263.498 C 93.865 263.428,91.930 263.370,87.200 263.370 C 82.470 263.370,80.535 263.428,82.900 263.498 " stroke="none" fill="#1e94db" fill-rule="evenodd"></path><path id="path3" d="M103.316 64.309 L 96.433 64.419 96.203 65.709 C 96.076 66.419,96.024 82.390,96.086 101.200 L 96.200 135.400 198.500 135.501 L 300.800 135.602 300.800 100.001 L 300.800 64.400 293.900 64.397 C 290.105 64.396,247.220 64.351,198.600 64.297 C 149.980 64.244,107.102 64.249,103.316 64.309 M291.947 70.360 C 294.861 72.439,294.782 71.624,294.782 99.800 C 294.782 127.817,294.841 127.177,292.085 129.140 L 290.877 130.000 198.612 130.000 C 129.520 130.000,106.128 129.884,105.474 129.537 C 102.228 127.818,102.343 129.002,102.482 98.722 L 102.600 72.844 103.990 71.410 C 106.152 69.180,102.277 69.265,199.200 69.334 L 290.600 69.400 291.947 70.360 M130.500 176.725 L 129.200 176.851 129.194 209.525 C 129.191 227.496,129.052 242.413,128.886 242.674 C 128.662 243.027,122.220 243.204,103.618 243.369 C 89.886 243.490,78.501 243.739,78.318 243.922 C 78.135 244.105,78.033 248.473,78.092 253.628 L 78.200 263.000 198.400 263.000 L 318.600 263.000 318.708 253.628 C 318.767 248.473,318.667 244.107,318.486 243.926 C 318.249 243.689,273.075 243.017,268.500 243.182 C 268.104 243.196,267.999 236.400,267.994 210.500 C 267.991 192.515,267.846 177.577,267.672 177.303 C 267.386 176.852,134.970 176.294,130.500 176.725 M266.702 177.531 C 267.100 177.784,267.183 184.630,267.102 210.425 L 267.000 243.000 198.500 243.101 L 130.000 243.202 130.000 210.468 C 130.000 192.464,130.120 177.613,130.267 177.467 C 130.649 177.084,266.099 177.148,266.702 177.531 " stroke="none" fill="#156b9f" fill-rule="evenodd"></path><path id="path4" d="M125.900 48.299 C 128.375 48.369,132.425 48.369,134.900 48.299 C 137.375 48.228,135.350 48.171,130.400 48.171 C 125.450 48.171,123.425 48.228,125.900 48.299 M169.400 48.297 C 235.281 48.570,282.400 48.571,282.400 48.300 C 282.400 48.135,251.395 48.044,213.500 48.097 C 175.605 48.150,155.760 48.240,169.400 48.297 M106.590 69.622 C 105.924 69.817,104.754 70.621,103.990 71.410 L 102.600 72.844 102.482 98.722 C 102.343 129.002,102.228 127.818,105.474 129.537 C 106.128 129.884,129.520 130.000,198.612 130.000 L 290.877 130.000 292.085 129.140 C 294.841 127.177,294.782 127.817,294.782 99.800 C 294.782 71.624,294.861 72.439,291.947 70.360 L 290.600 69.400 199.200 69.334 C 147.182 69.297,107.279 69.421,106.590 69.622 M291.040 72.960 L 292.400 74.320 292.400 99.598 C 292.400 127.208,292.458 126.498,290.115 127.566 C 289.439 127.874,262.758 128.000,198.223 128.000 L 107.285 128.000 106.042 126.840 L 104.800 125.679 104.800 99.929 C 104.800 71.997,104.732 72.889,106.943 71.997 C 107.416 71.806,148.587 71.639,198.740 71.625 L 289.680 71.600 291.040 72.960 " stroke="none" fill="#0a0e10" fill-rule="evenodd"></path></g></svg>';

//     return L.divIcon({
//       className: 'vehicle-icon',
//       html: `
//         <div style="
//           width: 42px;
//           height: 42px;
//           transform: rotate(${angle}deg);
//           transform-origin: center center;
//         ">
//           ${svg}
//         </div>
//       `,
//       iconSize: [42, 42],
//       iconAnchor: [21, 21]
//     });
//   }

// }
